Highcharts.maps["custom/asia"] = {
    "title": "Asia",
    "version": "1.1.2",
    "type": "FeatureCollection",
    "copyright": "Copyright (c) 2015 Highsoft AS, Based on data from Natural Earth",
    "copyrightShort": "Natural Earth",
    "copyrightUrl": "http://www.naturalearthdata.com",
    "crs": {
        "type": "name",
        "properties": {
            "name": "urn:ogc:def:crs:EPSG:54003"
        }
    },
    "hc-transform": {
        "default": {
            "rotation": -0.0349065850399,
            "crs": "+proj=mill +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R_A +datum=WGS84 +units=m +no_defs",
            "scale": 4.12393763639e-05,
            "jsonres": 15.5,
            "jsonmarginX": -999,
            "jsonmarginY": 9851.0,
            "xoffset": 2731935.60103,
            "yoffset": 12366575.4662
        }
    },
    "features": [{
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.560000,
            "hc-middl_1": 0.520000,
            "hc-key": "ir",
            "hc-a2": "IR",
            "name": "Iran",
            "labelrank": "2",
            "country-ab": "Iran",
            "subregion": "Southern Asia",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "IRN",
            "iso-a2": "IR",
            "woe-id": "23424851",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [1158.0, 4014.0],
                        [1116.0, 4002.0],
                        [1119.0, 4010.0],
                        [1177.0, 4039.0],
                        [1158.0, 4014.0]
                    ]
                ],
                [
                    [
                        [431.0, 4952.0],
                        [449.0, 4958.0],
                        [458.0, 4955.0],
                        [482.0, 4979.0],
                        [550.0, 5024.0],
                        [586.0, 5000.0],
                        [585.0, 4972.0],
                        [564.0, 4953.0],
                        [608.0, 4920.0],
                        [627.0, 4923.0],
                        [647.0, 4857.0],
                        [720.0, 4842.0],
                        [745.0, 4813.0],
                        [789.0, 4790.0],
                        [848.0, 4780.0],
                        [959.0, 4808.0],
                        [996.0, 4804.0],
                        [988.0, 4846.0],
                        [1049.0, 4863.0],
                        [1054.0, 4883.0],
                        [1093.0, 4910.0],
                        [1155.0, 4913.0],
                        [1164.0, 4927.0],
                        [1220.0, 4930.0],
                        [1230.0, 4906.0],
                        [1334.0, 4887.0],
                        [1374.0, 4872.0],
                        [1375.0, 4858.0],
                        [1422.0, 4836.0],
                        [1446.0, 4805.0],
                        [1499.0, 4808.0],
                        [1515.0, 4725.0],
                        [1503.0, 4660.0],
                        [1478.0, 4635.0],
                        [1492.0, 4620.0],
                        [1464.0, 4601.0],
                        [1467.0, 4565.0],
                        [1493.0, 4558.0],
                        [1472.0, 4526.0],
                        [1493.0, 4456.0],
                        [1495.0, 4397.0],
                        [1555.0, 4390.0],
                        [1565.0, 4347.0],
                        [1501.0, 4269.0],
                        [1533.0, 4236.0],
                        [1579.0, 4171.0],
                        [1640.0, 4151.0],
                        [1647.0, 4072.0],
                        [1684.0, 4065.0],
                        [1673.0, 4027.0],
                        [1645.0, 4028.0],
                        [1582.0, 3995.0],
                        [1566.0, 3916.0],
                        [1554.0, 3905.0],
                        [1498.0, 3919.0],
                        [1492.0, 3932.0],
                        [1446.0, 3922.0],
                        [1368.0, 3936.0],
                        [1322.0, 3933.0],
                        [1262.0, 3949.0],
                        [1238.0, 4029.0],
                        [1221.0, 4051.0],
                        [1189.0, 4054.0],
                        [1142.0, 4038.0],
                        [1081.0, 3997.0],
                        [1045.0, 4012.0],
                        [1003.0, 4010.0],
                        [981.0, 4031.0],
                        [920.0, 4060.0],
                        [909.0, 4079.0],
                        [834.0, 4102.0],
                        [809.0, 4159.0],
                        [778.0, 4189.0],
                        [778.0, 4213.0],
                        [741.0, 4249.0],
                        [735.0, 4269.0],
                        [702.0, 4255.0],
                        [654.0, 4282.0],
                        [654.0, 4257.0],
                        [626.0, 4247.0],
                        [588.0, 4285.0],
                        [587.0, 4324.0],
                        [562.0, 4325.0],
                        [571.0, 4385.0],
                        [535.0, 4439.0],
                        [519.0, 4438.0],
                        [457.0, 4476.0],
                        [428.0, 4528.0],
                        [391.0, 4554.0],
                        [392.0, 4591.0],
                        [426.0, 4644.0],
                        [444.0, 4655.0],
                        [428.0, 4677.0],
                        [450.0, 4705.0],
                        [384.0, 4714.0],
                        [374.0, 4748.0],
                        [356.0, 4758.0],
                        [339.0, 4807.0],
                        [325.0, 4854.0],
                        [298.0, 4874.0],
                        [299.0, 4946.0],
                        [282.0, 4991.0],
                        [306.0, 4995.0],
                        [317.0, 5023.0],
                        [334.0, 5013.0],
                        [381.0, 4962.0],
                        [431.0, 4952.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.360000,
            "hc-middl_1": 0.100000,
            "hc-key": "ph",
            "hc-a2": "PH",
            "name": "Philippines",
            "labelrank": "2",
            "country-ab": "Phil.",
            "subregion": "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "PHL",
            "iso-a2": "PH",
            "woe-id": "23424934",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [5753.0, 2601.0],
                        [5752.0, 2605.0],
                        [5780.0, 2622.0],
                        [5774.0, 2613.0],
                        [5753.0, 2601.0]
                    ]
                ],
                [
                    [
                        [5852.0, 2657.0],
                        [5831.0, 2662.0],
                        [5838.0, 2677.0],
                        [5865.0, 2670.0],
                        [5852.0, 2657.0]
                    ]
                ],
                [
                    [
                        [5909.0, 2702.0],
                        [5891.0, 2714.0],
                        [5909.0, 2725.0],
                        [5928.0, 2716.0],
                        [5909.0, 2702.0]
                    ]
                ],
                [
                    [
                        [6179.0, 2949.0],
                        [6176.0, 2948.0],
                        [6186.0, 2971.0],
                        [6193.0, 2952.0],
                        [6179.0, 2949.0]
                    ]
                ],
                [
                    [
                        [6076.0, 2968.0],
                        [6060.0, 2934.0],
                        [6025.0, 2947.0],
                        [6051.0, 2972.0],
                        [6076.0, 2968.0]
                    ]
                ],
                [
                    [
                        [6157.0, 2994.0],
                        [6160.0, 2957.0],
                        [6144.0, 2973.0],
                        [6146.0, 2988.0],
                        [6157.0, 2994.0]
                    ]
                ],
                [
                    [
                        [5946.0, 3000.0],
                        [5940.0, 2990.0],
                        [5929.0, 2994.0],
                        [5942.0, 3013.0],
                        [5946.0, 3000.0]
                    ]
                ],
                [
                    [
                        [5984.0, 3030.0],
                        [6006.0, 3020.0],
                        [5979.0, 2950.0],
                        [5992.0, 2913.0],
                        [5972.0, 2891.0],
                        [5940.0, 2918.0],
                        [5925.0, 2946.0],
                        [5958.0, 2967.0],
                        [5953.0, 2997.0],
                        [5965.0, 3024.0],
                        [5984.0, 3030.0]
                    ]
                ],
                [
                    [
                        [6035.0, 3039.0],
                        [6035.0, 2985.0],
                        [5991.0, 2925.0],
                        [5997.0, 2963.0],
                        [6035.0, 3039.0]
                    ]
                ],
                [
                    [
                        [5913.0, 3083.0],
                        [5976.0, 3064.0],
                        [5974.0, 3044.0],
                        [5936.0, 3008.0],
                        [5891.0, 2987.0],
                        [5900.0, 3075.0],
                        [5913.0, 3083.0]
                    ]
                ],
                [
                    [
                        [5751.0, 3089.0],
                        [5740.0, 3117.0],
                        [5774.0, 3100.0],
                        [5769.0, 3082.0],
                        [5751.0, 3089.0]
                    ]
                ],
                [
                    [
                        [6016.0, 3130.0],
                        [6038.0, 3085.0],
                        [5992.0, 3117.0],
                        [5975.0, 3098.0],
                        [5978.0, 3145.0],
                        [6016.0, 3130.0]
                    ]
                ],
                [
                    [
                        [5901.0, 3145.0],
                        [5892.0, 3111.0],
                        [5885.0, 3121.0],
                        [5891.0, 3143.0],
                        [5901.0, 3145.0]
                    ]
                ],
                [
                    [
                        [5826.0, 3115.0],
                        [5800.0, 3168.0],
                        [5771.0, 3204.0],
                        [5830.0, 3201.0],
                        [5856.0, 3177.0],
                        [5857.0, 3145.0],
                        [5826.0, 3115.0]
                    ]
                ],
                [
                    [
                        [5879.0, 3211.0],
                        [5896.0, 3205.0],
                        [5888.0, 3186.0],
                        [5875.0, 3195.0],
                        [5879.0, 3211.0]
                    ]
                ],
                [
                    [
                        [6045.0, 3254.0],
                        [6058.0, 3240.0],
                        [6053.0, 3218.0],
                        [6031.0, 3224.0],
                        [6045.0, 3254.0]
                    ]
                ],
                [
                    [
                        [5881.0, 3319.0],
                        [5886.0, 3296.0],
                        [5880.0, 3289.0],
                        [5872.0, 3318.0],
                        [5881.0, 3319.0]
                    ]
                ],
                [
                    [
                        [6121.0, 3008.0],
                        [6131.0, 2960.0],
                        [6109.0, 2992.0],
                        [6111.0, 2966.0],
                        [6093.0, 2974.0],
                        [6091.0, 3022.0],
                        [6064.0, 3029.0],
                        [6068.0, 3068.0],
                        [6105.0, 3063.0],
                        [6094.0, 3074.0],
                        [6097.0, 3090.0],
                        [6060.0, 3121.0],
                        [6051.0, 3143.0],
                        [6115.0, 3149.0],
                        [6139.0, 3126.0],
                        [6146.0, 3056.0],
                        [6124.0, 3043.0],
                        [6105.0, 3063.0],
                        [6108.0, 3021.0],
                        [6121.0, 3008.0]
                    ]
                ],
                [
                    [
                        [6051.0, 2709.0],
                        [6047.0, 2757.0],
                        [6062.0, 2778.0],
                        [6023.0, 2805.0],
                        [5985.0, 2781.0],
                        [5981.0, 2799.0],
                        [5961.0, 2766.0],
                        [5960.0, 2798.0],
                        [5938.0, 2794.0],
                        [5912.0, 2736.0],
                        [5899.0, 2742.0],
                        [5911.0, 2802.0],
                        [5922.0, 2816.0],
                        [5966.0, 2827.0],
                        [5977.0, 2854.0],
                        [6025.0, 2862.0],
                        [6034.0, 2830.0],
                        [6059.0, 2835.0],
                        [6070.0, 2864.0],
                        [6095.0, 2857.0],
                        [6096.0, 2898.0],
                        [6120.0, 2881.0],
                        [6127.0, 2900.0],
                        [6149.0, 2896.0],
                        [6138.0, 2942.0],
                        [6177.0, 2930.0],
                        [6218.0, 2842.0],
                        [6214.0, 2814.0],
                        [6230.0, 2775.0],
                        [6206.0, 2738.0],
                        [6204.0, 2704.0],
                        [6194.0, 2742.0],
                        [6173.0, 2778.0],
                        [6172.0, 2745.0],
                        [6153.0, 2753.0],
                        [6146.0, 2723.0],
                        [6159.0, 2718.0],
                        [6167.0, 2678.0],
                        [6148.0, 2651.0],
                        [6124.0, 2670.0],
                        [6065.0, 2691.0],
                        [6051.0, 2709.0]
                    ]
                ],
                [
                    [
                        [5649.0, 2899.0],
                        [5616.0, 2868.0],
                        [5561.0, 2828.0],
                        [5590.0, 2879.0],
                        [5614.0, 2892.0],
                        [5670.0, 2963.0],
                        [5701.0, 2986.0],
                        [5696.0, 3017.0],
                        [5715.0, 3052.0],
                        [5721.0, 3034.0],
                        [5729.0, 2990.0],
                        [5697.0, 2954.0],
                        [5666.0, 2941.0],
                        [5649.0, 2899.0]
                    ]
                ],
                [
                    [
                        [5903.0, 3237.0],
                        [5919.0, 3269.0],
                        [5946.0, 3265.0],
                        [5963.0, 3244.0],
                        [6008.0, 3243.0],
                        [6027.0, 3229.0],
                        [5996.0, 3220.0],
                        [6036.0, 3196.0],
                        [6039.0, 3145.0],
                        [5982.0, 3175.0],
                        [5971.0, 3206.0],
                        [5924.0, 3242.0],
                        [5930.0, 3185.0],
                        [5910.0, 3215.0],
                        [5867.0, 3240.0],
                        [5846.0, 3217.0],
                        [5818.0, 3215.0],
                        [5808.0, 3234.0],
                        [5789.0, 3226.0],
                        [5784.0, 3252.0],
                        [5812.0, 3277.0],
                        [5781.0, 3300.0],
                        [5785.0, 3276.0],
                        [5748.0, 3296.0],
                        [5723.0, 3376.0],
                        [5737.0, 3400.0],
                        [5760.0, 3385.0],
                        [5759.0, 3440.0],
                        [5767.0, 3483.0],
                        [5759.0, 3496.0],
                        [5776.0, 3569.0],
                        [5811.0, 3578.0],
                        [5873.0, 3554.0],
                        [5890.0, 3571.0],
                        [5888.0, 3505.0],
                        [5916.0, 3468.0],
                        [5897.0, 3411.0],
                        [5851.0, 3382.0],
                        [5856.0, 3362.0],
                        [5839.0, 3336.0],
                        [5865.0, 3294.0],
                        [5867.0, 3257.0],
                        [5903.0, 3237.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.410000,
            "hc-middl_1": 0.480000,
            "hc-key": "sa",
            "hc-a2": "SA",
            "name": "Saudi Arabia",
            "labelrank": "2",
            "country-ab": "Saud.",
            "subregion": "Western Asia",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "SAU",
            "iso-a2": "SA",
            "woe-id": "23424938",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [198.0, 3244.0],
                        [195.0, 3237.0],
                        [179.0, 3253.0],
                        [191.0, 3258.0],
                        [198.0, 3244.0]
                    ]
                ],
                [
                    [
                        [831.0, 3847.0],
                        [836.0, 3823.0],
                        [857.0, 3820.0],
                        [859.0, 3807.0],
                        [932.0, 3724.0],
                        [1112.0, 3707.0],
                        [1118.0, 3713.0],
                        [1152.0, 3661.0],
                        [1110.0, 3513.0],
                        [900.0, 3432.0],
                        [698.0, 3397.0],
                        [631.0, 3360.0],
                        [592.0, 3309.0],
                        [581.0, 3282.0],
                        [549.0, 3271.0],
                        [530.0, 3293.0],
                        [439.0, 3293.0],
                        [420.0, 3301.0],
                        [319.0, 3291.0],
                        [293.0, 3302.0],
                        [278.0, 3288.0],
                        [282.0, 3248.0],
                        [254.0, 3218.0],
                        [249.0, 3240.0],
                        [219.0, 3275.0],
                        [216.0, 3295.0],
                        [174.0, 3327.0],
                        [135.0, 3383.0],
                        [114.0, 3442.0],
                        [83.0, 3475.0],
                        [20.0, 3509.0],
                        [-23.0, 3570.0],
                        [-33.0, 3615.0],
                        [-26.0, 3662.0],
                        [-74.0, 3752.0],
                        [-130.0, 3788.0],
                        [-141.0, 3786.0],
                        [-169.0, 3829.0],
                        [-164.0, 3855.0],
                        [-206.0, 3904.0],
                        [-239.0, 3961.0],
                        [-289.0, 4022.0],
                        [-315.0, 4067.0],
                        [-355.0, 4069.0],
                        [-337.0, 4166.0],
                        [-261.0, 4156.0],
                        [-229.0, 4181.0],
                        [-210.0, 4210.0],
                        [-160.0, 4222.0],
                        [-125.0, 4262.0],
                        [-200.0, 4337.0],
                        [-59.0, 4381.0],
                        [-47.0, 4392.0],
                        [41.0, 4381.0],
                        [164.0, 4318.0],
                        [355.0, 4179.0],
                        [486.0, 4175.0],
                        [551.0, 4170.0],
                        [568.0, 4135.0],
                        [623.0, 4137.0],
                        [656.0, 4084.0],
                        [683.0, 4063.0],
                        [690.0, 4037.0],
                        [749.0, 3999.0],
                        [752.0, 3928.0],
                        [775.0, 3907.0],
                        [802.0, 3855.0],
                        [814.0, 3842.0],
                        [831.0, 3847.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.590000,
            "hc-middl_1": 0.520000,
            "hc-key": "jp",
            "hc-a2": "JP",
            "name": "Japan",
            "labelrank": "2",
            "country-ab": "Japan",
            "subregion": "Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "JPN",
            "iso-a2": "JP",
            "woe-id": "23424856",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [6266.0, 4194.0],
                        [6297.0, 4190.0],
                        [6269.0, 4173.0],
                        [6276.0, 4181.0],
                        [6266.0, 4194.0]
                    ]
                ],
                [
                    [
                        [6366.0, 4310.0],
                        [6357.0, 4316.0],
                        [6395.0, 4336.0],
                        [6376.0, 4316.0],
                        [6366.0, 4310.0]
                    ]
                ],
                [
                    [
                        [6447.0, 4489.0],
                        [6460.0, 4483.0],
                        [6443.0, 4472.0],
                        [6439.0, 4483.0],
                        [6447.0, 4489.0]
                    ]
                ],
                [
                    [
                        [6485.0, 4498.0],
                        [6480.0, 4483.0],
                        [6472.0, 4490.0],
                        [6486.0, 4520.0],
                        [6485.0, 4498.0]
                    ]
                ],
                [
                    [
                        [6422.0, 4644.0],
                        [6421.0, 4639.0],
                        [6407.0, 4623.0],
                        [6408.0, 4649.0],
                        [6422.0, 4644.0]
                    ]
                ],
                [
                    [
                        [6341.0, 4704.0],
                        [6341.0, 4673.0],
                        [6327.0, 4656.0],
                        [6327.0, 4669.0],
                        [6341.0, 4704.0]
                    ]
                ],
                [
                    [
                        [6750.0, 4805.0],
                        [6737.0, 4793.0],
                        [6732.0, 4800.0],
                        [6754.0, 4826.0],
                        [6750.0, 4805.0]
                    ]
                ],
                [
                    [
                        [6354.0, 4787.0],
                        [6343.0, 4772.0],
                        [6352.0, 4816.0],
                        [6363.0, 4812.0],
                        [6354.0, 4787.0]
                    ]
                ],
                [
                    [
                        [6990.0, 5115.0],
                        [6994.0, 5101.0],
                        [6978.0, 5093.0],
                        [6980.0, 5123.0],
                        [6990.0, 5115.0]
                    ]
                ],
                [
                    [
                        [6394.0, 4662.0],
                        [6369.0, 4723.0],
                        [6390.0, 4714.0],
                        [6437.0, 4755.0],
                        [6474.0, 4766.0],
                        [6478.0, 4741.0],
                        [6526.0, 4737.0],
                        [6511.0, 4712.0],
                        [6539.0, 4712.0],
                        [6549.0, 4685.0],
                        [6525.0, 4654.0],
                        [6504.0, 4562.0],
                        [6457.0, 4531.0],
                        [6425.0, 4549.0],
                        [6432.0, 4579.0],
                        [6422.0, 4614.0],
                        [6453.0, 4660.0],
                        [6421.0, 4702.0],
                        [6394.0, 4662.0]
                    ]
                ],
                [
                    [
                        [6740.0, 4764.0],
                        [6714.0, 4748.0],
                        [6702.0, 4716.0],
                        [6682.0, 4735.0],
                        [6636.0, 4722.0],
                        [6615.0, 4679.0],
                        [6588.0, 4672.0],
                        [6573.0, 4729.0],
                        [6611.0, 4784.0],
                        [6621.0, 4769.0],
                        [6651.0, 4772.0],
                        [6660.0, 4789.0],
                        [6696.0, 4807.0],
                        [6740.0, 4764.0]
                    ]
                ],
                [
                    [
                        [7195.0, 5339.0],
                        [7218.0, 5316.0],
                        [7244.0, 5246.0],
                        [7229.0, 5203.0],
                        [7203.0, 5172.0],
                        [7209.0, 5140.0],
                        [7178.0, 5147.0],
                        [7168.0, 5107.0],
                        [7177.0, 5065.0],
                        [7146.0, 4975.0],
                        [7170.0, 4931.0],
                        [7142.0, 4917.0],
                        [7137.0, 4887.0],
                        [7104.0, 4863.0],
                        [7093.0, 4895.0],
                        [7048.0, 4887.0],
                        [7049.0, 4858.0],
                        [7028.0, 4835.0],
                        [7024.0, 4877.0],
                        [7006.0, 4875.0],
                        [6984.0, 4843.0],
                        [6887.0, 4842.0],
                        [6872.0, 4861.0],
                        [6865.0, 4831.0],
                        [6891.0, 4805.0],
                        [6843.0, 4787.0],
                        [6826.0, 4748.0],
                        [6790.0, 4744.0],
                        [6762.0, 4769.0],
                        [6761.0, 4800.0],
                        [6779.0, 4836.0],
                        [6737.0, 4839.0],
                        [6663.0, 4817.0],
                        [6612.0, 4788.0],
                        [6570.0, 4801.0],
                        [6555.0, 4758.0],
                        [6525.0, 4775.0],
                        [6492.0, 4763.0],
                        [6463.0, 4777.0],
                        [6469.0, 4800.0],
                        [6501.0, 4803.0],
                        [6570.0, 4866.0],
                        [6585.0, 4888.0],
                        [6617.0, 4902.0],
                        [6641.0, 4891.0],
                        [6720.0, 4911.0],
                        [6810.0, 4902.0],
                        [6830.0, 4923.0],
                        [6820.0, 4939.0],
                        [6874.0, 5013.0],
                        [6872.0, 5053.0],
                        [6910.0, 5069.0],
                        [6884.0, 5036.0],
                        [6890.0, 5014.0],
                        [6979.0, 5043.0],
                        [7020.0, 5097.0],
                        [7060.0, 5126.0],
                        [7100.0, 5238.0],
                        [7098.0, 5265.0],
                        [7079.0, 5267.0],
                        [7096.0, 5309.0],
                        [7083.0, 5328.0],
                        [7114.0, 5353.0],
                        [7116.0, 5387.0],
                        [7140.0, 5356.0],
                        [7172.0, 5355.0],
                        [7174.0, 5390.0],
                        [7150.0, 5376.0],
                        [7156.0, 5412.0],
                        [7182.0, 5396.0],
                        [7195.0, 5339.0]
                    ]
                ],
                [
                    [
                        [7140.0, 5435.0],
                        [7106.0, 5398.0],
                        [7089.0, 5411.0],
                        [7100.0, 5447.0],
                        [7073.0, 5468.0],
                        [7079.0, 5504.0],
                        [7124.0, 5536.0],
                        [7120.0, 5567.0],
                        [7169.0, 5548.0],
                        [7188.0, 5568.0],
                        [7179.0, 5598.0],
                        [7200.0, 5618.0],
                        [7209.0, 5676.0],
                        [7192.0, 5725.0],
                        [7218.0, 5757.0],
                        [7293.0, 5678.0],
                        [7363.0, 5642.0],
                        [7427.0, 5627.0],
                        [7462.0, 5663.0],
                        [7445.0, 5611.0],
                        [7466.0, 5573.0],
                        [7485.0, 5574.0],
                        [7423.0, 5539.0],
                        [7384.0, 5542.0],
                        [7346.0, 5513.0],
                        [7319.0, 5450.0],
                        [7210.0, 5505.0],
                        [7158.0, 5479.0],
                        [7140.0, 5498.0],
                        [7109.0, 5471.0],
                        [7140.0, 5461.0],
                        [7174.0, 5433.0],
                        [7140.0, 5435.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.460000,
            "hc-middl_1": 0.290000,
            "hc-key": "th",
            "hc-a2": "TH",
            "name": "Thailand",
            "labelrank": "3",
            "country-ab": "Thai.",
            "subregion": "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "THA",
            "iso-a2": "TH",
            "woe-id": "23424960",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [4216.0, 2769.0],
                        [4227.0, 2761.0],
                        [4228.0, 2748.0],
                        [4219.0, 2739.0],
                        [4216.0, 2769.0]
                    ]
                ],
                [
                    [
                        [4523.0, 3055.0],
                        [4524.0, 3055.0],
                        [4536.0, 3027.0],
                        [4523.0, 3055.0],
                        [4523.0, 3055.0],
                        [4523.0, 3055.0]
                    ]
                ],
                [
                    [
                        [4490.0, 2641.0],
                        [4472.0, 2604.0],
                        [4453.0, 2615.0],
                        [4423.0, 2595.0],
                        [4420.0, 2638.0],
                        [4353.0, 2668.0],
                        [4351.0, 2650.0],
                        [4319.0, 2679.0],
                        [4323.0, 2697.0],
                        [4297.0, 2710.0],
                        [4260.0, 2761.0],
                        [4224.0, 2766.0],
                        [4209.0, 2793.0],
                        [4212.0, 2829.0],
                        [4244.0, 2924.0],
                        [4244.0, 2948.0],
                        [4275.0, 2979.0],
                        [4303.0, 3031.0],
                        [4284.0, 3086.0],
                        [4262.0, 3127.0],
                        [4264.0, 3166.0],
                        [4219.0, 3212.0],
                        [4190.0, 3265.0],
                        [4216.0, 3281.0],
                        [4224.0, 3349.0],
                        [4205.0, 3402.0],
                        [4149.0, 3460.0],
                        [4154.0, 3470.0],
                        [4126.0, 3510.0],
                        [4152.0, 3514.0],
                        [4145.0, 3540.0],
                        [4168.0, 3605.0],
                        [4205.0, 3597.0],
                        [4238.0, 3611.0],
                        [4303.0, 3657.0],
                        [4314.0, 3648.0],
                        [4347.0, 3638.0],
                        [4342.0, 3592.0],
                        [4398.0, 3596.0],
                        [4404.0, 3558.0],
                        [4385.0, 3512.0],
                        [4396.0, 3485.0],
                        [4377.0, 3451.0],
                        [4395.0, 3442.0],
                        [4460.0, 3499.0],
                        [4503.0, 3474.0],
                        [4553.0, 3519.0],
                        [4597.0, 3511.0],
                        [4618.0, 3478.0],
                        [4657.0, 3444.0],
                        [4655.0, 3383.0],
                        [4676.0, 3356.0],
                        [4702.0, 3348.0],
                        [4721.0, 3320.0],
                        [4708.0, 3281.0],
                        [4718.0, 3274.0],
                        [4707.0, 3233.0],
                        [4691.0, 3226.0],
                        [4661.0, 3232.0],
                        [4607.0, 3223.0],
                        [4583.0, 3229.0],
                        [4542.0, 3218.0],
                        [4503.0, 3164.0],
                        [4490.0, 3163.0],
                        [4503.0, 3099.0],
                        [4524.0, 3082.0],
                        [4520.0, 3062.0],
                        [4523.0, 3055.0],
                        [4523.0, 3055.0],
                        [4523.0, 3055.0],
                        [4494.0, 3065.0],
                        [4457.0, 3098.0],
                        [4386.0, 3098.0],
                        [4393.0, 3153.0],
                        [4328.0, 3146.0],
                        [4329.0, 3059.0],
                        [4318.0, 3042.0],
                        [4282.0, 2945.0],
                        [4273.0, 2909.0],
                        [4282.0, 2846.0],
                        [4325.0, 2852.0],
                        [4334.0, 2805.0],
                        [4357.0, 2783.0],
                        [4353.0, 2726.0],
                        [4412.0, 2681.0],
                        [4452.0, 2681.0],
                        [4490.0, 2641.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.750000,
            "hc-middl_1": 0.500000,
            "hc-key": "om",
            "hc-a2": "OM",
            "name": "Oman",
            "labelrank": "4",
            "country-ab": "Oman",
            "subregion": "Western Asia",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "OMN",
            "iso-a2": "OM",
            "woe-id": "23424898",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [1371.0, 3535.0],
                        [1369.0, 3548.0],
                        [1386.0, 3573.0],
                        [1391.0, 3561.0],
                        [1371.0, 3535.0]
                    ]
                ],
                [
                    [
                        [1189.0, 3906.0],
                        [1186.0, 3903.0],
                        [1185.0, 3911.0],
                        [1194.0, 3910.0],
                        [1189.0, 3906.0]
                    ]
                ],
                [
                    [
                        [1172.0, 3967.0],
                        [1192.0, 3993.0],
                        [1198.0, 3958.0],
                        [1188.0, 3935.0],
                        [1179.0, 3937.0],
                        [1172.0, 3967.0]
                    ]
                ],
                [
                    [
                        [1118.0, 3713.0],
                        [1117.0, 3735.0],
                        [1140.0, 3794.0],
                        [1134.0, 3808.0],
                        [1172.0, 3818.0],
                        [1154.0, 3829.0],
                        [1155.0, 3876.0],
                        [1173.0, 3869.0],
                        [1197.0, 3886.0],
                        [1214.0, 3851.0],
                        [1254.0, 3811.0],
                        [1371.0, 3782.0],
                        [1427.0, 3715.0],
                        [1446.0, 3712.0],
                        [1446.0, 3687.0],
                        [1416.0, 3630.0],
                        [1387.0, 3607.0],
                        [1360.0, 3552.0],
                        [1331.0, 3563.0],
                        [1304.0, 3502.0],
                        [1316.0, 3448.0],
                        [1251.0, 3431.0],
                        [1233.0, 3414.0],
                        [1212.0, 3365.0],
                        [1149.0, 3356.0],
                        [1121.0, 3295.0],
                        [1050.0, 3290.0],
                        [985.0, 3263.0],
                        [957.0, 3310.0],
                        [900.0, 3432.0],
                        [1110.0, 3513.0],
                        [1152.0, 3661.0],
                        [1118.0, 3713.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.440000,
            "hc-middl_1": 0.480000,
            "hc-key": "ye",
            "hc-a2": "YE",
            "name": "Yemen",
            "labelrank": "3",
            "country-ab": "Yem.",
            "subregion": "Western Asia",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "YEM",
            "iso-a2": "YE",
            "woe-id": "23425002",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [1029.0, 2980.0],
                        [1068.0, 2981.0],
                        [1093.0, 2971.0],
                        [1070.0, 2956.0],
                        [1030.0, 2954.0],
                        [1012.0, 2966.0],
                        [1029.0, 2980.0]
                    ]
                ],
                [
                    [
                        [985.0, 3263.0],
                        [929.0, 3234.0],
                        [926.0, 3187.0],
                        [866.0, 3157.0],
                        [808.0, 3141.0],
                        [782.0, 3126.0],
                        [740.0, 3117.0],
                        [705.0, 3099.0],
                        [678.0, 3064.0],
                        [631.0, 3064.0],
                        [588.0, 3033.0],
                        [539.0, 3015.0],
                        [465.0, 3006.0],
                        [411.0, 2961.0],
                        [387.0, 2965.0],
                        [345.0, 2949.0],
                        [311.0, 2965.0],
                        [294.0, 2991.0],
                        [295.0, 3028.0],
                        [249.0, 3170.0],
                        [254.0, 3218.0],
                        [282.0, 3248.0],
                        [278.0, 3288.0],
                        [293.0, 3302.0],
                        [319.0, 3291.0],
                        [420.0, 3301.0],
                        [439.0, 3293.0],
                        [530.0, 3293.0],
                        [549.0, 3271.0],
                        [581.0, 3282.0],
                        [592.0, 3309.0],
                        [631.0, 3360.0],
                        [698.0, 3397.0],
                        [900.0, 3432.0],
                        [957.0, 3310.0],
                        [985.0, 3263.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.320000,
            "hc-middl_1": 0.460000,
            "hc-key": "in",
            "hc-a2": "IN",
            "name": "India",
            "labelrank": "2",
            "country-ab": "India",
            "subregion": "Southern Asia",
            "region-wb": "South Asia",
            "iso-a3": "IND",
            "iso-a2": "IN",
            "woe-id": "23424848",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [3889.0, 2691.0],
                        [3905.0, 2688.0],
                        [3903.0, 2656.0],
                        [3890.0, 2674.0],
                        [3889.0, 2691.0]
                    ]
                ],
                [
                    [
                        [3804.0, 2940.0],
                        [3804.0, 2925.0],
                        [3791.0, 2922.0],
                        [3790.0, 2939.0],
                        [3804.0, 2940.0]
                    ]
                ],
                [
                    [
                        [3828.0, 3146.0],
                        [3829.0, 3065.0],
                        [3804.0, 3007.0],
                        [3818.0, 3116.0],
                        [3828.0, 3146.0]
                    ]
                ],
                [
                    [
                        [3444.0, 4184.0],
                        [3478.0, 4203.0],
                        [3496.0, 4184.0],
                        [3500.0, 4144.0],
                        [3489.0, 4131.0],
                        [3516.0, 4107.0],
                        [3567.0, 4099.0],
                        [3607.0, 4115.0],
                        [3622.0, 4107.0],
                        [3688.0, 4111.0],
                        [3728.0, 4123.0],
                        [3719.0, 4163.0],
                        [3703.0, 4159.0],
                        [3694.0, 4184.0],
                        [3718.0, 4183.0],
                        [3764.0, 4199.0],
                        [3765.0, 4213.0],
                        [3820.0, 4259.0],
                        [3883.0, 4288.0],
                        [3902.0, 4312.0],
                        [3949.0, 4293.0],
                        [3981.0, 4316.0],
                        [4010.0, 4319.0],
                        [4071.0, 4241.0],
                        [4097.0, 4234.0],
                        [4098.0, 4209.0],
                        [4066.0, 4187.0],
                        [4086.0, 4150.0],
                        [4059.0, 4165.0],
                        [4015.0, 4157.0],
                        [3939.0, 4095.0],
                        [3948.0, 4063.0],
                        [3911.0, 4012.0],
                        [3919.0, 3985.0],
                        [3879.0, 3895.0],
                        [3822.0, 3908.0],
                        [3832.0, 3878.0],
                        [3829.0, 3840.0],
                        [3813.0, 3830.0],
                        [3817.0, 3784.0],
                        [3804.0, 3754.0],
                        [3776.0, 3752.0],
                        [3757.0, 3849.0],
                        [3741.0, 3882.0],
                        [3703.0, 3821.0],
                        [3682.0, 3836.0],
                        [3669.0, 3870.0],
                        [3684.0, 3907.0],
                        [3736.0, 3932.0],
                        [3745.0, 3970.0],
                        [3727.0, 3990.0],
                        [3610.0, 3984.0],
                        [3569.0, 3999.0],
                        [3571.0, 4041.0],
                        [3550.0, 4043.0],
                        [3472.0, 4077.0],
                        [3446.0, 4035.0],
                        [3508.0, 3981.0],
                        [3473.0, 3980.0],
                        [3445.0, 3940.0],
                        [3498.0, 3910.0],
                        [3485.0, 3867.0],
                        [3515.0, 3833.0],
                        [3508.0, 3816.0],
                        [3526.0, 3755.0],
                        [3529.0, 3721.0],
                        [3492.0, 3711.0],
                        [3455.0, 3716.0],
                        [3462.0, 3754.0],
                        [3430.0, 3716.0],
                        [3395.0, 3707.0],
                        [3370.0, 3678.0],
                        [3383.0, 3642.0],
                        [3342.0, 3590.0],
                        [3275.0, 3564.0],
                        [3236.0, 3530.0],
                        [3182.0, 3459.0],
                        [3149.0, 3441.0],
                        [3124.0, 3407.0],
                        [3058.0, 3364.0],
                        [3060.0, 3331.0],
                        [3022.0, 3311.0],
                        [2986.0, 3310.0],
                        [2980.0, 3285.0],
                        [2956.0, 3265.0],
                        [2937.0, 3276.0],
                        [2917.0, 3260.0],
                        [2904.0, 3212.0],
                        [2915.0, 3180.0],
                        [2919.0, 3118.0],
                        [2929.0, 3093.0],
                        [2918.0, 3030.0],
                        [2898.0, 2997.0],
                        [2901.0, 2872.0],
                        [2869.0, 2874.0],
                        [2837.0, 2812.0],
                        [2846.0, 2801.0],
                        [2790.0, 2775.0],
                        [2779.0, 2732.0],
                        [2741.0, 2710.0],
                        [2703.0, 2729.0],
                        [2671.0, 2765.0],
                        [2646.0, 2842.0],
                        [2614.0, 2921.0],
                        [2591.0, 2962.0],
                        [2566.0, 2985.0],
                        [2537.0, 3044.0],
                        [2518.0, 3119.0],
                        [2493.0, 3175.0],
                        [2432.0, 3272.0],
                        [2417.0, 3345.0],
                        [2394.0, 3417.0],
                        [2366.0, 3545.0],
                        [2380.0, 3595.0],
                        [2378.0, 3623.0],
                        [2359.0, 3666.0],
                        [2381.0, 3682.0],
                        [2353.0, 3683.0],
                        [2352.0, 3716.0],
                        [2323.0, 3702.0],
                        [2336.0, 3678.0],
                        [2324.0, 3644.0],
                        [2245.0, 3605.0],
                        [2214.0, 3611.0],
                        [2178.0, 3635.0],
                        [2096.0, 3717.0],
                        [2144.0, 3723.0],
                        [2183.0, 3740.0],
                        [2198.0, 3769.0],
                        [2150.0, 3753.0],
                        [2116.0, 3758.0],
                        [2071.0, 3783.0],
                        [2038.0, 3830.0],
                        [2076.0, 3841.0],
                        [2076.0, 3865.0],
                        [2135.0, 3866.0],
                        [2164.0, 3859.0],
                        [2203.0, 3880.0],
                        [2220.0, 3866.0],
                        [2243.0, 3880.0],
                        [2241.0, 3901.0],
                        [2209.0, 3956.0],
                        [2207.0, 3976.0],
                        [2181.0, 3975.0],
                        [2166.0, 3996.0],
                        [2171.0, 4038.0],
                        [2121.0, 4057.0],
                        [2128.0, 4086.0],
                        [2180.0, 4151.0],
                        [2216.0, 4128.0],
                        [2289.0, 4150.0],
                        [2323.0, 4215.0],
                        [2360.0, 4235.0],
                        [2390.0, 4306.0],
                        [2431.0, 4327.0],
                        [2423.0, 4340.0],
                        [2456.0, 4384.0],
                        [2479.0, 4399.0],
                        [2465.0, 4447.0],
                        [2488.0, 4473.0],
                        [2525.0, 4493.0],
                        [2480.0, 4507.0],
                        [2476.0, 4536.0],
                        [2449.0, 4533.0],
                        [2426.0, 4562.0],
                        [2423.0, 4599.0],
                        [2443.0, 4624.0],
                        [2420.0, 4627.0],
                        [2407.0, 4656.0],
                        [2442.0, 4689.0],
                        [2549.0, 4671.0],
                        [2603.0, 4691.0],
                        [2637.0, 4723.0],
                        [2690.0, 4756.0],
                        [2726.0, 4690.0],
                        [2773.0, 4669.0],
                        [2760.0, 4645.0],
                        [2765.0, 4603.0],
                        [2808.0, 4574.0],
                        [2817.0, 4533.0],
                        [2777.0, 4509.0],
                        [2763.0, 4531.0],
                        [2739.0, 4521.0],
                        [2767.0, 4478.0],
                        [2768.0, 4429.0],
                        [2791.0, 4437.0],
                        [2829.0, 4400.0],
                        [2876.0, 4385.0],
                        [2872.0, 4372.0],
                        [2931.0, 4346.0],
                        [2896.0, 4314.0],
                        [2867.0, 4238.0],
                        [2947.0, 4205.0],
                        [2959.0, 4187.0],
                        [3013.0, 4172.0],
                        [3063.0, 4142.0],
                        [3193.0, 4134.0],
                        [3199.0, 4111.0],
                        [3245.0, 4091.0],
                        [3267.0, 4101.0],
                        [3284.0, 4080.0],
                        [3317.0, 4084.0],
                        [3348.0, 4070.0],
                        [3370.0, 4083.0],
                        [3391.0, 4067.0],
                        [3444.0, 4076.0],
                        [3450.0, 4099.0],
                        [3435.0, 4125.0],
                        [3444.0, 4184.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.380000,
            "hc-middl_1": 0.390000,
            "hc-key": "kr",
            "hc-a2": "KR",
            "name": "South Korea",
            "labelrank": "2",
            "country-ab": "S.K.",
            "subregion": "Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "KOR",
            "iso-a2": "KR",
            "woe-id": "23424868",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [6177.0, 4723.0],
                        [6179.0, 4703.0],
                        [6140.0, 4693.0],
                        [6141.0, 4714.0],
                        [6177.0, 4723.0]
                    ]
                ],
                [
                    [
                        [6154.0, 5067.0],
                        [6154.0, 5067.0],
                        [6188.0, 5107.0],
                        [6251.0, 5109.0],
                        [6273.0, 5136.0],
                        [6293.0, 5097.0],
                        [6345.0, 5029.0],
                        [6357.0, 4987.0],
                        [6352.0, 4941.0],
                        [6364.0, 4932.0],
                        [6359.0, 4885.0],
                        [6341.0, 4856.0],
                        [6291.0, 4850.0],
                        [6288.0, 4833.0],
                        [6261.0, 4844.0],
                        [6227.0, 4831.0],
                        [6242.0, 4815.0],
                        [6157.0, 4776.0],
                        [6136.0, 4816.0],
                        [6147.0, 4845.0],
                        [6146.0, 4888.0],
                        [6170.0, 4907.0],
                        [6147.0, 4930.0],
                        [6135.0, 4981.0],
                        [6146.0, 5003.0],
                        [6174.0, 4994.0],
                        [6147.0, 5051.0],
                        [6154.0, 5067.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.440000,
            "hc-middl_1": 0.680000,
            "hc-key": "bd",
            "hc-a2": "BD",
            "name": "Bangladesh",
            "labelrank": "3",
            "country-ab": "Bang.",
            "subregion": "Southern Asia",
            "region-wb": "South Asia",
            "iso-a3": "BGD",
            "iso-a2": "BD",
            "woe-id": "23424759",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [3672.0, 3778.0],
                        [3676.0, 3767.0],
                        [3668.0, 3757.0],
                        [3664.0, 3759.0],
                        [3672.0, 3778.0]
                    ]
                ],
                [
                    [
                        [3776.0, 3752.0],
                        [3782.0, 3702.0],
                        [3759.0, 3713.0],
                        [3756.0, 3684.0],
                        [3759.0, 3662.0],
                        [3727.0, 3714.0],
                        [3724.0, 3760.0],
                        [3694.0, 3809.0],
                        [3659.0, 3792.0],
                        [3626.0, 3829.0],
                        [3632.0, 3765.0],
                        [3639.0, 3782.0],
                        [3637.0, 3807.0],
                        [3652.0, 3763.0],
                        [3627.0, 3755.0],
                        [3631.0, 3763.0],
                        [3606.0, 3733.0],
                        [3599.0, 3748.0],
                        [3539.0, 3719.0],
                        [3526.0, 3755.0],
                        [3508.0, 3816.0],
                        [3515.0, 3833.0],
                        [3485.0, 3867.0],
                        [3498.0, 3910.0],
                        [3445.0, 3940.0],
                        [3473.0, 3980.0],
                        [3508.0, 3981.0],
                        [3446.0, 4035.0],
                        [3472.0, 4077.0],
                        [3550.0, 4043.0],
                        [3571.0, 4041.0],
                        [3569.0, 3999.0],
                        [3610.0, 3984.0],
                        [3727.0, 3990.0],
                        [3745.0, 3970.0],
                        [3736.0, 3932.0],
                        [3684.0, 3907.0],
                        [3669.0, 3870.0],
                        [3682.0, 3836.0],
                        [3703.0, 3821.0],
                        [3741.0, 3882.0],
                        [3757.0, 3849.0],
                        [3776.0, 3752.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.580000,
            "hc-middl_1": 0.510000,
            "hc-key": "sp",
            "hc-a2": "SP",
            "name": "Spratly Islands",
            "labelrank": "6",
            "country-ab": "Spratly Is.",
            "subregion": "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "-99",
            "iso-a2": "SP",
            "woe-id": "23424921",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [5456.0, 2993.0],
                        [5455.0, 2993.0],
                        [5455.0, 2994.0],
                        [5456.0, 2994.0],
                        [5456.0, 2993.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.420000,
            "hc-middl_1": 0.560000,
            "hc-key": "cn",
            "hc-a2": "CN",
            "name": "Mainland China",
            "labelrank": "2",
            "country-ab": "Mainland China",
            "subregion": "Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "CHN",
            "iso-a2": "CN",
            "woe-id": "23424781",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [5867.901726797210358, 4429.196546405579284],
                        [5844.901726797210358, 4432.196546405579284],
                        [5841.901726797210358, 4443.196546405579284],
                        [5864.901726797210358, 4438.196546405579284],
                        [5867.901726797210358, 4429.196546405579284]
                    ]
                ],
                [
                    [
                        [5833.901726797210358, 4545.196546405579284],
                        [5790.901726797210358, 4559.196546405579284],
                        [5786.901726797210358, 4574.196546405579284],
                        [5838.901726797210358, 4552.196546405579284],
                        [5833.901726797210358, 4545.196546405579284]
                    ]
                ],
                [
                    [
                        [3499.901726797210358, 4144.196546405579284],
                        [3495.901726797210358, 4184.196546405579284],
                        [3477.901726797210358, 4203.196546405579284],
                        [3443.901726797210358, 4184.196546405579284],
                        [3374.901726797210358, 4178.196546405579284],
                        [3330.901726797210358, 4197.196546405579284],
                        [3291.901726797210358, 4180.196546405579284],
                        [3269.901726797210358, 4214.196546405579284],
                        [3226.901726797210358, 4211.196546405579284],
                        [3231.901726797210358, 4232.196546405579284],
                        [3196.901726797210358, 4232.196546405579284],
                        [3164.901726797210358, 4254.196546405579284],
                        [3153.901726797210358, 4280.196546405579284],
                        [3112.901726797210358, 4274.196546405579284],
                        [3086.901726797210358, 4307.196546405579284],
                        [3063.901726797210358, 4309.196546405579284],
                        [3012.901726797210358, 4339.196546405579284],
                        [3008.901726797210358, 4359.196546405579284],
                        [2958.901726797210358, 4360.196546405579284],
                        [2938.901726797210358, 4332.196546405579284],
                        [2930.901726797210358, 4346.196546405579284],
                        [2871.901726797210358, 4372.196546405579284],
                        [2875.901726797210358, 4385.196546405579284],
                        [2828.901726797210358, 4400.196546405579284],
                        [2790.901726797210358, 4437.196546405579284],
                        [2767.901726797210358, 4429.196546405579284],
                        [2766.901726797210358, 4478.196546405579284],
                        [2738.901726797210358, 4521.196546405579284],
                        [2762.901726797210358, 4531.196546405579284],
                        [2776.901726797210358, 4509.196546405579284],
                        [2816.901726797210358, 4533.196546405579284],
                        [2807.901726797210358, 4574.196546405579284],
                        [2764.901726797210358, 4603.196546405579284],
                        [2759.901726797210358, 4645.196546405579284],
                        [2772.901726797210358, 4669.196546405579284],
                        [2725.901726797210358, 4690.196546405579284],
                        [2689.901726797210358, 4756.196546405579284],
                        [2661.901726797210358, 4753.196546405579284],
                        [2616.901726797210358, 4765.196546405579284],
                        [2598.901726797210358, 4786.196546405579284],
                        [2572.901726797210358, 4777.196546405579284],
                        [2552.901726797210358, 4800.196546405579284],
                        [2557.901726797210358, 4829.196546405579284],
                        [2511.901726797210358, 4865.196546405579284],
                        [2453.901726797210358, 4871.196546405579284],
                        [2441.901726797210358, 4880.196546405579284],
                        [2477.901726797210358, 4889.196546405579284],
                        [2496.901726797210358, 4904.196546405579284],
                        [2476.901726797210358, 4919.196546405579284],
                        [2465.901726797210358, 4994.196546405579284],
                        [2434.901726797210358, 5006.196546405579284],
                        [2396.901726797210358, 4999.196546405579284],
                        [2381.901726797210358, 5069.196546405579284],
                        [2402.901726797210358, 5081.196546405579284],
                        [2406.901726797210358, 5121.196546405579284],
                        [2432.901726797210358, 5125.196546405579284],
                        [2464.901726797210358, 5161.196546405579284],
                        [2489.901726797210358, 5156.196546405579284],
                        [2517.901726797210358, 5171.196546405579284],
                        [2525.901726797210358, 5144.196546405579284],
                        [2591.901726797210358, 5175.196546405579284],
                        [2600.901726797210358, 5202.196546405579284],
                        [2692.901726797210358, 5213.196546405579284],
                        [2712.901726797210358, 5242.196546405579284],
                        [2777.901726797210358, 5279.196546405579284],
                        [2839.901726797210358, 5301.196546405579284],
                        [2841.901726797210358, 5316.196546405579284],
                        [2834.901726797210358, 5353.196546405579284],
                        [2879.901726797210358, 5398.196546405579284],
                        [2844.901726797210358, 5481.196546405579284],
                        [2844.901726797210358, 5529.196546405579284],
                        [2817.901726797210358, 5540.196546405579284],
                        [2822.901726797210358, 5560.196546405579284],
                        [2940.901726797210358, 5592.196546405579284],
                        [2955.901726797210358, 5576.196546405579284],
                        [3000.901726797210358, 5580.196546405579284],
                        [3002.901726797210358, 5603.196546405579284],
                        [2978.901726797210358, 5611.196546405579284],
                        [2996.901726797210358, 5670.196546405579284],
                        [3034.901726797210358, 5762.196546405579284],
                        [3089.901726797210358, 5743.196546405579284],
                        [3142.901726797210358, 5745.196546405579284],
                        [3150.901726797210358, 5731.196546405579284],
                        [3201.901726797210358, 5753.196546405579284],
                        [3213.901726797210358, 5784.196546405579284],
                        [3200.901726797210358, 5832.196546405579284],
                        [3217.901726797210358, 5876.196546405579284],
                        [3273.901726797210358, 5889.196546405579284],
                        [3294.901726797210358, 5943.196546405579284],
                        [3325.901726797210358, 5942.196546405579284],
                        [3339.901726797210358, 5946.196546405579284],
                        [3359.901726797210358, 5951.196546405579284],
                        [3370.901726797210358, 5899.196546405579284],
                        [3415.901726797210358, 5878.196546405579284],
                        [3450.901726797210358, 5847.196546405579284],
                        [3486.901726797210358, 5852.196546405579284],
                        [3544.901726797210358, 5820.196546405579284],
                        [3554.901726797210358, 5789.196546405579284],
                        [3597.901726797210358, 5724.196546405579284],
                        [3596.901726797210358, 5675.196546405579284],
                        [3572.901726797210358, 5628.196546405579284],
                        [3589.901726797210358, 5601.196546405579284],
                        [3645.901726797210358, 5592.196546405579284],
                        [3778.901726797210358, 5587.196546405579284],
                        [3808.901726797210358, 5564.196546405579284],
                        [3888.901726797210358, 5530.196546405579284],
                        [3912.901726797210358, 5534.196546405579284],
                        [3953.901726797210358, 5442.196546405579284],
                        [3985.901726797210358, 5403.196546405579284],
                        [4045.901726797210358, 5409.196546405579284],
                        [4208.901726797210358, 5396.196546405579284],
                        [4246.901726797210358, 5406.196546405579284],
                        [4362.901726797210358, 5397.196546405579284],
                        [4391.901726797210358, 5369.196546405579284],
                        [4465.901726797210358, 5357.196546405579284],
                        [4512.901726797210358, 5337.196546405579284],
                        [4567.901726797210358, 5349.196546405579284],
                        [4567.901726797210358, 5331.196546405579284],
                        [4604.901726797210358, 5327.196546405579284],
                        [4617.901726797210358, 5340.196546405579284],
                        [4727.901726797210358, 5390.196546405579284],
                        [4826.901726797210358, 5408.196546405579284],
                        [4919.901726797210358, 5411.196546405579284],
                        [4984.901726797210358, 5440.196546405579284],
                        [5020.901726797210358, 5486.196546405579284],
                        [5090.901726797210358, 5524.196546405579284],
                        [5049.901726797210358, 5579.196546405579284],
                        [5072.901726797210358, 5634.196546405579284],
                        [5091.901726797210358, 5645.196546405579284],
                        [5207.901726797210358, 5619.196546405579284],
                        [5236.901726797210358, 5637.196546405579284],
                        [5269.901726797210358, 5678.196546405579284],
                        [5347.901726797210358, 5685.196546405579284],
                        [5384.901726797210358, 5710.196546405579284],
                        [5413.901726797210358, 5764.196546405579284],
                        [5463.901726797210358, 5770.196546405579284],
                        [5528.901726797210358, 5805.196546405579284],
                        [5569.901726797210358, 5810.196546405579284],
                        [5631.901726797210358, 5797.196546405579284],
                        [5646.901726797210358, 5808.196546405579284],
                        [5631.901726797210358, 5848.196546405579284],
                        [5546.901726797210358, 5918.196546405579284],
                        [5489.901726797210358, 5917.196546405579284],
                        [5485.901726797210358, 5915.196546405579284],
                        [5473.901726797210358, 5898.196546405579284],
                        [5460.901726797210358, 5886.196546405579284],
                        [5426.901726797210358, 5905.196546405579284],
                        [5383.901726797210358, 5903.196546405579284],
                        [5356.901726797210358, 5887.196546405579284],
                        [5330.901726797210358, 5924.196546405579284],
                        [5408.901726797210358, 6083.196546405579284],
                        [5485.901726797210358, 6057.196546405579284],
                        [5547.901726797210358, 6100.196546405579284],
                        [5594.901726797210358, 6114.196546405579284],
                        [5581.901726797210358, 6140.196546405579284],
                        [5605.901726797210358, 6175.196546405579284],
                        [5645.901726797210358, 6264.196546405579284],
                        [5691.901726797210358, 6308.196546405579284],
                        [5686.901726797210358, 6348.196546405579284],
                        [5638.901726797210358, 6352.196546405579284],
                        [5636.901726797210358, 6368.196546405579284],
                        [5694.901726797210358, 6420.196546405579284],
                        [5797.901726797210358, 6444.196546405579284],
                        [5888.901726797210358, 6454.196546405579284],
                        [5945.901726797210358, 6424.196546405579284],
                        [5996.901726797210358, 6423.196546405579284],
                        [6040.901726797210358, 6403.196546405579284],
                        [6100.901726797210358, 6326.196546405579284],
                        [6094.901726797210358, 6309.196546405579284],
                        [6129.901726797210358, 6255.196546405579284],
                        [6132.901726797210358, 6224.196546405579284],
                        [6158.901726797210358, 6195.196546405579284],
                        [6163.901726797210358, 6156.196546405579284],
                        [6180.901726797210358, 6147.196546405579284],
                        [6177.901726797210358, 6110.196546405579284],
                        [6219.901726797210358, 6085.196546405579284],
                        [6269.901726797210358, 6090.196546405579284],
                        [6290.901726797210358, 6070.196546405579284],
                        [6320.901726797210358, 6077.196546405579284],
                        [6375.901726797210358, 6028.196546405579284],
                        [6405.901726797210358, 6030.196546405579284],
                        [6395.901726797210358, 6008.196546405579284],
                        [6417.901726797210358, 5982.196546405579284],
                        [6408.901726797210358, 5955.196546405579284],
                        [6433.901726797210358, 5923.196546405579284],
                        [6540.901726797210358, 5929.196546405579284],
                        [6579.901726797210358, 5967.196546405579284],
                        [6670.901726797210358, 5995.196546405579284],
                        [6700.901726797210358, 5935.196546405579284],
                        [6657.901726797210358, 5893.196546405579284],
                        [6642.901726797210358, 5803.196546405579284],
                        [6627.901726797210358, 5792.196546405579284],
                        [6590.901726797210358, 5701.196546405579284],
                        [6570.901726797210358, 5694.196546405579284],
                        [6562.901726797210358, 5711.196546405579284],
                        [6510.901726797210358, 5707.196546405579284],
                        [6497.901726797210358, 5716.196546405579284],
                        [6470.901726797210358, 5682.196546405579284],
                        [6436.901726797210358, 5671.196546405579284],
                        [6462.901726797210358, 5603.196546405579284],
                        [6465.901726797210358, 5544.196546405579284],
                        [6454.901726797210358, 5504.196546405579284],
                        [6405.901726797210358, 5487.196546405579284],
                        [6414.901726797210358, 5470.196546405579284],
                        [6384.901726797210358, 5507.196546405579284],
                        [6365.901726797210358, 5505.196546405579284],
                        [6356.901726797210358, 5460.196546405579284],
                        [6330.901726797210358, 5459.196546405579284],
                        [6300.901726797210358, 5423.196546405579284],
                        [6238.901726797210358, 5418.196546405579284],
                        [6259.901726797210358, 5384.196546405579284],
                        [6248.901726797210358, 5366.196546405579284],
                        [6185.901726797210358, 5374.196546405579284],
                        [6160.901726797210358, 5399.196546405579284],
                        [6139.901726797210358, 5386.196546405579284],
                        [6098.901726797210358, 5321.196546405579284],
                        [6020.901726797210358, 5282.196546405579284],
                        [5984.901726797210358, 5249.196546405579284],
                        [5967.901726797210358, 5226.196546405579284],
                        [5915.901726797210358, 5221.196546405579284],
                        [5845.901726797210358, 5187.196546405579284],
                        [5809.901726797210358, 5147.196546405579284],
                        [5759.901726797210358, 5127.196546405579284],
                        [5756.901726797210358, 5145.196546405579284],
                        [5795.901726797210358, 5158.196546405579284],
                        [5802.901726797210358, 5182.196546405579284],
                        [5767.901726797210358, 5182.196546405579284],
                        [5783.901726797210358, 5222.196546405579284],
                        [5807.901726797210358, 5234.196546405579284],
                        [5836.901726797210358, 5277.196546405579284],
                        [5803.901726797210358, 5304.196546405579284],
                        [5754.901726797210358, 5310.196546405579284],
                        [5704.901726797210358, 5247.196546405579284],
                        [5641.901726797210358, 5219.196546405579284],
                        [5606.901726797210358, 5160.196546405579284],
                        [5551.901726797210358, 5147.196546405579284],
                        [5517.901726797210358, 5150.196546405579284],
                        [5503.901726797210358, 5109.196546405579284],
                        [5543.901726797210358, 5071.196546405579284],
                        [5596.901726797210358, 5074.196546405579284],
                        [5612.901726797210358, 5039.196546405579284],
                        [5608.901726797210358, 5003.196546405579284],
                        [5642.901726797210358, 4991.196546405579284],
                        [5732.901726797210358, 5052.196546405579284],
                        [5794.901726797210358, 5021.196546405579284],
                        [5831.901726797210358, 5034.196546405579284],
                        [5872.901726797210358, 5022.196546405579284],
                        [5847.901726797210358, 4974.196546405579284],
                        [5827.901726797210358, 4986.196546405579284],
                        [5737.901726797210358, 4940.196546405579284],
                        [5734.901726797210358, 4915.196546405579284],
                        [5661.901726797210358, 4867.196546405579284],
                        [5631.901726797210358, 4823.196546405579284],
                        [5664.901726797210358, 4784.196546405579284],
                        [5708.901726797210358, 4766.196546405579284],
                        [5726.901726797210358, 4714.196546405579284],
                        [5757.901726797210358, 4665.196546405579284],
                        [5756.901726797210358, 4638.196546405579284],
                        [5794.901726797210358, 4617.196546405579284],
                        [5826.901726797210358, 4584.196546405579284],
                        [5826.901726797210358, 4563.196546405579284],
                        [5788.901726797210358, 4578.196546405579284],
                        [5750.901726797210358, 4569.196546405579284],
                        [5821.901726797210358, 4531.196546405579284],
                        [5840.901726797210358, 4503.196546405579284],
                        [5770.901726797210358, 4472.196546405579284],
                        [5753.901726797210358, 4447.196546405579284],
                        [5798.901726797210358, 4456.196546405579284],
                        [5821.901726797210358, 4431.196546405579284],
                        [5851.901726797210358, 4425.196546405579284],
                        [5839.901726797210358, 4404.196546405579284],
                        [5842.901726797210358, 4360.196546405579284],
                        [5816.901726797210358, 4376.196546405579284],
                        [5824.901726797210358, 4303.196546405579284],
                        [5790.901726797210358, 4279.196546405579284],
                        [5790.901726797210358, 4305.196546405579284],
                        [5750.901726797210358, 4242.196546405579284],
                        [5746.901726797210358, 4214.196546405579284],
                        [5689.901726797210358, 4174.196546405579284],
                        [5703.901726797210358, 4145.196546405579284],
                        [5677.901726797210358, 4072.196546405579284],
                        [5667.901726797210358, 4085.196546405579284],
                        [5642.901726797210358, 4065.196546405579284],
                        [5644.901726797210358, 4040.196546405579284],
                        [5578.901726797210358, 3996.196546405579284],
                        [5547.901726797210358, 3945.196546405579284],
                        [5499.901726797210358, 3937.196546405579284],
                        [5471.901726797210358, 3883.196546405579284],
                        [5424.901726797210358, 3867.196546405579284],
                        [5350.901726797210358, 3869.196546405579284],
                        [5332.901726797210358, 3842.196546405579284],
                        [5288.901726797210358, 3837.196546405579284],
                        [5276.901726797210358, 3863.196546405579284],
                        [5264.901726797210358, 3818.196546405579284],
                        [5196.901726797210358, 3786.196546405579284],
                        [5156.901726797210358, 3787.196546405579284],
                        [5129.901726797210358, 3766.196546405579284],
                        [5064.901726797210358, 3751.196546405579284],
                        [5052.901726797210358, 3721.196546405579284],
                        [5034.901726797210358, 3722.196546405579284],
                        [5045.901726797210358, 3673.196546405579284],
                        [5011.901726797210358, 3667.196546405579284],
                        [4991.901726797210358, 3717.196546405579284],
                        [4995.901726797210358, 3757.196546405579284],
                        [4953.901726797210358, 3751.196546405579284],
                        [4952.901726797210358, 3765.196546405579284],
                        [4902.901726797210358, 3783.196546405579284],
                        [4871.901726797210358, 3754.196546405579284],
                        [4825.901726797210358, 3761.196546405579284],
                        [4774.901726797210358, 3788.196546405579284],
                        [4765.901726797210358, 3820.196546405579284],
                        [4779.901726797210358, 3844.196546405579284],
                        [4760.901726797210358, 3857.196546405579284],
                        [4715.901726797210358, 3854.196546405579284],
                        [4676.901726797210358, 3887.196546405579284],
                        [4645.901726797210358, 3871.196546405579284],
                        [4642.901726797210358, 3853.196546405579284],
                        [4584.901726797210358, 3821.196546405579284],
                        [4559.901726797210358, 3841.196546405579284],
                        [4535.901726797210358, 3839.196546405579284],
                        [4513.901726797210358, 3812.196546405579284],
                        [4474.901726797210358, 3835.196546405579284],
                        [4451.901726797210358, 3807.196546405579284],
                        [4418.901726797210358, 3809.196546405579284],
                        [4409.901726797210358, 3793.196546405579284],
                        [4427.901726797210358, 3763.196546405579284],
                        [4426.901726797210358, 3712.196546405579284],
                        [4395.901726797210358, 3714.196546405579284],
                        [4385.901726797210358, 3742.196546405579284],
                        [4382.901726797210358, 3757.196546405579284],
                        [4317.901726797210358, 3730.196546405579284],
                        [4298.901726797210358, 3775.196546405579284],
                        [4241.901726797210358, 3781.196546405579284],
                        [4263.901726797210358, 3849.196546405579284],
                        [4218.901726797210358, 3857.196546405579284],
                        [4217.901726797210358, 3889.196546405579284],
                        [4196.901726797210358, 3923.196546405579284],
                        [4167.901726797210358, 3925.196546405579284],
                        [4129.901726797210358, 3905.196546405579284],
                        [4120.901726797210358, 3971.196546405579284],
                        [4139.901726797210358, 4010.196546405579284],
                        [4199.901726797210358, 4059.196546405579284],
                        [4188.901726797210358, 4076.196546405579284],
                        [4201.901726797210358, 4116.196546405579284],
                        [4194.901726797210358, 4188.196546405579284],
                        [4166.901726797210358, 4184.196546405579284],
                        [4152.901726797210358, 4230.196546405579284],
                        [4110.901726797210358, 4259.196546405579284],
                        [4096.901726797210358, 4234.196546405579284],
                        [4070.901726797210358, 4241.196546405579284],
                        [4009.901726797210358, 4319.196546405579284],
                        [3980.901726797210358, 4316.196546405579284],
                        [3948.901726797210358, 4293.196546405579284],
                        [3901.901726797210358, 4312.196546405579284],
                        [3882.901726797210358, 4288.196546405579284],
                        [3819.901726797210358, 4259.196546405579284],
                        [3764.901726797210358, 4213.196546405579284],
                        [3763.901726797210358, 4199.196546405579284],
                        [3717.901726797210358, 4183.196546405579284],
                        [3693.901726797210358, 4184.196546405579284],
                        [3667.901726797210358, 4209.196546405579284],
                        [3654.901726797210358, 4199.196546405579284],
                        [3609.901726797210358, 4206.196546405579284],
                        [3591.901726797210358, 4227.196546405579284],
                        [3544.901726797210358, 4208.196546405579284],
                        [3499.901726797210358, 4144.196546405579284]
                    ]
                ],
                [
                    [
                        [4997.901726797210358, 3649.196546405579284],
                        [5084.901726797210358, 3651.196546405579284],
                        [5089.901726797210358, 3629.196546405579284],
                        [5067.901726797210358, 3606.196546405579284],
                        [5048.901726797210358, 3554.196546405579284],
                        [5004.901726797210358, 3531.196546405579284],
                        [4991.901726797210358, 3514.196546405579284],
                        [4929.901726797210358, 3537.196546405579284],
                        [4922.901726797210358, 3593.196546405579284],
                        [4997.901726797210358, 3649.196546405579284]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.460000,
            "hc-middl_1": 0.500000,
            "hc-key": "bh",
            "hc-a2": "BH",
            "name": "Bahrain",
            "labelrank": "4",
            "country-ab": "Bahr.",
            "subregion": "Western Asia",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "BHR",
            "iso-a2": "BH",
            "woe-id": "23424753",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [774.0, 3967.0],
                        [784.0, 3963.0],
                        [782.0, 3933.0],
                        [774.0, 3948.0],
                        [774.0, 3967.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.450000,
            "hc-middl_1": 0.360000,
            "hc-key": "mm",
            "hc-a2": "MM",
            "name": "Myanmar",
            "labelrank": "3",
            "country-ab": "Myan.",
            "subregion": "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "MMR",
            "iso-a2": "MM",
            "woe-id": "23424763",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [4205.0, 3077.0],
                        [4207.0, 3090.0],
                        [4220.0, 3077.0],
                        [4210.0, 3064.0],
                        [4205.0, 3077.0]
                    ]
                ],
                [
                    [
                        [3756.0, 3684.0],
                        [3759.0, 3713.0],
                        [3782.0, 3702.0],
                        [3776.0, 3752.0],
                        [3804.0, 3754.0],
                        [3817.0, 3784.0],
                        [3813.0, 3830.0],
                        [3829.0, 3840.0],
                        [3832.0, 3878.0],
                        [3822.0, 3908.0],
                        [3879.0, 3895.0],
                        [3919.0, 3985.0],
                        [3911.0, 4012.0],
                        [3948.0, 4063.0],
                        [3939.0, 4095.0],
                        [4015.0, 4157.0],
                        [4059.0, 4165.0],
                        [4086.0, 4150.0],
                        [4066.0, 4187.0],
                        [4098.0, 4209.0],
                        [4097.0, 4234.0],
                        [4111.0, 4259.0],
                        [4153.0, 4230.0],
                        [4167.0, 4184.0],
                        [4195.0, 4188.0],
                        [4202.0, 4116.0],
                        [4189.0, 4076.0],
                        [4200.0, 4059.0],
                        [4140.0, 4010.0],
                        [4121.0, 3971.0],
                        [4130.0, 3905.0],
                        [4168.0, 3925.0],
                        [4197.0, 3923.0],
                        [4218.0, 3889.0],
                        [4219.0, 3857.0],
                        [4264.0, 3849.0],
                        [4242.0, 3781.0],
                        [4299.0, 3775.0],
                        [4318.0, 3730.0],
                        [4383.0, 3757.0],
                        [4386.0, 3742.0],
                        [4356.0, 3723.0],
                        [4344.0, 3685.0],
                        [4321.0, 3676.0],
                        [4314.0, 3648.0],
                        [4303.0, 3657.0],
                        [4238.0, 3611.0],
                        [4205.0, 3597.0],
                        [4168.0, 3605.0],
                        [4145.0, 3540.0],
                        [4152.0, 3514.0],
                        [4126.0, 3510.0],
                        [4154.0, 3470.0],
                        [4149.0, 3460.0],
                        [4205.0, 3402.0],
                        [4224.0, 3349.0],
                        [4216.0, 3281.0],
                        [4190.0, 3265.0],
                        [4219.0, 3212.0],
                        [4264.0, 3166.0],
                        [4262.0, 3127.0],
                        [4284.0, 3086.0],
                        [4303.0, 3031.0],
                        [4275.0, 2979.0],
                        [4244.0, 2948.0],
                        [4244.0, 2924.0],
                        [4230.0, 2898.0],
                        [4222.0, 2949.0],
                        [4240.0, 2965.0],
                        [4241.0, 3025.0],
                        [4214.0, 3022.0],
                        [4233.0, 3094.0],
                        [4224.0, 3127.0],
                        [4193.0, 3162.0],
                        [4165.0, 3247.0],
                        [4151.0, 3348.0],
                        [4137.0, 3348.0],
                        [4107.0, 3416.0],
                        [4095.0, 3425.0],
                        [4089.0, 3378.0],
                        [4077.0, 3362.0],
                        [4026.0, 3340.0],
                        [3995.0, 3302.0],
                        [3962.0, 3303.0],
                        [3907.0, 3320.0],
                        [3910.0, 3358.0],
                        [3932.0, 3432.0],
                        [3916.0, 3487.0],
                        [3896.0, 3524.0],
                        [3862.0, 3537.0],
                        [3848.0, 3558.0],
                        [3866.0, 3561.0],
                        [3858.0, 3572.0],
                        [3869.0, 3572.0],
                        [3880.0, 3567.0],
                        [3837.0, 3615.0],
                        [3814.0, 3608.0],
                        [3765.0, 3657.0],
                        [3756.0, 3684.0]
                    ],
                    [
                        [3878.0, 3564.0],
                        [3883.0, 3565.0],
                        [3881.0, 3566.0],
                        [3878.0, 3564.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.390000,
            "hc-middl_1": 0.390000,
            "hc-key": "id",
            "hc-a2": "ID",
            "name": "Indonesia",
            "labelrank": "2",
            "country-ab": "Indo.",
            "subregion": "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "IDN",
            "iso-a2": "ID",
            "woe-id": "23424846",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [6044.0, 1503.0],
                        [6033.0, 1486.0],
                        [6008.0, 1477.0],
                        [6045.0, 1513.0],
                        [6044.0, 1503.0]
                    ]
                ],
                [
                    [
                        [5803.0, 1582.0],
                        [5837.0, 1563.0],
                        [5862.0, 1531.0],
                        [5836.0, 1515.0],
                        [5802.0, 1536.0],
                        [5727.0, 1564.0],
                        [5743.0, 1578.0],
                        [5803.0, 1582.0]
                    ]
                ],
                [
                    [
                        [6023.0, 1656.0],
                        [6005.0, 1644.0],
                        [6015.0, 1662.0],
                        [6036.0, 1668.0],
                        [6023.0, 1656.0]
                    ]
                ],
                [
                    [
                        [5568.0, 1642.0],
                        [5557.0, 1606.0],
                        [5517.0, 1604.0],
                        [5517.0, 1637.0],
                        [5542.0, 1655.0],
                        [5568.0, 1642.0]
                    ]
                ],
                [
                    [
                        [6079.0, 1671.0],
                        [6052.0, 1646.0],
                        [6029.0, 1649.0],
                        [6039.0, 1664.0],
                        [6079.0, 1671.0]
                    ]
                ],
                [
                    [
                        [6100.0, 1662.0],
                        [6096.0, 1651.0],
                        [6085.0, 1658.0],
                        [6101.0, 1676.0],
                        [6100.0, 1662.0]
                    ]
                ],
                [
                    [
                        [6123.0, 1680.0],
                        [6161.0, 1679.0],
                        [6163.0, 1666.0],
                        [6114.0, 1656.0],
                        [6123.0, 1680.0]
                    ]
                ],
                [
                    [
                        [6351.0, 1684.0],
                        [6355.0, 1691.0],
                        [6376.0, 1688.0],
                        [6382.0, 1678.0],
                        [6351.0, 1684.0]
                    ]
                ],
                [
                    [
                        [5479.0, 1655.0],
                        [5495.0, 1641.0],
                        [5462.0, 1608.0],
                        [5405.0, 1658.0],
                        [5479.0, 1655.0]
                    ]
                ],
                [
                    [
                        [6492.0, 1716.0],
                        [6499.0, 1707.0],
                        [6493.0, 1698.0],
                        [6480.0, 1707.0],
                        [6492.0, 1716.0]
                    ]
                ],
                [
                    [
                        [6275.0, 1718.0],
                        [6258.0, 1697.0],
                        [6230.0, 1701.0],
                        [6220.0, 1716.0],
                        [6275.0, 1718.0]
                    ]
                ],
                [
                    [
                        [6630.0, 1768.0],
                        [6625.0, 1735.0],
                        [6602.0, 1705.0],
                        [6587.0, 1733.0],
                        [6630.0, 1768.0]
                    ]
                ],
                [
                    [
                        [5369.0, 1743.0],
                        [5379.0, 1736.0],
                        [5338.0, 1717.0],
                        [5280.0, 1720.0],
                        [5287.0, 1738.0],
                        [5369.0, 1743.0]
                    ]
                ],
                [
                    [
                        [5830.0, 1788.0],
                        [5825.0, 1832.0],
                        [5828.0, 1838.0],
                        [5833.0, 1823.0],
                        [5830.0, 1788.0]
                    ]
                ],
                [
                    [
                        [6698.0, 1874.0],
                        [6703.0, 1866.0],
                        [6699.0, 1855.0],
                        [6693.0, 1858.0],
                        [6698.0, 1874.0]
                    ]
                ],
                [
                    [
                        [6804.0, 1871.0],
                        [6828.0, 1897.0],
                        [6841.0, 1880.0],
                        [6839.0, 1834.0],
                        [6813.0, 1832.0],
                        [6797.0, 1853.0],
                        [6804.0, 1871.0]
                    ]
                ],
                [
                    [
                        [6719.0, 1877.0],
                        [6716.0, 1877.0],
                        [6723.0, 1901.0],
                        [6728.0, 1901.0],
                        [6719.0, 1877.0]
                    ]
                ],
                [
                    [
                        [5928.0, 1889.0],
                        [5938.0, 1882.0],
                        [5932.0, 1863.0],
                        [5920.0, 1877.0],
                        [5928.0, 1889.0]
                    ]
                ],
                [
                    [
                        [5988.0, 1901.0],
                        [5973.0, 1867.0],
                        [5954.0, 1870.0],
                        [5961.0, 1915.0],
                        [5985.0, 1923.0],
                        [5988.0, 1901.0]
                    ]
                ],
                [
                    [
                        [6018.0, 1922.0],
                        [6001.0, 1886.0],
                        [6020.0, 1877.0],
                        [5975.0, 1861.0],
                        [5986.0, 1880.0],
                        [5996.0, 1935.0],
                        [6018.0, 1922.0]
                    ]
                ],
                [
                    [
                        [6008.0, 1969.0],
                        [6020.0, 1963.0],
                        [6008.0, 1953.0],
                        [5998.0, 1965.0],
                        [6008.0, 1969.0]
                    ]
                ],
                [
                    [
                        [6384.0, 2010.0],
                        [6355.0, 1997.0],
                        [6358.0, 2010.0],
                        [6376.0, 2017.0],
                        [6384.0, 2010.0]
                    ]
                ],
                [
                    [
                        [5527.0, 1987.0],
                        [5511.0, 1947.0],
                        [5505.0, 1976.0],
                        [5522.0, 2007.0],
                        [5527.0, 1987.0]
                    ]
                ],
                [
                    [
                        [6275.0, 2041.0],
                        [6303.0, 2023.0],
                        [6302.0, 2007.0],
                        [6267.0, 1988.0],
                        [6226.0, 2005.0],
                        [6212.0, 2029.0],
                        [6242.0, 2043.0],
                        [6275.0, 2041.0]
                    ]
                ],
                [
                    [
                        [4402.0, 1975.0],
                        [4393.0, 1973.0],
                        [4379.0, 1985.0],
                        [4381.0, 1999.0],
                        [4402.0, 1975.0]
                    ]
                ],
                [
                    [
                        [4898.0, 2010.0],
                        [4909.0, 2032.0],
                        [4952.0, 2020.0],
                        [4949.0, 1993.0],
                        [4925.0, 1998.0],
                        [4908.0, 1984.0],
                        [4898.0, 2010.0]
                    ]
                ],
                [
                    [
                        [4379.0, 2000.0],
                        [4366.0, 1994.0],
                        [4363.0, 2019.0],
                        [4379.0, 2006.0],
                        [4379.0, 2000.0]
                    ]
                ],
                [
                    [
                        [4343.0, 2043.0],
                        [4354.0, 2028.0],
                        [4336.0, 2033.0],
                        [4334.0, 2051.0],
                        [4343.0, 2043.0]
                    ]
                ],
                [
                    [
                        [6216.0, 2085.0],
                        [6208.0, 2089.0],
                        [6200.0, 2111.0],
                        [6209.0, 2118.0],
                        [6216.0, 2085.0]
                    ]
                ],
                [
                    [
                        [6168.0, 2131.0],
                        [6209.0, 2133.0],
                        [6229.0, 2128.0],
                        [6169.0, 2120.0],
                        [6168.0, 2131.0]
                    ]
                ],
                [
                    [
                        [6519.0, 2150.0],
                        [6525.0, 2139.0],
                        [6512.0, 2125.0],
                        [6473.0, 2135.0],
                        [6519.0, 2150.0]
                    ]
                ],
                [
                    [
                        [6094.0, 2114.0],
                        [6094.0, 2137.0],
                        [6112.0, 2140.0],
                        [6161.0, 2125.0],
                        [6094.0, 2114.0]
                    ]
                ],
                [
                    [
                        [6882.0, 2170.0],
                        [6970.0, 2163.0],
                        [6982.0, 2157.0],
                        [6939.0, 2149.0],
                        [6882.0, 2170.0]
                    ]
                ],
                [
                    [
                        [4843.0, 2002.0],
                        [4790.0, 2010.0],
                        [4775.0, 2055.0],
                        [4740.0, 2057.0],
                        [4729.0, 2070.0],
                        [4759.0, 2100.0],
                        [4791.0, 2097.0],
                        [4816.0, 2036.0],
                        [4850.0, 2030.0],
                        [4843.0, 2002.0]
                    ]
                ],
                [
                    [
                        [6325.0, 2173.0],
                        [6360.0, 2153.0],
                        [6355.0, 2143.0],
                        [6307.0, 2147.0],
                        [6325.0, 2173.0]
                    ]
                ],
                [
                    [
                        [6033.0, 2148.0],
                        [5987.0, 2139.0],
                        [5988.0, 2167.0],
                        [6024.0, 2166.0],
                        [6033.0, 2148.0]
                    ]
                ],
                [
                    [
                        [4284.0, 2125.0],
                        [4310.0, 2067.0],
                        [4283.0, 2073.0],
                        [4261.0, 2106.0],
                        [4284.0, 2125.0]
                    ]
                ],
                [
                    [
                        [6549.0, 2209.0],
                        [6568.0, 2203.0],
                        [6562.0, 2176.0],
                        [6538.0, 2200.0],
                        [6549.0, 2209.0]
                    ]
                ],
                [
                    [
                        [6876.0, 2236.0],
                        [6906.0, 2234.0],
                        [6932.0, 2209.0],
                        [6912.0, 2199.0],
                        [6899.0, 2225.0],
                        [6876.0, 2236.0]
                    ]
                ],
                [
                    [
                        [4675.0, 2183.0],
                        [4685.0, 2174.0],
                        [4669.0, 2158.0],
                        [4662.0, 2171.0],
                        [4675.0, 2183.0]
                    ]
                ],
                [
                    [
                        [6296.0, 2229.0],
                        [6313.0, 2241.0],
                        [6321.0, 2218.0],
                        [6331.0, 2201.0],
                        [6296.0, 2229.0]
                    ]
                ],
                [
                    [
                        [5932.0, 2233.0],
                        [5932.0, 2224.0],
                        [5903.0, 2214.0],
                        [5916.0, 2227.0],
                        [5932.0, 2233.0]
                    ]
                ],
                [
                    [
                        [6532.0, 2240.0],
                        [6509.0, 2262.0],
                        [6548.0, 2270.0],
                        [6582.0, 2261.0],
                        [6578.0, 2244.0],
                        [6532.0, 2240.0]
                    ]
                ],
                [
                    [
                        [4253.0, 2165.0],
                        [4247.0, 2149.0],
                        [4240.0, 2152.0],
                        [4249.0, 2172.0],
                        [4253.0, 2165.0]
                    ]
                ],
                [
                    [
                        [4685.0, 2212.0],
                        [4697.0, 2193.0],
                        [4695.0, 2191.0],
                        [4675.0, 2190.0],
                        [4685.0, 2212.0]
                    ]
                ],
                [
                    [
                        [4602.0, 2268.0],
                        [4605.0, 2247.0],
                        [4594.0, 2256.0],
                        [4601.0, 2268.0],
                        [4602.0, 2268.0]
                    ]
                ],
                [
                    [
                        [4571.0, 2275.0],
                        [4575.0, 2261.0],
                        [4554.0, 2274.0],
                        [4554.0, 2283.0],
                        [4571.0, 2275.0]
                    ]
                ],
                [
                    [
                        [4636.0, 2274.0],
                        [4646.0, 2276.0],
                        [4659.0, 2265.0],
                        [4658.0, 2254.0],
                        [4636.0, 2274.0]
                    ]
                ],
                [
                    [
                        [4685.0, 2263.0],
                        [4672.0, 2280.0],
                        [4656.0, 2282.0],
                        [4681.0, 2292.0],
                        [4685.0, 2263.0]
                    ]
                ],
                [
                    [
                        [4168.0, 2295.0],
                        [4209.0, 2259.0],
                        [4194.0, 2229.0],
                        [4146.0, 2287.0],
                        [4168.0, 2295.0]
                    ]
                ],
                [
                    [
                        [4513.0, 2311.0],
                        [4531.0, 2306.0],
                        [4533.0, 2291.0],
                        [4506.0, 2302.0],
                        [4513.0, 2311.0]
                    ]
                ],
                [
                    [
                        [4475.0, 2344.0],
                        [4476.0, 2324.0],
                        [4466.0, 2319.0],
                        [4455.0, 2344.0],
                        [4475.0, 2344.0]
                    ]
                ],
                [
                    [
                        [6352.0, 2425.0],
                        [6381.0, 2451.0],
                        [6390.0, 2441.0],
                        [6377.0, 2410.0],
                        [6352.0, 2425.0]
                    ]
                ],
                [
                    [
                        [4061.0, 2389.0],
                        [4102.0, 2352.0],
                        [4046.0, 2380.0],
                        [4052.0, 2391.0],
                        [4061.0, 2389.0]
                    ]
                ],
                [
                    [
                        [4938.0, 2503.0],
                        [4940.0, 2475.0],
                        [4915.0, 2497.0],
                        [4932.0, 2514.0],
                        [4938.0, 2503.0]
                    ]
                ],
                [
                    [
                        [6242.0, 2541.0],
                        [6252.0, 2559.0],
                        [6246.0, 2581.0],
                        [6260.0, 2563.0],
                        [6242.0, 2541.0]
                    ]
                ],
                [
                    [
                        [6815.0, 1828.0],
                        [6820.0, 1824.0],
                        [6803.0, 1790.0],
                        [6794.0, 1800.0],
                        [6798.0, 1842.0],
                        [6815.0, 1829.0],
                        [6834.0, 1823.0],
                        [6846.0, 1825.0],
                        [6838.0, 1817.0],
                        [6815.0, 1828.0]
                    ]
                ],
                [
                    [
                        [5679.0, 1648.0],
                        [5730.0, 1659.0],
                        [5732.0, 1631.0],
                        [5692.0, 1613.0],
                        [5589.0, 1592.0],
                        [5571.0, 1598.0],
                        [5575.0, 1634.0],
                        [5617.0, 1638.0],
                        [5621.0, 1659.0],
                        [5665.0, 1665.0],
                        [5679.0, 1648.0]
                    ]
                ],
                [
                    [
                        [6088.0, 1593.0],
                        [6105.0, 1582.0],
                        [6118.0, 1605.0],
                        [6126.0, 1606.0],
                        [6150.0, 1622.0],
                        [6167.0, 1606.0],
                        [6162.0, 1585.0],
                        [6118.0, 1535.0],
                        [6051.0, 1519.0],
                        [6065.0, 1573.0],
                        [6088.0, 1593.0]
                    ]
                ],
                [
                    [
                        [5620.0, 2532.0],
                        [5603.0, 2519.0],
                        [5605.0, 2532.0],
                        [5608.0, 2532.0],
                        [5620.0, 2532.0]
                    ]
                ],
                [
                    [
                        [4633.0, 2131.0],
                        [4672.0, 2132.0],
                        [4685.0, 2075.0],
                        [4711.0, 2045.0],
                        [4763.0, 2039.0],
                        [4798.0, 1979.0],
                        [4781.0, 1949.0],
                        [4790.0, 1938.0],
                        [4783.0, 1797.0],
                        [4749.0, 1821.0],
                        [4736.0, 1798.0],
                        [4700.0, 1818.0],
                        [4708.0, 1788.0],
                        [4677.0, 1806.0],
                        [4633.0, 1854.0],
                        [4577.0, 1884.0],
                        [4532.0, 1918.0],
                        [4525.0, 1943.0],
                        [4482.0, 1969.0],
                        [4443.0, 2014.0],
                        [4426.0, 2053.0],
                        [4390.0, 2106.0],
                        [4382.0, 2137.0],
                        [4346.0, 2173.0],
                        [4330.0, 2200.0],
                        [4296.0, 2211.0],
                        [4292.0, 2236.0],
                        [4249.0, 2327.0],
                        [4186.0, 2359.0],
                        [4181.0, 2391.0],
                        [4119.0, 2451.0],
                        [4095.0, 2455.0],
                        [4021.0, 2524.0],
                        [4000.0, 2577.0],
                        [4052.0, 2573.0],
                        [4070.0, 2558.0],
                        [4167.0, 2559.0],
                        [4198.0, 2534.0],
                        [4205.0, 2510.0],
                        [4225.0, 2502.0],
                        [4228.0, 2478.0],
                        [4333.0, 2418.0],
                        [4393.0, 2348.0],
                        [4414.0, 2337.0],
                        [4427.0, 2359.0],
                        [4452.0, 2323.0],
                        [4505.0, 2297.0],
                        [4513.0, 2284.0],
                        [4512.0, 2299.0],
                        [4531.0, 2288.0],
                        [4531.0, 2276.0],
                        [4532.0, 2280.0],
                        [4575.0, 2256.0],
                        [4538.0, 2256.0],
                        [4527.0, 2262.0],
                        [4531.0, 2255.0],
                        [4561.0, 2253.0],
                        [4577.0, 2235.0],
                        [4600.0, 2239.0],
                        [4627.0, 2203.0],
                        [4601.0, 2187.0],
                        [4626.0, 2179.0],
                        [4597.0, 2153.0],
                        [4633.0, 2131.0]
                    ],
                    [
                        [4519.0, 2275.0],
                        [4527.0, 2262.0],
                        [4529.0, 2269.0],
                        [4519.0, 2275.0]
                    ]
                ],
                [
                    [
                        [7106.0, 1837.0],
                        [7076.0, 1906.0],
                        [7014.0, 1933.0],
                        [6986.0, 1938.0],
                        [6924.0, 1964.0],
                        [6871.0, 1967.0],
                        [6806.0, 2006.0],
                        [6806.0, 1996.0],
                        [6753.0, 2026.0],
                        [6730.0, 1990.0],
                        [6710.0, 1986.0],
                        [6692.0, 2015.0],
                        [6706.0, 2025.0],
                        [6662.0, 2066.0],
                        [6637.0, 2068.0],
                        [6652.0, 2085.0],
                        [6690.0, 2077.0],
                        [6711.0, 2101.0],
                        [6767.0, 2091.0],
                        [6778.0, 2109.0],
                        [6729.0, 2121.0],
                        [6686.0, 2113.0],
                        [6642.0, 2125.0],
                        [6621.0, 2166.0],
                        [6561.0, 2169.0],
                        [6579.0, 2214.0],
                        [6625.0, 2225.0],
                        [6639.0, 2241.0],
                        [6682.0, 2250.0],
                        [6732.0, 2226.0],
                        [6773.0, 2227.0],
                        [6797.0, 2184.0],
                        [6790.0, 2142.0],
                        [6790.0, 2116.0],
                        [6813.0, 2078.0],
                        [6821.0, 2108.0],
                        [6830.0, 2071.0],
                        [6851.0, 2046.0],
                        [6886.0, 2045.0],
                        [6941.0, 2103.0],
                        [6949.0, 2128.0],
                        [7008.0, 2140.0],
                        [7001.0, 2160.0],
                        [7046.0, 2183.0],
                        [7196.0, 2126.0],
                        [7217.0, 2130.0],
                        [7275.0, 2112.0],
                        [7291.0, 1652.0],
                        [7215.0, 1720.0],
                        [7137.0, 1715.0],
                        [7139.0, 1721.0],
                        [7128.0, 1712.0],
                        [7137.0, 1712.0],
                        [7142.0, 1700.0],
                        [7118.0, 1698.0],
                        [7125.0, 1710.0],
                        [7110.0, 1697.0],
                        [7052.0, 1692.0],
                        [7078.0, 1751.0],
                        [7133.0, 1769.0],
                        [7152.0, 1756.0],
                        [7147.0, 1740.0],
                        [7154.0, 1757.0],
                        [7124.0, 1782.0],
                        [7124.0, 1822.0],
                        [7106.0, 1837.0]
                    ]
                ],
                [
                    [
                        [5596.0, 2531.0],
                        [5610.0, 2495.0],
                        [5563.0, 2494.0],
                        [5606.0, 2479.0],
                        [5582.0, 2465.0],
                        [5602.0, 2456.0],
                        [5638.0, 2399.0],
                        [5622.0, 2372.0],
                        [5706.0, 2309.0],
                        [5691.0, 2298.0],
                        [5639.0, 2305.0],
                        [5621.0, 2296.0],
                        [5599.0, 2245.0],
                        [5598.0, 2200.0],
                        [5611.0, 2182.0],
                        [5588.0, 2180.0],
                        [5570.0, 2152.0],
                        [5537.0, 2131.0],
                        [5526.0, 2110.0],
                        [5543.0, 2078.0],
                        [5501.0, 1979.0],
                        [5407.0, 1936.0],
                        [5396.0, 1984.0],
                        [5364.0, 1992.0],
                        [5335.0, 1984.0],
                        [5291.0, 2020.0],
                        [5291.0, 2003.0],
                        [5263.0, 1984.0],
                        [5240.0, 1991.0],
                        [5207.0, 1973.0],
                        [5199.0, 2025.0],
                        [5123.0, 2003.0],
                        [5095.0, 2008.0],
                        [5066.0, 2141.0],
                        [5044.0, 2148.0],
                        [5056.0, 2139.0],
                        [5035.0, 2126.0],
                        [5032.0, 2147.0],
                        [5042.0, 2149.0],
                        [5019.0, 2157.0],
                        [5023.0, 2176.0],
                        [5001.0, 2199.0],
                        [5019.0, 2218.0],
                        [4991.0, 2240.0],
                        [4985.0, 2275.0],
                        [5000.0, 2327.0],
                        [5038.0, 2365.0],
                        [5030.0, 2351.0],
                        [5054.0, 2318.0],
                        [5106.0, 2280.0],
                        [5151.0, 2298.0],
                        [5195.0, 2295.0],
                        [5220.0, 2327.0],
                        [5279.0, 2335.0],
                        [5325.0, 2315.0],
                        [5343.0, 2331.0],
                        [5385.0, 2332.0],
                        [5407.0, 2365.0],
                        [5402.0, 2389.0],
                        [5432.0, 2409.0],
                        [5421.0, 2431.0],
                        [5449.0, 2446.0],
                        [5458.0, 2476.0],
                        [5452.0, 2508.0],
                        [5473.0, 2543.0],
                        [5512.0, 2538.0],
                        [5570.0, 2544.0],
                        [5596.0, 2531.0]
                    ]
                ],
                [
                    [
                        [5963.0, 1639.0],
                        [6009.0, 1671.0],
                        [5999.0, 1642.0],
                        [5928.0, 1620.0],
                        [5900.0, 1625.0],
                        [5866.0, 1615.0],
                        [5843.0, 1623.0],
                        [5795.0, 1616.0],
                        [5770.0, 1635.0],
                        [5814.0, 1658.0],
                        [5869.0, 1657.0],
                        [5907.0, 1639.0],
                        [5942.0, 1653.0],
                        [5963.0, 1639.0]
                    ]
                ],
                [
                    [
                        [5322.0, 1677.0],
                        [5373.0, 1690.0],
                        [5405.0, 1676.0],
                        [5399.0, 1635.0],
                        [5417.0, 1610.0],
                        [5372.0, 1619.0],
                        [5316.0, 1642.0],
                        [5279.0, 1628.0],
                        [5216.0, 1640.0],
                        [5208.0, 1631.0],
                        [5122.0, 1647.0],
                        [5090.0, 1662.0],
                        [5007.0, 1678.0],
                        [4969.0, 1662.0],
                        [4903.0, 1683.0],
                        [4840.0, 1687.0],
                        [4840.0, 1717.0],
                        [4798.0, 1727.0],
                        [4748.0, 1724.0],
                        [4743.0, 1735.0],
                        [4762.0, 1727.0],
                        [4788.0, 1754.0],
                        [4803.0, 1794.0],
                        [4870.0, 1782.0],
                        [4873.0, 1794.0],
                        [4949.0, 1767.0],
                        [4967.0, 1774.0],
                        [4986.0, 1738.0],
                        [5119.0, 1729.0],
                        [5132.0, 1761.0],
                        [5150.0, 1769.0],
                        [5167.0, 1749.0],
                        [5191.0, 1755.0],
                        [5232.0, 1737.0],
                        [5270.0, 1738.0],
                        [5283.0, 1693.0],
                        [5322.0, 1677.0]
                    ]
                ],
                [
                    [
                        [6538.0, 2050.0],
                        [6560.0, 2019.0],
                        [6558.0, 1998.0],
                        [6465.0, 2035.0],
                        [6461.0, 2023.0],
                        [6417.0, 2040.0],
                        [6390.0, 2020.0],
                        [6364.0, 2047.0],
                        [6351.0, 2013.0],
                        [6351.0, 2050.0],
                        [6367.0, 2062.0],
                        [6434.0, 2058.0],
                        [6456.0, 2071.0],
                        [6538.0, 2050.0]
                    ]
                ],
                [
                    [
                        [6026.0, 2199.0],
                        [6017.0, 2178.0],
                        [5981.0, 2186.0],
                        [5951.0, 2144.0],
                        [5911.0, 2127.0],
                        [5904.0, 2113.0],
                        [5876.0, 2121.0],
                        [5950.0, 2043.0],
                        [5948.0, 1991.0],
                        [5996.0, 1955.0],
                        [5992.0, 1938.0],
                        [5940.0, 1930.0],
                        [5932.0, 1906.0],
                        [5896.0, 1919.0],
                        [5904.0, 1959.0],
                        [5851.0, 1996.0],
                        [5862.0, 2052.0],
                        [5840.0, 2061.0],
                        [5801.0, 2036.0],
                        [5814.0, 2018.0],
                        [5814.0, 1967.0],
                        [5822.0, 1918.0],
                        [5810.0, 1881.0],
                        [5815.0, 1855.0],
                        [5762.0, 1843.0],
                        [5746.0, 1864.0],
                        [5763.0, 1938.0],
                        [5737.0, 2000.0],
                        [5711.0, 1989.0],
                        [5699.0, 2039.0],
                        [5724.0, 2069.0],
                        [5736.0, 2103.0],
                        [5734.0, 2156.0],
                        [5761.0, 2198.0],
                        [5763.0, 2260.0],
                        [5781.0, 2296.0],
                        [5817.0, 2300.0],
                        [5840.0, 2342.0],
                        [5881.0, 2327.0],
                        [6049.0, 2312.0],
                        [6102.0, 2340.0],
                        [6099.0, 2351.0],
                        [6140.0, 2379.0],
                        [6124.0, 2325.0],
                        [6085.0, 2283.0],
                        [6008.0, 2275.0],
                        [5996.0, 2288.0],
                        [5906.0, 2278.0],
                        [5898.0, 2285.0],
                        [5841.0, 2276.0],
                        [5804.0, 2278.0],
                        [5779.0, 2229.0],
                        [5787.0, 2198.0],
                        [5810.0, 2181.0],
                        [5830.0, 2147.0],
                        [5859.0, 2146.0],
                        [5887.0, 2187.0],
                        [5931.0, 2184.0],
                        [5937.0, 2195.0],
                        [5991.0, 2200.0],
                        [6010.0, 2212.0],
                        [6026.0, 2199.0]
                    ]
                ],
                [
                    [
                        [6372.0, 2198.0],
                        [6324.0, 2247.0],
                        [6318.0, 2321.0],
                        [6302.0, 2349.0],
                        [6313.0, 2386.0],
                        [6336.0, 2417.0],
                        [6346.0, 2372.0],
                        [6319.0, 2333.0],
                        [6331.0, 2320.0],
                        [6376.0, 2374.0],
                        [6394.0, 2376.0],
                        [6394.0, 2341.0],
                        [6367.0, 2328.0],
                        [6368.0, 2312.0],
                        [6394.0, 2304.0],
                        [6408.0, 2283.0],
                        [6343.0, 2298.0],
                        [6339.0, 2262.0],
                        [6372.0, 2198.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.510000,
            "hc-middl_1": 0.590000,
            "hc-key": "sg",
            "hc-a2": "SG",
            "name": "Singapore",
            "labelrank": "6",
            "country-ab": "Sing.",
            "subregion": "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "SGP",
            "iso-a2": "SG",
            "woe-id": "23424948",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [4629.0, 2305.0],
                        [4639.0, 2302.0],
                        [4628.0, 2293.0],
                        [4614.0, 2296.0],
                        [4629.0, 2305.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.550000,
            "hc-middl_1": 0.510000,
            "hc-key": "ru",
            "hc-a2": "RU",
            "name": "Russia",
            "labelrank": "2",
            "country-ab": "Rus.",
            "subregion": "Eastern Europe",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "RUS",
            "iso-a2": "RU",
            "woe-id": "23424936",
            "continent": "Europe"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [7532.0, 5673.0],
                        [7495.0, 5630.0],
                        [7490.0, 5638.0],
                        [7516.0, 5679.0],
                        [7532.0, 5673.0]
                    ]
                ],
                [
                    [
                        [7705.0, 5758.0],
                        [7627.0, 5727.0],
                        [7576.0, 5674.0],
                        [7570.0, 5679.0],
                        [7640.0, 5746.0],
                        [7691.0, 5772.0],
                        [7705.0, 5758.0]
                    ]
                ],
                [
                    [
                        [7827.0, 5842.0],
                        [7802.0, 5814.0],
                        [7749.0, 5782.0],
                        [7802.0, 5836.0],
                        [7827.0, 5842.0]
                    ]
                ],
                [
                    [
                        [7940.0, 5927.0],
                        [7947.0, 5927.0],
                        [7913.0, 5892.0],
                        [7915.0, 5901.0],
                        [7940.0, 5927.0]
                    ]
                ],
                [
                    [
                        [8122.0, 6160.0],
                        [8120.0, 6134.0],
                        [8112.0, 6126.0],
                        [8104.0, 6136.0],
                        [8122.0, 6160.0]
                    ]
                ],
                [
                    [
                        [8208.0, 6243.0],
                        [8192.0, 6220.0],
                        [8146.0, 6200.0],
                        [8143.0, 6222.0],
                        [8180.0, 6235.0],
                        [8204.0, 6270.0],
                        [8208.0, 6243.0]
                    ]
                ],
                [
                    [
                        [8228.0, 6259.0],
                        [8212.0, 6261.0],
                        [8226.0, 6279.0],
                        [8235.0, 6269.0],
                        [8228.0, 6259.0]
                    ]
                ],
                [
                    [
                        [6847.0, 6637.0],
                        [6836.0, 6620.0],
                        [6812.0, 6618.0],
                        [6838.0, 6638.0],
                        [6847.0, 6637.0]
                    ]
                ],
                [
                    [
                        [6890.0, 6643.0],
                        [6914.0, 6631.0],
                        [6886.0, 6592.0],
                        [6870.0, 6617.0],
                        [6890.0, 6643.0]
                    ]
                ],
                [
                    [
                        [8890.0, 6735.0],
                        [8912.0, 6715.0],
                        [8941.0, 6686.0],
                        [8921.0, 6685.0],
                        [8890.0, 6735.0]
                    ]
                ],
                [
                    [
                        [8779.0, 7122.0],
                        [8784.0, 7088.0],
                        [8711.0, 7054.0],
                        [8736.0, 7104.0],
                        [8779.0, 7122.0]
                    ]
                ],
                [
                    [
                        [-375.0, 7458.0],
                        [-377.0, 7446.0],
                        [-393.0, 7438.0],
                        [-412.0, 7452.0],
                        [-375.0, 7458.0]
                    ]
                ],
                [
                    [
                        [1980.0, 7736.0],
                        [2037.0, 7725.0],
                        [2035.0, 7703.0],
                        [1999.0, 7712.0],
                        [1980.0, 7736.0]
                    ]
                ],
                [
                    [
                        [609.0, 7953.0],
                        [502.0, 7920.0],
                        [475.0, 7942.0],
                        [479.0, 7988.0],
                        [547.0, 8019.0],
                        [611.0, 7990.0],
                        [609.0, 7953.0]
                    ]
                ],
                [
                    [
                        [8510.0, 8302.0],
                        [8522.0, 8231.0],
                        [8495.0, 8244.0],
                        [8489.0, 8289.0],
                        [8510.0, 8302.0]
                    ]
                ],
                [
                    [
                        [1827.0, 8055.0],
                        [1814.0, 8045.0],
                        [1803.0, 8051.0],
                        [1828.0, 8073.0],
                        [1827.0, 8055.0]
                    ]
                ],
                [
                    [
                        [8513.0, 8286.0],
                        [8511.0, 8308.0],
                        [8528.0, 8306.0],
                        [8527.0, 8291.0],
                        [8513.0, 8286.0]
                    ]
                ],
                [
                    [
                        [9080.0, 8350.0],
                        [9042.0, 8323.0],
                        [8962.0, 8354.0],
                        [8997.0, 8380.0],
                        [9080.0, 8363.0],
                        [9080.0, 8350.0]
                    ]
                ],
                [
                    [
                        [1761.0, 8227.0],
                        [1774.0, 8184.0],
                        [1762.0, 8197.0],
                        [1757.0, 8215.0],
                        [1761.0, 8227.0]
                    ]
                ],
                [
                    [
                        [785.0, 8272.0],
                        [819.0, 8240.0],
                        [806.0, 8215.0],
                        [751.0, 8253.0],
                        [785.0, 8272.0]
                    ]
                ],
                [
                    [
                        [9826.0, 8533.0],
                        [9744.0, 8507.0],
                        [9728.0, 8536.0],
                        [9747.0, 8563.0],
                        [9823.0, 8604.0],
                        [9826.0, 8533.0]
                    ]
                ],
                [
                    [
                        [6831.0, 8506.0],
                        [6824.0, 8486.0],
                        [6771.0, 8498.0],
                        [6785.0, 8504.0],
                        [6831.0, 8506.0]
                    ]
                ],
                [
                    [
                        [2559.0, 8453.0],
                        [2498.0, 8449.0],
                        [2546.0, 8497.0],
                        [2602.0, 8480.0],
                        [2559.0, 8453.0]
                    ]
                ],
                [
                    [
                        [6219.0, 8644.0],
                        [6147.0, 8647.0],
                        [6194.0, 8665.0],
                        [6223.0, 8657.0],
                        [6219.0, 8644.0]
                    ]
                ],
                [
                    [
                        [2681.0, 8541.0],
                        [2684.0, 8516.0],
                        [2614.0, 8530.0],
                        [2652.0, 8563.0],
                        [2681.0, 8541.0]
                    ]
                ],
                [
                    [
                        [2347.0, 8552.0],
                        [2321.0, 8525.0],
                        [2294.0, 8542.0],
                        [2302.0, 8554.0],
                        [2347.0, 8552.0]
                    ]
                ],
                [
                    [
                        [5541.0, 8656.0],
                        [5530.0, 8666.0],
                        [5556.0, 8675.0],
                        [5571.0, 8658.0],
                        [5541.0, 8656.0]
                    ]
                ],
                [
                    [
                        [2088.0, 8569.0],
                        [2100.0, 8555.0],
                        [1994.0, 8532.0],
                        [1999.0, 8582.0],
                        [2068.0, 8601.0],
                        [2088.0, 8569.0]
                    ]
                ],
                [
                    [
                        [2438.0, 8620.0],
                        [2413.0, 8604.0],
                        [2392.0, 8603.0],
                        [2400.0, 8617.0],
                        [2438.0, 8620.0]
                    ]
                ],
                [
                    [
                        [2901.0, 8709.0],
                        [2934.0, 8719.0],
                        [2962.0, 8715.0],
                        [2950.0, 8703.0],
                        [2901.0, 8709.0]
                    ]
                ],
                [
                    [
                        [6668.0, 8852.0],
                        [6705.0, 8828.0],
                        [6697.0, 8812.0],
                        [6646.0, 8850.0],
                        [6668.0, 8852.0]
                    ]
                ],
                [
                    [
                        [7010.0, 8828.0],
                        [6986.0, 8870.0],
                        [7033.0, 8880.0],
                        [7045.0, 8842.0],
                        [7010.0, 8828.0]
                    ]
                ],
                [
                    [
                        [5077.0, 8822.0],
                        [5037.0, 8784.0],
                        [4942.0, 8816.0],
                        [4980.0, 8845.0],
                        [5073.0, 8840.0],
                        [5077.0, 8822.0]
                    ]
                ],
                [
                    [
                        [3097.0, 8774.0],
                        [3084.0, 8768.0],
                        [3072.0, 8778.0],
                        [3099.0, 8784.0],
                        [3097.0, 8774.0]
                    ]
                ],
                [
                    [
                        [3131.0, 8786.0],
                        [3147.0, 8780.0],
                        [3119.0, 8766.0],
                        [3108.0, 8770.0],
                        [3131.0, 8786.0]
                    ]
                ],
                [
                    [
                        [3210.0, 8842.0],
                        [3198.0, 8825.0],
                        [3152.0, 8826.0],
                        [3167.0, 8845.0],
                        [3210.0, 8842.0]
                    ]
                ],
                [
                    [
                        [2849.0, 8857.0],
                        [2835.0, 8881.0],
                        [2810.0, 8889.0],
                        [2856.0, 8911.0],
                        [2849.0, 8857.0]
                    ]
                ],
                [
                    [
                        [6669.0, 9024.0],
                        [6641.0, 9022.0],
                        [6655.0, 9093.0],
                        [6690.0, 9061.0],
                        [6669.0, 9024.0]
                    ]
                ],
                [
                    [
                        [3887.0, 9056.0],
                        [3863.0, 9039.0],
                        [3785.0, 9043.0],
                        [3821.0, 9059.0],
                        [3887.0, 9056.0]
                    ]
                ],
                [
                    [
                        [5006.0, 9147.0],
                        [5014.0, 9124.0],
                        [5003.0, 9123.0],
                        [4966.0, 9147.0],
                        [5006.0, 9147.0]
                    ]
                ],
                [
                    [
                        [3824.0, 9110.0],
                        [3848.0, 9120.0],
                        [3865.0, 9121.0],
                        [3850.0, 9106.0],
                        [3824.0, 9110.0]
                    ]
                ],
                [
                    [
                        [7615.0, 9240.0],
                        [7558.0, 9237.0],
                        [7587.0, 9254.0],
                        [7625.0, 9261.0],
                        [7615.0, 9240.0]
                    ]
                ],
                [
                    [
                        [3332.0, 9144.0],
                        [3320.0, 9143.0],
                        [3309.0, 9157.0],
                        [3342.0, 9165.0],
                        [3332.0, 9144.0]
                    ]
                ],
                [
                    [
                        [3864.0, 9176.0],
                        [3824.0, 9167.0],
                        [3778.0, 9160.0],
                        [3867.0, 9195.0],
                        [3864.0, 9176.0]
                    ]
                ],
                [
                    [
                        [3385.0, 9172.0],
                        [3354.0, 9168.0],
                        [3341.0, 9179.0],
                        [3374.0, 9194.0],
                        [3385.0, 9172.0]
                    ]
                ],
                [
                    [
                        [4651.0, 9369.0],
                        [4638.0, 9351.0],
                        [4563.0, 9361.0],
                        [4598.0, 9369.0],
                        [4651.0, 9369.0]
                    ]
                ],
                [
                    [
                        [4587.0, 9388.0],
                        [4548.0, 9370.0],
                        [4533.0, 9373.0],
                        [4567.0, 9394.0],
                        [4587.0, 9388.0]
                    ]
                ],
                [
                    [
                        [2415.0, 9525.0],
                        [2509.0, 9510.0],
                        [2446.0, 9499.0],
                        [2408.0, 9512.0],
                        [2415.0, 9525.0]
                    ]
                ],
                [
                    [
                        [633.0, 9519.0],
                        [648.0, 9507.0],
                        [586.0, 9517.0],
                        [617.0, 9536.0],
                        [633.0, 9519.0]
                    ]
                ],
                [
                    [
                        [1171.0, 9525.0],
                        [1133.0, 9528.0],
                        [1223.0, 9561.0],
                        [1252.0, 9541.0],
                        [1171.0, 9525.0]
                    ]
                ],
                [
                    [
                        [549.0, 9527.0],
                        [512.0, 9542.0],
                        [538.0, 9555.0],
                        [561.0, 9555.0],
                        [549.0, 9527.0]
                    ]
                ],
                [
                    [
                        [1049.0, 9591.0],
                        [1040.0, 9545.0],
                        [952.0, 9548.0],
                        [970.0, 9587.0],
                        [1049.0, 9591.0]
                    ]
                ],
                [
                    [
                        [781.0, 9591.0],
                        [819.0, 9572.0],
                        [793.0, 9554.0],
                        [700.0, 9568.0],
                        [781.0, 9591.0]
                    ]
                ],
                [
                    [
                        [921.0, 9585.0],
                        [935.0, 9576.0],
                        [906.0, 9566.0],
                        [898.0, 9597.0],
                        [921.0, 9585.0]
                    ]
                ],
                [
                    [
                        [886.0, 9601.0],
                        [856.0, 9591.0],
                        [872.0, 9612.0],
                        [903.0, 9612.0],
                        [886.0, 9601.0]
                    ]
                ],
                [
                    [
                        [846.0, 9624.0],
                        [845.0, 9596.0],
                        [813.0, 9604.0],
                        [819.0, 9627.0],
                        [846.0, 9624.0]
                    ]
                ],
                [
                    [
                        [1180.0, 9672.0],
                        [1140.0, 9661.0],
                        [1099.0, 9672.0],
                        [1162.0, 9688.0],
                        [1180.0, 9672.0]
                    ]
                ],
                [
                    [
                        [923.0, 9673.0],
                        [967.0, 9664.0],
                        [889.0, 9648.0],
                        [825.0, 9664.0],
                        [923.0, 9673.0]
                    ]
                ],
                [
                    [
                        [2681.0, 9750.0],
                        [2696.0, 9734.0],
                        [2611.0, 9722.0],
                        [2618.0, 9747.0],
                        [2681.0, 9750.0]
                    ]
                ],
                [
                    [
                        [1149.0, 9696.0],
                        [1100.0, 9707.0],
                        [1113.0, 9721.0],
                        [1155.0, 9711.0],
                        [1149.0, 9696.0]
                    ]
                ],
                [
                    [
                        [1343.0, 9706.0],
                        [1255.0, 9709.0],
                        [1294.0, 9724.0],
                        [1370.0, 9730.0],
                        [1343.0, 9706.0]
                    ]
                ],
                [
                    [
                        [978.0, 9718.0],
                        [1016.0, 9718.0],
                        [1129.0, 9691.0],
                        [1052.0, 9684.0],
                        [978.0, 9718.0]
                    ]
                ],
                [
                    [
                        [596.0, 9693.0],
                        [567.0, 9687.0],
                        [577.0, 9712.0],
                        [609.0, 9703.0],
                        [596.0, 9693.0]
                    ]
                ],
                [
                    [
                        [3476.0, 9798.0],
                        [3381.0, 9799.0],
                        [3386.0, 9818.0],
                        [3484.0, 9818.0],
                        [3476.0, 9798.0]
                    ]
                ],
                [
                    [
                        [1087.0, 9724.0],
                        [1036.0, 9728.0],
                        [1099.0, 9743.0],
                        [1114.0, 9738.0],
                        [1087.0, 9724.0]
                    ]
                ],
                [
                    [
                        [1020.0, 9764.0],
                        [1094.0, 9748.0],
                        [953.0, 9728.0],
                        [927.0, 9751.0],
                        [1004.0, 9741.0],
                        [1020.0, 9764.0]
                    ]
                ],
                [
                    [
                        [1208.0, 9740.0],
                        [1141.0, 9758.0],
                        [1179.0, 9773.0],
                        [1199.0, 9767.0],
                        [1208.0, 9740.0]
                    ]
                ],
                [
                    [
                        [1091.0, 9792.0],
                        [1147.0, 9773.0],
                        [1092.0, 9766.0],
                        [1018.0, 9775.0],
                        [1091.0, 9792.0]
                    ]
                ],
                [
                    [
                        [1176.0, 9830.0],
                        [1104.0, 9819.0],
                        [1102.0, 9841.0],
                        [1190.0, 9851.0],
                        [1176.0, 9830.0]
                    ]
                ],
                [
                    [
                        [2874.0, 8975.0],
                        [2881.0, 8981.0],
                        [2930.0, 8978.0],
                        [2874.0, 8975.0],
                        [2874.0, 8975.0]
                    ]
                ],
                [
                    [
                        [1415.0, 9824.0],
                        [1435.0, 9836.0],
                        [1508.0, 9834.0],
                        [1494.0, 9815.0],
                        [1415.0, 9824.0],
                        [1415.0, 9824.0]
                    ]
                ],
                [
                    [
                        [1144.0, 9615.0],
                        [1202.0, 9596.0],
                        [1119.0, 9580.0],
                        [1143.0, 9565.0],
                        [1073.0, 9556.0],
                        [1037.0, 9613.0],
                        [1144.0, 9615.0]
                    ]
                ],
                [
                    [
                        [3465.0, 9595.0],
                        [3476.0, 9610.0],
                        [3514.0, 9631.0],
                        [3653.0, 9614.0],
                        [3576.0, 9570.0],
                        [3538.0, 9591.0],
                        [3465.0, 9595.0]
                    ]
                ],
                [
                    [
                        [2874.0, 8975.0],
                        [2860.0, 8963.0],
                        [2861.0, 8974.0],
                        [2874.0, 8975.0],
                        [2874.0, 8975.0]
                    ]
                ],
                [
                    [
                        [1415.0, 9824.0],
                        [1395.0, 9812.0],
                        [1397.0, 9826.0],
                        [1415.0, 9824.0],
                        [1415.0, 9824.0]
                    ]
                ],
                [
                    [
                        [496.0, 5970.0],
                        [452.0, 5910.0],
                        [445.0, 5864.0],
                        [463.0, 5853.0],
                        [426.0, 5779.0],
                        [469.0, 5768.0],
                        [474.0, 5727.0],
                        [540.0, 5725.0],
                        [575.0, 5694.0],
                        [611.0, 5638.0],
                        [572.0, 5627.0],
                        [628.0, 5599.0],
                        [556.0, 5544.0],
                        [516.0, 5540.0],
                        [488.0, 5474.0],
                        [455.0, 5427.0],
                        [494.0, 5408.0],
                        [521.0, 5370.0],
                        [513.0, 5306.0],
                        [596.0, 5208.0],
                        [547.0, 5152.0],
                        [504.0, 5159.0],
                        [465.0, 5204.0],
                        [443.0, 5206.0],
                        [385.0, 5233.0],
                        [389.0, 5257.0],
                        [329.0, 5277.0],
                        [264.0, 5257.0],
                        [254.0, 5273.0],
                        [154.0, 5311.0],
                        [92.0, 5309.0],
                        [28.0, 5333.0],
                        [-19.0, 5319.0],
                        [-19.0, 5319.0],
                        [-93.0, 5382.0],
                        [-151.0, 5402.0],
                        [-173.0, 5426.0],
                        [-266.0, 5468.0],
                        [-249.0, 5490.0],
                        [-229.0, 5473.0],
                        [-185.0, 5480.0],
                        [-195.0, 5511.0],
                        [-170.0, 5545.0],
                        [-129.0, 5554.0],
                        [-171.0, 5574.0],
                        [-189.0, 5601.0],
                        [-82.0, 5635.0],
                        [-82.0, 5657.0],
                        [-156.0, 5641.0],
                        [-148.0, 5686.0],
                        [-115.0, 5709.0],
                        [-49.0, 5710.0],
                        [-34.0, 5751.0],
                        [-58.0, 5818.0],
                        [-26.0, 5840.0],
                        [-96.0, 5894.0],
                        [-169.0, 5910.0],
                        [-181.0, 5895.0],
                        [-222.0, 5942.0],
                        [-281.0, 5920.0],
                        [-317.0, 5939.0],
                        [-346.0, 5930.0],
                        [-391.0, 6007.0],
                        [-456.0, 6011.0],
                        [-465.0, 6077.0],
                        [-487.0, 6115.0],
                        [-549.0, 6103.0],
                        [-590.0, 6108.0],
                        [-621.0, 6080.0],
                        [-645.0, 6105.0],
                        [-659.0, 6190.0],
                        [-611.0, 6180.0],
                        [-567.0, 6216.0],
                        [-587.0, 6242.0],
                        [-638.0, 6248.0],
                        [-634.0, 6274.0],
                        [-669.0, 6290.0],
                        [-682.0, 6328.0],
                        [-710.0, 6343.0],
                        [-695.0, 6367.0],
                        [-705.0, 6424.0],
                        [-778.0, 6444.0],
                        [-807.0, 6429.0],
                        [-813.0, 6455.0],
                        [-891.0, 6462.0],
                        [-904.0, 6511.0],
                        [-941.0, 6541.0],
                        [-927.0, 6587.0],
                        [-963.0, 6610.0],
                        [-951.0, 6639.0],
                        [-907.0, 6661.0],
                        [-954.0, 6683.0],
                        [-935.0, 6708.0],
                        [-942.0, 6764.0],
                        [-919.0, 6848.0],
                        [-856.0, 6853.0],
                        [-843.0, 6872.0],
                        [-770.0, 6862.0],
                        [-795.0, 6891.0],
                        [-884.0, 6906.0],
                        [-880.0, 6950.0],
                        [-942.0, 6927.0],
                        [-845.0, 7006.0],
                        [-747.0, 7112.0],
                        [-705.0, 7148.0],
                        [-683.0, 7194.0],
                        [-709.0, 7225.0],
                        [-799.0, 7284.0],
                        [-760.0, 7339.0],
                        [-798.0, 7358.0],
                        [-798.0, 7403.0],
                        [-832.0, 7426.0],
                        [-816.0, 7451.0],
                        [-827.0, 7500.0],
                        [-799.0, 7504.0],
                        [-815.0, 7557.0],
                        [-875.0, 7641.0],
                        [-875.0, 7660.0],
                        [-814.0, 7746.0],
                        [-866.0, 7792.0],
                        [-911.0, 7806.0],
                        [-927.0, 7847.0],
                        [-904.0, 7884.0],
                        [-929.0, 7891.0],
                        [-828.0, 7952.0],
                        [-802.0, 7986.0],
                        [-762.0, 7976.0],
                        [-764.0, 8011.0],
                        [-694.0, 7999.0],
                        [-678.0, 8034.0],
                        [-601.0, 7998.0],
                        [-669.0, 7995.0],
                        [-642.0, 7978.0],
                        [-397.0, 7945.0],
                        [-273.0, 7891.0],
                        [-218.0, 7849.0],
                        [-105.0, 7811.0],
                        [-32.0, 7775.0],
                        [-4.0, 7693.0],
                        [-67.0, 7618.0],
                        [-144.0, 7583.0],
                        [-244.0, 7574.0],
                        [-319.0, 7595.0],
                        [-427.0, 7607.0],
                        [-468.0, 7629.0],
                        [-563.0, 7639.0],
                        [-651.0, 7684.0],
                        [-600.0, 7614.0],
                        [-488.0, 7569.0],
                        [-458.0, 7522.0],
                        [-489.0, 7482.0],
                        [-451.0, 7423.0],
                        [-462.0, 7388.0],
                        [-416.0, 7359.0],
                        [-388.0, 7366.0],
                        [-352.0, 7330.0],
                        [-280.0, 7310.0],
                        [-231.0, 7328.0],
                        [-232.0, 7369.0],
                        [-295.0, 7376.0],
                        [-345.0, 7434.0],
                        [-306.0, 7465.0],
                        [-231.0, 7431.0],
                        [-122.0, 7399.0],
                        [-102.0, 7415.0],
                        [-91.0, 7412.0],
                        [-102.0, 7417.0],
                        [-74.0, 7418.0],
                        [-58.0, 7404.0],
                        [-66.0, 7404.0],
                        [-54.0, 7401.0],
                        [-66.0, 7444.0],
                        [-115.0, 7498.0],
                        [-108.0, 7522.0],
                        [-40.0, 7570.0],
                        [-2.0, 7580.0],
                        [57.0, 7637.0],
                        [83.0, 7621.0],
                        [132.0, 7629.0],
                        [200.0, 7566.0],
                        [195.0, 7616.0],
                        [219.0, 7660.0],
                        [203.0, 7709.0],
                        [169.0, 7719.0],
                        [195.0, 7851.0],
                        [128.0, 7893.0],
                        [269.0, 7889.0],
                        [315.0, 7878.0],
                        [373.0, 7807.0],
                        [276.0, 7789.0],
                        [249.0, 7739.0],
                        [296.0, 7721.0],
                        [315.0, 7689.0],
                        [367.0, 7682.0],
                        [448.0, 7707.0],
                        [452.0, 7775.0],
                        [519.0, 7797.0],
                        [686.0, 7898.0],
                        [760.0, 7911.0],
                        [755.0, 7886.0],
                        [797.0, 7899.0],
                        [765.0, 7915.0],
                        [845.0, 7956.0],
                        [887.0, 7948.0],
                        [867.0, 7924.0],
                        [887.0, 7886.0],
                        [950.0, 7868.0],
                        [954.0, 7895.0],
                        [1025.0, 7929.0],
                        [1123.0, 7921.0],
                        [1168.0, 7959.0],
                        [1232.0, 7980.0],
                        [1271.0, 7952.0],
                        [1250.0, 7906.0],
                        [1291.0, 7899.0],
                        [1297.0, 7940.0],
                        [1346.0, 7949.0],
                        [1376.0, 7975.0],
                        [1318.0, 8055.0],
                        [1342.0, 8074.0],
                        [1277.0, 8071.0],
                        [1267.0, 8093.0],
                        [1205.0, 8115.0],
                        [1200.0, 8147.0],
                        [1235.0, 8167.0],
                        [1259.0, 8152.0],
                        [1341.0, 8099.0],
                        [1342.0, 8074.0],
                        [1362.0, 8091.0],
                        [1495.0, 8082.0],
                        [1602.0, 8061.0],
                        [1717.0, 8006.0],
                        [1819.0, 7973.0],
                        [1901.0, 7920.0],
                        [1947.0, 7959.0],
                        [1958.0, 7997.0],
                        [1914.0, 7999.0],
                        [1880.0, 8063.0],
                        [1813.0, 8087.0],
                        [1791.0, 8075.0],
                        [1795.0, 8125.0],
                        [1824.0, 8218.0],
                        [1778.0, 8224.0],
                        [1793.0, 8293.0],
                        [1864.0, 8326.0],
                        [1901.0, 8368.0],
                        [1933.0, 8485.0],
                        [1975.0, 8510.0],
                        [2115.0, 8520.0],
                        [2206.0, 8495.0],
                        [2210.0, 8436.0],
                        [2167.0, 8348.0],
                        [2141.0, 8336.0],
                        [2202.0, 8282.0],
                        [2212.0, 8194.0],
                        [2189.0, 8173.0],
                        [2209.0, 8119.0],
                        [2196.0, 8094.0],
                        [2205.0, 8006.0],
                        [2283.0, 7954.0],
                        [2244.0, 7917.0],
                        [2251.0, 7858.0],
                        [2213.0, 7844.0],
                        [2188.0, 7788.0],
                        [2138.0, 7751.0],
                        [2143.0, 7725.0],
                        [2081.0, 7706.0],
                        [2019.0, 7740.0],
                        [1957.0, 7737.0],
                        [1969.0, 7714.0],
                        [2059.0, 7684.0],
                        [2114.0, 7689.0],
                        [2175.0, 7676.0],
                        [2209.0, 7723.0],
                        [2279.0, 7750.0],
                        [2306.0, 7808.0],
                        [2363.0, 7857.0],
                        [2359.0, 7917.0],
                        [2332.0, 7941.0],
                        [2339.0, 7980.0],
                        [2391.0, 8004.0],
                        [2474.0, 8022.0],
                        [2543.0, 7967.0],
                        [2533.0, 7873.0],
                        [2599.0, 7848.0],
                        [2665.0, 7858.0],
                        [2559.0, 7872.0],
                        [2561.0, 7918.0],
                        [2605.0, 7937.0],
                        [2568.0, 8012.0],
                        [2501.0, 8039.0],
                        [2412.0, 8053.0],
                        [2384.0, 8033.0],
                        [2287.0, 8039.0],
                        [2297.0, 8068.0],
                        [2268.0, 8109.0],
                        [2282.0, 8165.0],
                        [2321.0, 8210.0],
                        [2264.0, 8304.0],
                        [2226.0, 8327.0],
                        [2259.0, 8378.0],
                        [2358.0, 8418.0],
                        [2362.0, 8493.0],
                        [2382.0, 8516.0],
                        [2413.0, 8441.0],
                        [2384.0, 8401.0],
                        [2403.0, 8346.0],
                        [2382.0, 8327.0],
                        [2439.0, 8307.0],
                        [2565.0, 8299.0],
                        [2614.0, 8269.0],
                        [2600.0, 8316.0],
                        [2556.0, 8318.0],
                        [2459.0, 8351.0],
                        [2434.0, 8396.0],
                        [2501.0, 8416.0],
                        [2548.0, 8390.0],
                        [2585.0, 8397.0],
                        [2571.0, 8429.0],
                        [2538.0, 8421.0],
                        [2583.0, 8465.0],
                        [2673.0, 8468.0],
                        [2843.0, 8382.0],
                        [2923.0, 8397.0],
                        [2956.0, 8384.0],
                        [2938.0, 8348.0],
                        [2885.0, 8330.0],
                        [2895.0, 8265.0],
                        [2946.0, 8279.0],
                        [2939.0, 8220.0],
                        [2952.0, 8222.0],
                        [2948.0, 8249.0],
                        [2955.0, 8269.0],
                        [2959.0, 8249.0],
                        [2954.0, 8222.0],
                        [2993.0, 8228.0],
                        [2945.0, 8326.0],
                        [2978.0, 8375.0],
                        [2958.0, 8405.0],
                        [2873.0, 8436.0],
                        [2872.0, 8462.0],
                        [2803.0, 8468.0],
                        [2766.0, 8493.0],
                        [2774.0, 8544.0],
                        [2732.0, 8595.0],
                        [2770.0, 8633.0],
                        [2849.0, 8648.0],
                        [2958.0, 8651.0],
                        [3191.0, 8693.0],
                        [3220.0, 8654.0],
                        [3224.0, 8689.0],
                        [3151.0, 8764.0],
                        [3167.0, 8786.0],
                        [3113.0, 8793.0],
                        [3147.0, 8819.0],
                        [3200.0, 8793.0],
                        [3209.0, 8829.0],
                        [3350.0, 8918.0],
                        [3408.0, 8938.0],
                        [3662.0, 8987.0],
                        [3624.0, 9018.0],
                        [3735.0, 9021.0],
                        [3727.0, 9046.0],
                        [3826.0, 9035.0],
                        [3869.0, 8997.0],
                        [3966.0, 9018.0],
                        [4027.0, 9052.0],
                        [4102.0, 9031.0],
                        [4037.0, 9099.0],
                        [4082.0, 9092.0],
                        [4177.0, 9106.0],
                        [4203.0, 9141.0],
                        [4180.0, 9171.0],
                        [4266.0, 9239.0],
                        [4342.0, 9281.0],
                        [4448.0, 9291.0],
                        [4529.0, 9273.0],
                        [4532.0, 9202.0],
                        [4629.0, 9192.0],
                        [4645.0, 9177.0],
                        [4575.0, 9115.0],
                        [4674.0, 9123.0],
                        [4680.0, 9153.0],
                        [4851.0, 9162.0],
                        [4937.0, 9154.0],
                        [5018.0, 9110.0],
                        [5032.0, 9078.0],
                        [5075.0, 9080.0],
                        [5107.0, 9038.0],
                        [5094.0, 9000.0],
                        [5012.0, 9034.0],
                        [5030.0, 8997.0],
                        [5091.0, 8989.0],
                        [5090.0, 8955.0],
                        [5040.0, 8911.0],
                        [4988.0, 8893.0],
                        [4835.0, 8811.0],
                        [4831.0, 8792.0],
                        [4768.0, 8764.0],
                        [4704.0, 8709.0],
                        [4639.0, 8704.0],
                        [4605.0, 8660.0],
                        [4576.0, 8662.0],
                        [4525.0, 8584.0],
                        [4577.0, 8614.0],
                        [4585.0, 8644.0],
                        [4682.0, 8644.0],
                        [4905.0, 8723.0],
                        [4808.0, 8732.0],
                        [4841.0, 8766.0],
                        [5010.0, 8729.0],
                        [5061.0, 8757.0],
                        [5090.0, 8705.0],
                        [5226.0, 8738.0],
                        [5442.0, 8728.0],
                        [5445.0, 8676.0],
                        [5540.0, 8654.0],
                        [5765.0, 8644.0],
                        [5806.0, 8690.0],
                        [5784.0, 8713.0],
                        [5807.0, 8759.0],
                        [5860.0, 8773.0],
                        [6007.0, 8724.0],
                        [6053.0, 8744.0],
                        [6125.0, 8739.0],
                        [6119.0, 8719.0],
                        [6226.0, 8679.0],
                        [6144.0, 8660.0],
                        [6122.0, 8626.0],
                        [6144.0, 8620.0],
                        [6135.0, 8624.0],
                        [6171.0, 8629.0],
                        [6190.0, 8625.0],
                        [6175.0, 8612.0],
                        [6205.0, 8604.0],
                        [6235.0, 8574.0],
                        [6194.0, 8549.0],
                        [6116.0, 8594.0],
                        [6257.0, 8429.0],
                        [6338.0, 8383.0],
                        [6385.0, 8400.0],
                        [6451.0, 8533.0],
                        [6532.0, 8477.0],
                        [6592.0, 8471.0],
                        [6697.0, 8508.0],
                        [6847.0, 8460.0],
                        [6843.0, 8504.0],
                        [6894.0, 8516.0],
                        [6926.0, 8487.0],
                        [6985.0, 8497.0],
                        [6950.0, 8557.0],
                        [6971.0, 8590.0],
                        [6922.0, 8586.0],
                        [6945.0, 8632.0],
                        [7057.0, 8648.0],
                        [7018.0, 8688.0],
                        [7087.0, 8674.0],
                        [7362.0, 8655.0],
                        [7461.0, 8628.0],
                        [7360.0, 8626.0],
                        [7329.0, 8638.0],
                        [7293.0, 8601.0],
                        [7339.0, 8615.0],
                        [7471.0, 8626.0],
                        [7405.0, 8563.0],
                        [7352.0, 8559.0],
                        [7362.0, 8535.0],
                        [7419.0, 8558.0],
                        [7490.0, 8629.0],
                        [7576.0, 8629.0],
                        [7662.0, 8610.0],
                        [7696.0, 8581.0],
                        [7646.0, 8577.0],
                        [7621.0, 8550.0],
                        [7689.0, 8548.0],
                        [7684.0, 8520.0],
                        [7738.0, 8529.0],
                        [7809.0, 8503.0],
                        [7853.0, 8450.0],
                        [7956.0, 8451.0],
                        [8117.0, 8488.0],
                        [8234.0, 8489.0],
                        [8301.0, 8477.0],
                        [8385.0, 8441.0],
                        [8417.0, 8390.0],
                        [8389.0, 8341.0],
                        [8434.0, 8313.0],
                        [8477.0, 8313.0],
                        [8482.0, 8246.0],
                        [8527.0, 8226.0],
                        [8515.0, 8281.0],
                        [8576.0, 8319.0],
                        [8697.0, 8337.0],
                        [8755.0, 8313.0],
                        [8815.0, 8319.0],
                        [8905.0, 8310.0],
                        [8965.0, 8347.0],
                        [8997.0, 8321.0],
                        [9002.0, 8281.0],
                        [9075.0, 8265.0],
                        [9099.0, 8226.0],
                        [9188.0, 8256.0],
                        [9164.0, 8332.0],
                        [9163.0, 8397.0],
                        [9407.0, 8376.0],
                        [9514.0, 8376.0],
                        [9717.0, 8337.0],
                        [9835.0, 8277.0],
                        [9851.0, 7807.0],
                        [9816.0, 7778.0],
                        [9727.0, 7756.0],
                        [9661.0, 7774.0],
                        [9571.0, 7781.0],
                        [9621.0, 7743.0],
                        [9675.0, 7767.0],
                        [9673.0, 7727.0],
                        [9713.0, 7704.0],
                        [9733.0, 7721.0],
                        [9761.0, 7676.0],
                        [9759.0, 7615.0],
                        [9809.0, 7595.0],
                        [9833.0, 7539.0],
                        [9787.0, 7500.0],
                        [9670.0, 7519.0],
                        [9529.0, 7463.0],
                        [9473.0, 7428.0],
                        [9439.0, 7427.0],
                        [9300.0, 7318.0],
                        [9217.0, 7278.0],
                        [9190.0, 7219.0],
                        [9158.0, 7227.0],
                        [9139.0, 7263.0],
                        [9105.0, 7280.0],
                        [9024.0, 7277.0],
                        [8950.0, 7249.0],
                        [8885.0, 7193.0],
                        [8903.0, 7263.0],
                        [8815.0, 7218.0],
                        [8793.0, 7186.0],
                        [8769.0, 7219.0],
                        [8708.0, 7210.0],
                        [8678.0, 7152.0],
                        [8686.0, 7108.0],
                        [8626.0, 7061.0],
                        [8599.0, 7001.0],
                        [8638.0, 6968.0],
                        [8651.0, 6990.0],
                        [8695.0, 6965.0],
                        [8661.0, 6931.0],
                        [8660.0, 6868.0],
                        [8692.0, 6867.0],
                        [8704.0, 6810.0],
                        [8682.0, 6792.0],
                        [8648.0, 6817.0],
                        [8617.0, 6802.0],
                        [8593.0, 6749.0],
                        [8601.0, 6697.0],
                        [8622.0, 6675.0],
                        [8593.0, 6641.0],
                        [8523.0, 6641.0],
                        [8475.0, 6604.0],
                        [8461.0, 6541.0],
                        [8479.0, 6499.0],
                        [8448.0, 6514.0],
                        [8380.0, 6477.0],
                        [8357.0, 6387.0],
                        [8249.0, 6281.0],
                        [8235.0, 6318.0],
                        [8225.0, 6406.0],
                        [8199.0, 6474.0],
                        [8152.0, 6702.0],
                        [8157.0, 6765.0],
                        [8182.0, 6851.0],
                        [8225.0, 6881.0],
                        [8247.0, 6921.0],
                        [8232.0, 6956.0],
                        [8279.0, 6961.0],
                        [8387.0, 7028.0],
                        [8435.0, 7078.0],
                        [8444.0, 7105.0],
                        [8585.0, 7223.0],
                        [8587.0, 7246.0],
                        [8653.0, 7284.0],
                        [8715.0, 7304.0],
                        [8695.0, 7312.0],
                        [8732.0, 7351.0],
                        [8735.0, 7451.0],
                        [8764.0, 7473.0],
                        [8813.0, 7469.0],
                        [8767.0, 7498.0],
                        [8673.0, 7478.0],
                        [8681.0, 7457.0],
                        [8656.0, 7396.0],
                        [8661.0, 7367.0],
                        [8616.0, 7383.0],
                        [8587.0, 7349.0],
                        [8459.0, 7258.0],
                        [8478.0, 7308.0],
                        [8435.0, 7296.0],
                        [8430.0, 7329.0],
                        [8465.0, 7364.0],
                        [8468.0, 7407.0],
                        [8410.0, 7375.0],
                        [8398.0, 7399.0],
                        [8264.0, 7382.0],
                        [8209.0, 7352.0],
                        [8209.0, 7318.0],
                        [8152.0, 7264.0],
                        [8091.0, 7223.0],
                        [8041.0, 7168.0],
                        [8032.0, 7130.0],
                        [8095.0, 7131.0],
                        [8112.0, 7097.0],
                        [8063.0, 7100.0],
                        [8031.0, 7082.0],
                        [7982.0, 7100.0],
                        [7951.0, 7065.0],
                        [7910.0, 7078.0],
                        [7841.0, 7054.0],
                        [7821.0, 7080.0],
                        [7907.0, 7096.0],
                        [7868.0, 7102.0],
                        [7843.0, 7133.0],
                        [7780.0, 7118.0],
                        [7713.0, 7145.0],
                        [7658.0, 7119.0],
                        [7667.0, 7088.0],
                        [7594.0, 7102.0],
                        [7569.0, 7085.0],
                        [7481.0, 7099.0],
                        [7309.0, 7095.0],
                        [7194.0, 7060.0],
                        [7148.0, 7005.0],
                        [7100.0, 6979.0],
                        [7073.0, 6923.0],
                        [6946.0, 6830.0],
                        [6895.0, 6765.0],
                        [6816.0, 6693.0],
                        [6709.0, 6613.0],
                        [6747.0, 6582.0],
                        [6828.0, 6587.0],
                        [6816.0, 6510.0],
                        [6846.0, 6511.0],
                        [6842.0, 6544.0],
                        [6902.0, 6578.0],
                        [6861.0, 6535.0],
                        [6893.0, 6526.0],
                        [6864.0, 6485.0],
                        [6905.0, 6492.0],
                        [6950.0, 6533.0],
                        [6928.0, 6490.0],
                        [6946.0, 6489.0],
                        [6961.0, 6565.0],
                        [7006.0, 6554.0],
                        [7036.0, 6565.0],
                        [7070.0, 6527.0],
                        [7156.0, 6458.0],
                        [7135.0, 6442.0],
                        [7160.0, 6343.0],
                        [7124.0, 6310.0],
                        [7094.0, 6209.0],
                        [7111.0, 6164.0],
                        [7081.0, 6015.0],
                        [7028.0, 5964.0],
                        [6970.0, 5879.0],
                        [6942.0, 5810.0],
                        [6854.0, 5717.0],
                        [6806.0, 5651.0],
                        [6790.0, 5644.0],
                        [6740.0, 5565.0],
                        [6655.0, 5508.0],
                        [6601.0, 5490.0],
                        [6539.0, 5504.0],
                        [6539.0, 5542.0],
                        [6498.0, 5528.0],
                        [6428.0, 5450.0],
                        [6424.0, 5457.0],
                        [6415.0, 5470.0],
                        [6406.0, 5487.0],
                        [6455.0, 5504.0],
                        [6466.0, 5544.0],
                        [6463.0, 5603.0],
                        [6437.0, 5671.0],
                        [6471.0, 5682.0],
                        [6498.0, 5716.0],
                        [6511.0, 5707.0],
                        [6515.0, 5671.0],
                        [6539.0, 5647.0],
                        [6571.0, 5694.0],
                        [6591.0, 5701.0],
                        [6628.0, 5792.0],
                        [6643.0, 5803.0],
                        [6658.0, 5893.0],
                        [6701.0, 5935.0],
                        [6671.0, 5995.0],
                        [6580.0, 5967.0],
                        [6541.0, 5929.0],
                        [6434.0, 5923.0],
                        [6409.0, 5955.0],
                        [6418.0, 5982.0],
                        [6396.0, 6008.0],
                        [6406.0, 6030.0],
                        [6376.0, 6028.0],
                        [6321.0, 6077.0],
                        [6291.0, 6070.0],
                        [6270.0, 6090.0],
                        [6220.0, 6085.0],
                        [6178.0, 6110.0],
                        [6181.0, 6147.0],
                        [6164.0, 6156.0],
                        [6159.0, 6195.0],
                        [6133.0, 6224.0],
                        [6130.0, 6255.0],
                        [6095.0, 6309.0],
                        [6101.0, 6326.0],
                        [6041.0, 6403.0],
                        [5997.0, 6423.0],
                        [5946.0, 6424.0],
                        [5889.0, 6454.0],
                        [5798.0, 6444.0],
                        [5695.0, 6420.0],
                        [5637.0, 6368.0],
                        [5639.0, 6352.0],
                        [5687.0, 6348.0],
                        [5692.0, 6308.0],
                        [5646.0, 6264.0],
                        [5606.0, 6175.0],
                        [5582.0, 6140.0],
                        [5595.0, 6114.0],
                        [5548.0, 6100.0],
                        [5486.0, 6057.0],
                        [5409.0, 6083.0],
                        [5375.0, 6099.0],
                        [5315.0, 6086.0],
                        [5270.0, 6116.0],
                        [5237.0, 6119.0],
                        [5162.0, 6074.0],
                        [5151.0, 6052.0],
                        [5031.0, 6027.0],
                        [4988.0, 6005.0],
                        [4876.0, 6020.0],
                        [4832.0, 6017.0],
                        [4788.0, 6046.0],
                        [4788.0, 6071.0],
                        [4736.0, 6076.0],
                        [4695.0, 6105.0],
                        [4666.0, 6100.0],
                        [4600.0, 6115.0],
                        [4483.0, 6079.0],
                        [4387.0, 6114.0],
                        [4374.0, 6187.0],
                        [4317.0, 6197.0],
                        [4254.0, 6221.0],
                        [4218.0, 6220.0],
                        [4137.0, 6255.0],
                        [4126.0, 6228.0],
                        [4080.0, 6190.0],
                        [4064.0, 6146.0],
                        [4100.0, 6102.0],
                        [4088.0, 6059.0],
                        [4032.0, 6026.0],
                        [4008.0, 6040.0],
                        [3930.0, 6049.0],
                        [3905.0, 6037.0],
                        [3841.0, 6046.0],
                        [3812.0, 6096.0],
                        [3699.0, 6102.0],
                        [3674.0, 6117.0],
                        [3612.0, 6079.0],
                        [3583.0, 6075.0],
                        [3486.0, 6023.0],
                        [3491.0, 6005.0],
                        [3434.0, 5978.0],
                        [3385.0, 5977.0],
                        [3360.0, 5951.0],
                        [3340.0, 5946.0],
                        [3326.0, 5942.0],
                        [3272.0, 5986.0],
                        [3243.0, 5974.0],
                        [3178.0, 5983.0],
                        [3156.0, 6028.0],
                        [3104.0, 6043.0],
                        [3071.0, 6099.0],
                        [3043.0, 6109.0],
                        [2976.0, 6081.0],
                        [2904.0, 6080.0],
                        [2899.0, 6101.0],
                        [2847.0, 6132.0],
                        [2799.0, 6082.0],
                        [2760.0, 6146.0],
                        [2640.0, 6312.0],
                        [2543.0, 6376.0],
                        [2564.0, 6425.0],
                        [2466.0, 6377.0],
                        [2396.0, 6344.0],
                        [2370.0, 6334.0],
                        [2324.0, 6317.0],
                        [2309.0, 6338.0],
                        [2329.0, 6368.0],
                        [2265.0, 6383.0],
                        [2254.0, 6360.0],
                        [2226.0, 6383.0],
                        [2163.0, 6376.0],
                        [2160.0, 6437.0],
                        [2133.0, 6492.0],
                        [2089.0, 6475.0],
                        [1999.0, 6502.0],
                        [1951.0, 6476.0],
                        [1945.0, 6452.0],
                        [1791.0, 6413.0],
                        [1754.0, 6413.0],
                        [1738.0, 6385.0],
                        [1650.0, 6378.0],
                        [1587.0, 6354.0],
                        [1482.0, 6338.0],
                        [1453.0, 6343.0],
                        [1441.0, 6306.0],
                        [1456.0, 6271.0],
                        [1521.0, 6246.0],
                        [1447.0, 6237.0],
                        [1421.0, 6211.0],
                        [1448.0, 6181.0],
                        [1385.0, 6136.0],
                        [1431.0, 6113.0],
                        [1496.0, 6080.0],
                        [1477.0, 6035.0],
                        [1431.0, 6021.0],
                        [1381.0, 6038.0],
                        [1364.0, 6008.0],
                        [1303.0, 6019.0],
                        [1258.0, 6062.0],
                        [1220.0, 6058.0],
                        [1215.0, 6036.0],
                        [1177.0, 6054.0],
                        [1130.0, 6049.0],
                        [1072.0, 5997.0],
                        [998.0, 6041.0],
                        [987.0, 6024.0],
                        [904.0, 6083.0],
                        [845.0, 6078.0],
                        [832.0, 6105.0],
                        [793.0, 6078.0],
                        [707.0, 6088.0],
                        [692.0, 6058.0],
                        [627.0, 6035.0],
                        [627.0, 6011.0],
                        [575.0, 5984.0],
                        [592.0, 5933.0],
                        [560.0, 5913.0],
                        [496.0, 5970.0]
                    ]
                ],
                [
                    [
                        [870.0, 9714.0],
                        [933.0, 9697.0],
                        [968.0, 9705.0],
                        [1087.0, 9671.0],
                        [1044.0, 9648.0],
                        [1017.0, 9658.0],
                        [1035.0, 9643.0],
                        [957.0, 9635.0],
                        [928.0, 9648.0],
                        [1016.0, 9658.0],
                        [918.0, 9691.0],
                        [854.0, 9695.0],
                        [870.0, 9714.0]
                    ]
                ],
                [
                    [
                        [958.0, 8691.0],
                        [1020.0, 8698.0],
                        [967.0, 8721.0],
                        [1028.0, 8733.0],
                        [992.0, 8749.0],
                        [1047.0, 8765.0],
                        [1030.0, 8782.0],
                        [1071.0, 8831.0],
                        [1121.0, 8823.0],
                        [1108.0, 8850.0],
                        [1151.0, 8861.0],
                        [1204.0, 8911.0],
                        [1355.0, 8941.0],
                        [1353.0, 8969.0],
                        [1447.0, 8960.0],
                        [1563.0, 8982.0],
                        [1674.0, 9025.0],
                        [1767.0, 9083.0],
                        [1874.0, 9090.0],
                        [1909.0, 9064.0],
                        [1910.0, 9031.0],
                        [1869.0, 8998.0],
                        [1785.0, 8959.0],
                        [1380.0, 8832.0],
                        [1298.0, 8761.0],
                        [1276.0, 8728.0],
                        [1235.0, 8729.0],
                        [1225.0, 8700.0],
                        [1157.0, 8717.0],
                        [1197.0, 8670.0],
                        [1163.0, 8663.0],
                        [1130.0, 8597.0],
                        [1062.0, 8529.0],
                        [996.0, 8534.0],
                        [1039.0, 8525.0],
                        [1020.0, 8464.0],
                        [991.0, 8463.0],
                        [968.0, 8397.0],
                        [978.0, 8344.0],
                        [1024.0, 8261.0],
                        [1123.0, 8180.0],
                        [1022.0, 8172.0],
                        [979.0, 8193.0],
                        [961.0, 8167.0],
                        [912.0, 8195.0],
                        [827.0, 8203.0],
                        [840.0, 8230.0],
                        [892.0, 8238.0],
                        [832.0, 8257.0],
                        [821.0, 8280.0],
                        [722.0, 8276.0],
                        [687.0, 8330.0],
                        [719.0, 8369.0],
                        [758.0, 8361.0],
                        [782.0, 8437.0],
                        [769.0, 8466.0],
                        [818.0, 8470.0],
                        [806.0, 8506.0],
                        [931.0, 8548.0],
                        [952.0, 8544.0],
                        [937.0, 8551.0],
                        [867.0, 8539.0],
                        [902.0, 8573.0],
                        [837.0, 8591.0],
                        [919.0, 8625.0],
                        [958.0, 8691.0]
                    ]
                ],
                [
                    [
                        [1432.0, 9687.0],
                        [1474.0, 9710.0],
                        [1538.0, 9715.0],
                        [1584.0, 9753.0],
                        [1622.0, 9743.0],
                        [1638.0, 9707.0],
                        [1567.0, 9675.0],
                        [1475.0, 9662.0],
                        [1432.0, 9687.0]
                    ]
                ],
                [
                    [
                        [7288.0, 5914.0],
                        [7317.0, 5851.0],
                        [7250.0, 5857.0],
                        [7226.0, 5792.0],
                        [7205.0, 5853.0],
                        [7220.0, 5894.0],
                        [7212.0, 5944.0],
                        [7227.0, 5976.0],
                        [7200.0, 6049.0],
                        [7219.0, 6133.0],
                        [7208.0, 6211.0],
                        [7222.0, 6263.0],
                        [7207.0, 6300.0],
                        [7179.0, 6325.0],
                        [7175.0, 6385.0],
                        [7192.0, 6447.0],
                        [7179.0, 6480.0],
                        [7217.0, 6481.0],
                        [7251.0, 6514.0],
                        [7217.0, 6569.0],
                        [7231.0, 6572.0],
                        [7264.0, 6558.0],
                        [7257.0, 6526.0],
                        [7288.0, 6463.0],
                        [7293.0, 6420.0],
                        [7283.0, 6341.0],
                        [7312.0, 6282.0],
                        [7333.0, 6195.0],
                        [7371.0, 6099.0],
                        [7298.0, 6109.0],
                        [7252.0, 5982.0],
                        [7252.0, 5959.0],
                        [7288.0, 5914.0]
                    ]
                ],
                [
                    [
                        [7117.0, 8832.0],
                        [7215.0, 8784.0],
                        [7228.0, 8742.0],
                        [7200.0, 8733.0],
                        [7030.0, 8759.0],
                        [6972.0, 8746.0],
                        [6967.0, 8765.0],
                        [7022.0, 8786.0],
                        [7052.0, 8825.0],
                        [7117.0, 8832.0]
                    ]
                ],
                [
                    [
                        [7447.0, 9049.0],
                        [7561.0, 9061.0],
                        [7577.0, 9032.0],
                        [7613.0, 9041.0],
                        [7737.0, 9025.0],
                        [7720.0, 8991.0],
                        [7621.0, 8968.0],
                        [7547.0, 8972.0],
                        [7396.0, 9029.0],
                        [7417.0, 9080.0],
                        [7447.0, 9049.0]
                    ]
                ],
                [
                    [
                        [7312.0, 9034.0],
                        [7273.0, 8997.0],
                        [7171.0, 9007.0],
                        [7141.0, 9040.0],
                        [7176.0, 9089.0],
                        [7128.0, 9090.0],
                        [7111.0, 9060.0],
                        [7152.0, 9000.0],
                        [7230.0, 8981.0],
                        [7134.0, 8961.0],
                        [7097.0, 8984.0],
                        [6972.0, 8955.0],
                        [6930.0, 8971.0],
                        [6898.0, 8929.0],
                        [6817.0, 8953.0],
                        [6741.0, 9024.0],
                        [6778.0, 9023.0],
                        [6760.0, 9066.0],
                        [6799.0, 9087.0],
                        [6779.0, 9111.0],
                        [6881.0, 9153.0],
                        [6947.0, 9108.0],
                        [7033.0, 9071.0],
                        [7034.0, 9134.0],
                        [7057.0, 9154.0],
                        [7143.0, 9110.0],
                        [7242.0, 9110.0],
                        [7346.0, 9066.0],
                        [7300.0, 9053.0],
                        [7312.0, 9034.0]
                    ]
                ],
                [
                    [
                        [4194.0, 9358.0],
                        [4112.0, 9319.0],
                        [4057.0, 9329.0],
                        [4167.0, 9479.0],
                        [4231.0, 9544.0],
                        [4265.0, 9555.0],
                        [4310.0, 9532.0],
                        [4274.0, 9460.0],
                        [4308.0, 9495.0],
                        [4373.0, 9515.0],
                        [4424.0, 9470.0],
                        [4472.0, 9463.0],
                        [4487.0, 9416.0],
                        [4447.0, 9389.0],
                        [4371.0, 9373.0],
                        [4194.0, 9358.0]
                    ]
                ],
                [
                    [
                        [3623.0, 9552.0],
                        [3722.0, 9598.0],
                        [3695.0, 9622.0],
                        [3742.0, 9645.0],
                        [3926.0, 9664.0],
                        [3983.0, 9617.0],
                        [3995.0, 9647.0],
                        [4085.0, 9625.0],
                        [4101.0, 9593.0],
                        [4072.0, 9523.0],
                        [4035.0, 9523.0],
                        [4100.0, 9476.0],
                        [4062.0, 9451.0],
                        [3946.0, 9445.0],
                        [3876.0, 9471.0],
                        [3750.0, 9474.0],
                        [3702.0, 9504.0],
                        [3697.0, 9543.0],
                        [3623.0, 9552.0]
                    ]
                ],
                [
                    [
                        [323.0, 9633.0],
                        [338.0, 9649.0],
                        [419.0, 9650.0],
                        [452.0, 9614.0],
                        [384.0, 9638.0],
                        [294.0, 9584.0],
                        [225.0, 9591.0],
                        [194.0, 9612.0],
                        [323.0, 9633.0]
                    ]
                ],
                [
                    [
                        [1329.0, 9611.0],
                        [1200.0, 9627.0],
                        [1217.0, 9673.0],
                        [1327.0, 9684.0],
                        [1398.0, 9692.0],
                        [1400.0, 9648.0],
                        [1329.0, 9611.0]
                    ]
                ],
                [
                    [
                        [398.0, 9552.0],
                        [340.0, 9538.0],
                        [307.0, 9560.0],
                        [404.0, 9563.0],
                        [396.0, 9579.0],
                        [430.0, 9607.0],
                        [482.0, 9600.0],
                        [516.0, 9621.0],
                        [471.0, 9642.0],
                        [558.0, 9672.0],
                        [663.0, 9633.0],
                        [611.0, 9608.0],
                        [462.0, 9578.0],
                        [482.0, 9546.0],
                        [380.0, 9523.0],
                        [398.0, 9552.0]
                    ]
                ],
                [
                    [
                        [3878.0, 9783.0],
                        [3948.0, 9751.0],
                        [3895.0, 9740.0],
                        [3897.0, 9672.0],
                        [3709.0, 9649.0],
                        [3681.0, 9630.0],
                        [3672.0, 9621.0],
                        [3495.0, 9668.0],
                        [3521.0, 9698.0],
                        [3579.0, 9707.0],
                        [3615.0, 9756.0],
                        [3561.0, 9750.0],
                        [3599.0, 9788.0],
                        [3728.0, 9818.0],
                        [3791.0, 9845.0],
                        [3878.0, 9783.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.540000,
            "hc-middl_1": 0.510000,
            "hc-key": "sh",
            "hc-a2": "SH",
            "name": "Scarborough Reef",
            "labelrank": "6",
            "country-ab": "S.R.",
            "subregion": "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "-99",
            "iso-a2": "SH",
            "woe-id": "-99",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [5582.0, 3316.0],
                        [5582.0, 3316.0],
                        [5581.0, 3316.0],
                        [5582.0, 3316.0],
                        [5582.0, 3316.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.860000,
            "hc-middl_1": 0.170000,
            "hc-key": "my",
            "hc-a2": "MY",
            "name": "Malaysia",
            "labelrank": "3",
            "country-ab": "Malay.",
            "subregion": "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "MYS",
            "iso-a2": "MY",
            "woe-id": "23424901",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [5548.0, 2751.0],
                        [5565.0, 2757.0],
                        [5565.0, 2745.0],
                        [5553.0, 2739.0],
                        [5548.0, 2751.0]
                    ]
                ],
                [
                    [
                        [5620.0, 2532.0],
                        [5608.0, 2532.0],
                        [5605.0, 2532.0],
                        [5605.0, 2534.0],
                        [5596.0, 2531.0],
                        [5570.0, 2544.0],
                        [5512.0, 2538.0],
                        [5473.0, 2543.0],
                        [5452.0, 2508.0],
                        [5458.0, 2476.0],
                        [5449.0, 2446.0],
                        [5421.0, 2431.0],
                        [5432.0, 2409.0],
                        [5402.0, 2389.0],
                        [5407.0, 2365.0],
                        [5385.0, 2332.0],
                        [5343.0, 2331.0],
                        [5325.0, 2315.0],
                        [5279.0, 2335.0],
                        [5220.0, 2327.0],
                        [5195.0, 2295.0],
                        [5151.0, 2298.0],
                        [5106.0, 2280.0],
                        [5054.0, 2318.0],
                        [5030.0, 2351.0],
                        [5038.0, 2365.0],
                        [5059.0, 2338.0],
                        [5136.0, 2331.0],
                        [5155.0, 2395.0],
                        [5180.0, 2424.0],
                        [5274.0, 2450.0],
                        [5338.0, 2531.0],
                        [5341.0, 2554.0],
                        [5384.0, 2514.0],
                        [5402.0, 2543.0],
                        [5394.0, 2565.0],
                        [5410.0, 2577.0],
                        [5413.0, 2579.0],
                        [5414.0, 2572.0],
                        [5421.0, 2541.0],
                        [5439.0, 2538.0],
                        [5422.0, 2578.0],
                        [5454.0, 2601.0],
                        [5436.0, 2608.0],
                        [5451.0, 2630.0],
                        [5470.0, 2626.0],
                        [5487.0, 2667.0],
                        [5514.0, 2694.0],
                        [5533.0, 2732.0],
                        [5537.0, 2701.0],
                        [5559.0, 2732.0],
                        [5570.0, 2706.0],
                        [5603.0, 2690.0],
                        [5606.0, 2656.0],
                        [5623.0, 2667.0],
                        [5632.0, 2641.0],
                        [5652.0, 2649.0],
                        [5714.0, 2609.0],
                        [5673.0, 2590.0],
                        [5634.0, 2584.0],
                        [5679.0, 2555.0],
                        [5612.0, 2536.0],
                        [5620.0, 2532.0]
                    ]
                ],
                [
                    [
                        [4351.0, 2650.0],
                        [4353.0, 2668.0],
                        [4420.0, 2638.0],
                        [4423.0, 2595.0],
                        [4453.0, 2615.0],
                        [4472.0, 2604.0],
                        [4490.0, 2641.0],
                        [4566.0, 2582.0],
                        [4591.0, 2541.0],
                        [4596.0, 2509.0],
                        [4586.0, 2468.0],
                        [4597.0, 2451.0],
                        [4595.0, 2412.0],
                        [4619.0, 2389.0],
                        [4660.0, 2307.0],
                        [4593.0, 2311.0],
                        [4442.0, 2399.0],
                        [4447.0, 2415.0],
                        [4423.0, 2452.0],
                        [4400.0, 2469.0],
                        [4388.0, 2501.0],
                        [4387.0, 2538.0],
                        [4371.0, 2554.0],
                        [4368.0, 2620.0],
                        [4351.0, 2650.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.770000,
            "hc-middl_1": 0.420000,
            "hc-key": "az",
            "hc-a2": "AZ",
            "name": "Azerbaijan",
            "labelrank": "5",
            "country-ab": "Aze.",
            "subregion": "Western Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "AZE",
            "iso-a2": "AZ",
            "woe-id": "23424741",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [346.0, 5132.0],
                        [345.0, 5130.0],
                        [341.0, 5133.0],
                        [345.0, 5134.0],
                        [346.0, 5132.0]
                    ]
                ],
                [
                    [
                        [360.0, 5126.0],
                        [357.0, 5126.0],
                        [357.0, 5127.0],
                        [358.0, 5128.0],
                        [360.0, 5126.0]
                    ]
                ],
                [
                    [
                        [332.0, 5018.0],
                        [404.0, 5008.0],
                        [431.0, 4952.0],
                        [381.0, 4962.0],
                        [334.0, 5013.0],
                        [333.0, 5014.0],
                        [332.0, 5018.0]
                    ]
                ],
                [
                    [
                        [608.0, 4920.0],
                        [564.0, 4953.0],
                        [585.0, 4972.0],
                        [586.0, 5000.0],
                        [550.0, 5024.0],
                        [482.0, 4979.0],
                        [458.0, 4955.0],
                        [446.0, 4995.0],
                        [392.0, 5047.0],
                        [416.0, 5065.0],
                        [372.0, 5101.0],
                        [387.0, 5117.0],
                        [343.0, 5152.0],
                        [376.0, 5165.0],
                        [450.0, 5135.0],
                        [464.0, 5155.0],
                        [426.0, 5186.0],
                        [443.0, 5206.0],
                        [465.0, 5204.0],
                        [504.0, 5159.0],
                        [547.0, 5152.0],
                        [596.0, 5208.0],
                        [630.0, 5173.0],
                        [671.0, 5107.0],
                        [704.0, 5105.0],
                        [727.0, 5088.0],
                        [693.0, 5087.0],
                        [662.0, 5061.0],
                        [648.0, 4972.0],
                        [631.0, 4986.0],
                        [627.0, 4923.0],
                        [608.0, 4920.0]
                    ],
                    [
                        [379.0, 5096.0],
                        [382.0, 5095.0],
                        [385.0, 5099.0],
                        [379.0, 5099.0],
                        [379.0, 5096.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.560000,
            "hc-middl_1": 0.420000,
            "hc-key": "am",
            "hc-a2": "AM",
            "name": "Armenia",
            "labelrank": "6",
            "country-ab": "Arm.",
            "subregion": "Western Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "ARM",
            "iso-a2": "AM",
            "woe-id": "23424743",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [379.0, 5096.0],
                        [379.0, 5099.0],
                        [385.0, 5099.0],
                        [382.0, 5095.0],
                        [379.0, 5096.0]
                    ]
                ],
                [
                    [
                        [458.0, 4955.0],
                        [449.0, 4958.0],
                        [431.0, 4952.0],
                        [404.0, 5008.0],
                        [332.0, 5018.0],
                        [309.0, 5040.0],
                        [252.0, 5050.0],
                        [255.0, 5097.0],
                        [233.0, 5133.0],
                        [286.0, 5145.0],
                        [343.0, 5152.0],
                        [387.0, 5117.0],
                        [372.0, 5101.0],
                        [416.0, 5065.0],
                        [392.0, 5047.0],
                        [446.0, 4995.0],
                        [458.0, 4955.0]
                    ],
                    [
                        [346.0, 5132.0],
                        [345.0, 5134.0],
                        [341.0, 5133.0],
                        [345.0, 5130.0],
                        [346.0, 5132.0]
                    ],
                    [
                        [360.0, 5126.0],
                        [358.0, 5128.0],
                        [357.0, 5127.0],
                        [357.0, 5126.0],
                        [360.0, 5126.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.580000,
            "hc-middl_1": 0.910000,
            "hc-key": "vn",
            "hc-a2": "VN",
            "name": "Vietnam",
            "labelrank": "2",
            "country-ab": "Viet.",
            "subregion": "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "VNM",
            "iso-a2": "VN",
            "woe-id": "23424984",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [4617.0, 2944.0],
                        [4623.0, 2930.0],
                        [4618.0, 2914.0],
                        [4606.0, 2938.0],
                        [4617.0, 2944.0]
                    ]
                ],
                [
                    [
                        [4872.0, 3754.0],
                        [4814.0, 3711.0],
                        [4807.0, 3694.0],
                        [4770.0, 3681.0],
                        [4774.0, 3658.0],
                        [4736.0, 3639.0],
                        [4710.0, 3565.0],
                        [4746.0, 3515.0],
                        [4770.0, 3503.0],
                        [4786.0, 3456.0],
                        [4879.0, 3373.0],
                        [4901.0, 3369.0],
                        [4943.0, 3310.0],
                        [4967.0, 3264.0],
                        [4985.0, 3203.0],
                        [4981.0, 3168.0],
                        [5000.0, 3116.0],
                        [4981.0, 3114.0],
                        [4986.0, 3049.0],
                        [4971.0, 3021.0],
                        [4907.0, 2988.0],
                        [4849.0, 2947.0],
                        [4821.0, 2957.0],
                        [4795.0, 2886.0],
                        [4729.0, 2854.0],
                        [4699.0, 2818.0],
                        [4675.0, 2830.0],
                        [4681.0, 2904.0],
                        [4695.0, 2915.0],
                        [4660.0, 2925.0],
                        [4649.0, 2943.0],
                        [4677.0, 2952.0],
                        [4688.0, 2980.0],
                        [4739.0, 2989.0],
                        [4770.0, 2972.0],
                        [4745.0, 3009.0],
                        [4756.0, 3044.0],
                        [4786.0, 3038.0],
                        [4783.0, 3059.0],
                        [4804.0, 3060.0],
                        [4861.0, 3088.0],
                        [4856.0, 3137.0],
                        [4864.0, 3174.0],
                        [4843.0, 3215.0],
                        [4856.0, 3258.0],
                        [4864.0, 3300.0],
                        [4828.0, 3333.0],
                        [4837.0, 3356.0],
                        [4781.0, 3399.0],
                        [4780.0, 3420.0],
                        [4722.0, 3468.0],
                        [4700.0, 3506.0],
                        [4673.0, 3524.0],
                        [4675.0, 3542.0],
                        [4647.0, 3548.0],
                        [4583.0, 3583.0],
                        [4609.0, 3614.0],
                        [4629.0, 3607.0],
                        [4660.0, 3644.0],
                        [4617.0, 3668.0],
                        [4633.0, 3685.0],
                        [4594.0, 3705.0],
                        [4567.0, 3682.0],
                        [4527.0, 3696.0],
                        [4509.0, 3728.0],
                        [4515.0, 3748.0],
                        [4452.0, 3807.0],
                        [4475.0, 3835.0],
                        [4514.0, 3812.0],
                        [4536.0, 3839.0],
                        [4560.0, 3841.0],
                        [4585.0, 3821.0],
                        [4643.0, 3853.0],
                        [4646.0, 3871.0],
                        [4677.0, 3887.0],
                        [4716.0, 3854.0],
                        [4761.0, 3857.0],
                        [4780.0, 3844.0],
                        [4766.0, 3820.0],
                        [4775.0, 3788.0],
                        [4826.0, 3761.0],
                        [4872.0, 3754.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.340000,
            "hc-middl_1": 0.540000,
            "hc-key": "tj",
            "hc-a2": "TJ",
            "name": "Tajikistan",
            "labelrank": "4",
            "country-ab": "Tjk.",
            "subregion": "Central Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "TJK",
            "iso-a2": "TJ",
            "woe-id": "23424961",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [2166.0, 5187.0],
                        [2164.0, 5186.0],
                        [2160.0, 5191.0],
                        [2164.0, 5191.0],
                        [2166.0, 5187.0]
                    ]
                ],
                [
                    [
                        [2167.0, 5095.0],
                        [2173.0, 5093.0],
                        [2165.0, 5088.0],
                        [2157.0, 5096.0],
                        [2167.0, 5095.0]
                    ]
                ],
                [
                    [
                        [2382.0, 5069.0],
                        [2397.0, 4999.0],
                        [2435.0, 5006.0],
                        [2466.0, 4994.0],
                        [2477.0, 4919.0],
                        [2497.0, 4904.0],
                        [2478.0, 4889.0],
                        [2461.0, 4902.0],
                        [2388.0, 4886.0],
                        [2397.0, 4903.0],
                        [2363.0, 4904.0],
                        [2320.0, 4867.0],
                        [2247.0, 4838.0],
                        [2233.0, 4867.0],
                        [2242.0, 4936.0],
                        [2218.0, 4937.0],
                        [2223.0, 4966.0],
                        [2181.0, 4978.0],
                        [2141.0, 4936.0],
                        [2141.0, 4903.0],
                        [2096.0, 4905.0],
                        [2078.0, 4865.0],
                        [2057.0, 4883.0],
                        [1990.0, 4848.0],
                        [1973.0, 4868.0],
                        [1976.0, 4896.0],
                        [2012.0, 4950.0],
                        [1989.0, 4979.0],
                        [1990.0, 5017.0],
                        [1962.0, 5016.0],
                        [1937.0, 5034.0],
                        [1965.0, 5069.0],
                        [2019.0, 5064.0],
                        [2052.0, 5123.0],
                        [2071.0, 5120.0],
                        [2064.0, 5149.0],
                        [2080.0, 5172.0],
                        [2097.0, 5158.0],
                        [2151.0, 5193.0],
                        [2174.0, 5166.0],
                        [2147.0, 5145.0],
                        [2163.0, 5126.0],
                        [2190.0, 5128.0],
                        [2160.0, 5110.0],
                        [2120.0, 5123.0],
                        [2074.0, 5103.0],
                        [2075.0, 5064.0],
                        [2139.0, 5067.0],
                        [2174.0, 5059.0],
                        [2228.0, 5077.0],
                        [2248.0, 5050.0],
                        [2270.0, 5058.0],
                        [2347.0, 5060.0],
                        [2382.0, 5069.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.400000,
            "hc-middl_1": 0.380000,
            "hc-key": "uz",
            "hc-a2": "UZ",
            "name": "Uzbekistan",
            "labelrank": "3",
            "country-ab": "Uzb.",
            "subregion": "Central Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "UZB",
            "iso-a2": "UZ",
            "woe-id": "23424980",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [2248.0, 5102.0],
                        [2241.0, 5105.0],
                        [2248.0, 5109.0],
                        [2250.0, 5108.0],
                        [2248.0, 5102.0]
                    ]
                ],
                [
                    [
                        [2206.0, 5112.0],
                        [2209.0, 5099.0],
                        [2198.0, 5105.0],
                        [2192.0, 5120.0],
                        [2206.0, 5112.0]
                    ]
                ],
                [
                    [
                        [1358.0, 5519.0],
                        [1341.0, 5484.0],
                        [1394.0, 5441.0],
                        [1402.0, 5495.0],
                        [1473.0, 5457.0],
                        [1483.0, 5439.0],
                        [1546.0, 5381.0],
                        [1630.0, 5397.0],
                        [1716.0, 5393.0],
                        [1754.0, 5407.0],
                        [1795.0, 5374.0],
                        [1816.0, 5339.0],
                        [1837.0, 5349.0],
                        [1834.0, 5264.0],
                        [1869.0, 5265.0],
                        [1884.0, 5198.0],
                        [1973.0, 5201.0],
                        [1978.0, 5169.0],
                        [2021.0, 5152.0],
                        [2019.0, 5179.0],
                        [2050.0, 5218.0],
                        [2112.0, 5250.0],
                        [2149.0, 5283.0],
                        [2184.0, 5298.0],
                        [2205.0, 5294.0],
                        [2130.0, 5239.0],
                        [2203.0, 5202.0],
                        [2243.0, 5232.0],
                        [2274.0, 5195.0],
                        [2342.0, 5179.0],
                        [2305.0, 5155.0],
                        [2288.0, 5162.0],
                        [2241.0, 5122.0],
                        [2210.0, 5136.0],
                        [2190.0, 5128.0],
                        [2163.0, 5126.0],
                        [2147.0, 5145.0],
                        [2174.0, 5166.0],
                        [2151.0, 5193.0],
                        [2097.0, 5158.0],
                        [2080.0, 5172.0],
                        [2064.0, 5149.0],
                        [2071.0, 5120.0],
                        [2052.0, 5123.0],
                        [2019.0, 5064.0],
                        [1965.0, 5069.0],
                        [1937.0, 5034.0],
                        [1962.0, 5016.0],
                        [1990.0, 5017.0],
                        [1989.0, 4979.0],
                        [2012.0, 4950.0],
                        [1976.0, 4896.0],
                        [1973.0, 4868.0],
                        [1935.0, 4867.0],
                        [1918.0, 4882.0],
                        [1883.0, 4879.0],
                        [1884.0, 4934.0],
                        [1835.0, 4952.0],
                        [1816.0, 4949.0],
                        [1724.0, 5006.0],
                        [1708.0, 5005.0],
                        [1587.0, 5088.0],
                        [1543.0, 5180.0],
                        [1513.0, 5194.0],
                        [1500.0, 5181.0],
                        [1438.0, 5186.0],
                        [1415.0, 5198.0],
                        [1402.0, 5245.0],
                        [1408.0, 5267.0],
                        [1369.0, 5272.0],
                        [1306.0, 5313.0],
                        [1272.0, 5299.0],
                        [1299.0, 5272.0],
                        [1263.0, 5287.0],
                        [1239.0, 5257.0],
                        [1209.0, 5267.0],
                        [1199.0, 5236.0],
                        [1196.0, 5179.0],
                        [1123.0, 5182.0],
                        [1112.0, 5498.0],
                        [1296.0, 5553.0],
                        [1273.0, 5498.0],
                        [1279.0, 5454.0],
                        [1308.0, 5482.0],
                        [1307.0, 5547.0],
                        [1334.0, 5532.0],
                        [1358.0, 5519.0]
                    ],
                    [
                        [2166.0, 5187.0],
                        [2164.0, 5191.0],
                        [2160.0, 5191.0],
                        [2164.0, 5186.0],
                        [2166.0, 5187.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.620000,
            "hc-middl_1": 0.310000,
            "hc-key": "tl",
            "hc-a2": "TL",
            "name": "East Timor",
            "labelrank": "5",
            "country-ab": "T.L.",
            "subregion": "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "TLS",
            "iso-a2": "TL",
            "woe-id": "23424968",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [6150.0, 1622.0],
                        [6166.0, 1646.0],
                        [6294.0, 1673.0],
                        [6319.0, 1667.0],
                        [6258.0, 1626.0],
                        [6200.0, 1608.0],
                        [6162.0, 1585.0],
                        [6167.0, 1606.0],
                        [6150.0, 1622.0]
                    ]
                ],
                [
                    [
                        [6088.0, 1593.0],
                        [6099.0, 1599.0],
                        [6118.0, 1605.0],
                        [6105.0, 1582.0],
                        [6088.0, 1593.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.520000,
            "hc-middl_1": 0.520000,
            "hc-key": "kh",
            "hc-a2": "KH",
            "name": "Cambodia",
            "labelrank": "3",
            "country-ab": "Camb.",
            "subregion": "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "KHM",
            "iso-a2": "KH",
            "woe-id": "23424776",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [4523.0, 3055.0],
                        [4523.0, 3055.0],
                        [4523.0, 3055.0],
                        [4520.0, 3062.0],
                        [4524.0, 3082.0],
                        [4503.0, 3099.0],
                        [4490.0, 3163.0],
                        [4503.0, 3164.0],
                        [4542.0, 3218.0],
                        [4583.0, 3229.0],
                        [4607.0, 3223.0],
                        [4661.0, 3232.0],
                        [4691.0, 3226.0],
                        [4744.0, 3197.0],
                        [4760.0, 3209.0],
                        [4747.0, 3230.0],
                        [4784.0, 3247.0],
                        [4816.0, 3229.0],
                        [4856.0, 3258.0],
                        [4843.0, 3215.0],
                        [4864.0, 3174.0],
                        [4856.0, 3137.0],
                        [4861.0, 3088.0],
                        [4804.0, 3060.0],
                        [4783.0, 3059.0],
                        [4786.0, 3038.0],
                        [4756.0, 3044.0],
                        [4745.0, 3009.0],
                        [4770.0, 2972.0],
                        [4739.0, 2989.0],
                        [4688.0, 2980.0],
                        [4677.0, 2952.0],
                        [4649.0, 2943.0],
                        [4634.0, 2953.0],
                        [4590.0, 2947.0],
                        [4592.0, 2987.0],
                        [4551.0, 2976.0],
                        [4553.0, 3004.0],
                        [4536.0, 3027.0],
                        [4523.0, 3055.0],
                        [4523.0, 3055.0],
                        [4523.0, 3055.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.160000,
            "hc-middl_1": 0.550000,
            "hc-key": "bt",
            "hc-a2": "BT",
            "name": "Bhutan",
            "labelrank": "5",
            "country-ab": "Bhutan",
            "subregion": "Southern Asia",
            "region-wb": "South Asia",
            "iso-a3": "BTN",
            "iso-a2": "BT",
            "woe-id": "23424770",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [3500.0, 4144.0],
                        [3545.0, 4208.0],
                        [3592.0, 4227.0],
                        [3610.0, 4206.0],
                        [3655.0, 4199.0],
                        [3668.0, 4209.0],
                        [3694.0, 4184.0],
                        [3703.0, 4159.0],
                        [3719.0, 4163.0],
                        [3728.0, 4123.0],
                        [3688.0, 4111.0],
                        [3622.0, 4107.0],
                        [3607.0, 4115.0],
                        [3567.0, 4099.0],
                        [3516.0, 4107.0],
                        [3489.0, 4131.0],
                        [3500.0, 4144.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.330000,
            "hc-middl_1": 0.510000,
            "hc-key": "ge",
            "hc-a2": "GE",
            "name": "Georgia",
            "labelrank": "5",
            "country-ab": "Geo.",
            "subregion": "Western Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "GEO",
            "iso-a2": "GE",
            "woe-id": "23424823",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [254.0, 5273.0],
                        [264.0, 5257.0],
                        [329.0, 5277.0],
                        [389.0, 5257.0],
                        [385.0, 5233.0],
                        [443.0, 5206.0],
                        [426.0, 5186.0],
                        [464.0, 5155.0],
                        [450.0, 5135.0],
                        [376.0, 5165.0],
                        [343.0, 5152.0],
                        [286.0, 5145.0],
                        [233.0, 5133.0],
                        [187.0, 5171.0],
                        [161.0, 5158.0],
                        [95.0, 5162.0],
                        [112.0, 5189.0],
                        [91.0, 5258.0],
                        [44.0, 5293.0],
                        [6.0, 5298.0],
                        [-19.0, 5319.0],
                        [-19.0, 5319.0],
                        [-19.0, 5319.0],
                        [-2.0, 5335.0],
                        [28.0, 5333.0],
                        [92.0, 5309.0],
                        [154.0, 5311.0],
                        [196.0, 5301.0],
                        [254.0, 5273.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.560000,
            "hc-middl_1": 0.460000,
            "hc-key": "kz",
            "hc-a2": "KZ",
            "name": "Kazakhstan",
            "labelrank": "3",
            "country-ab": "Kaz.",
            "subregion": "Central Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "KAZ",
            "iso-a2": "KZ",
            "woe-id": "-90",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [3043.0, 6109.0],
                        [3071.0, 6099.0],
                        [3104.0, 6043.0],
                        [3156.0, 6028.0],
                        [3178.0, 5983.0],
                        [3243.0, 5974.0],
                        [3272.0, 5986.0],
                        [3326.0, 5942.0],
                        [3295.0, 5943.0],
                        [3274.0, 5889.0],
                        [3218.0, 5876.0],
                        [3201.0, 5832.0],
                        [3214.0, 5784.0],
                        [3202.0, 5753.0],
                        [3151.0, 5731.0],
                        [3143.0, 5745.0],
                        [3090.0, 5743.0],
                        [3035.0, 5762.0],
                        [2997.0, 5670.0],
                        [2979.0, 5611.0],
                        [3003.0, 5603.0],
                        [3001.0, 5580.0],
                        [2956.0, 5576.0],
                        [2941.0, 5592.0],
                        [2823.0, 5560.0],
                        [2818.0, 5540.0],
                        [2845.0, 5529.0],
                        [2845.0, 5481.0],
                        [2880.0, 5398.0],
                        [2835.0, 5353.0],
                        [2842.0, 5316.0],
                        [2820.0, 5335.0],
                        [2785.0, 5338.0],
                        [2764.0, 5364.0],
                        [2718.0, 5370.0],
                        [2524.0, 5368.0],
                        [2482.0, 5360.0],
                        [2410.0, 5393.0],
                        [2372.0, 5374.0],
                        [2357.0, 5333.0],
                        [2365.0, 5319.0],
                        [2246.0, 5350.0],
                        [2214.0, 5346.0],
                        [2187.0, 5325.0],
                        [2184.0, 5298.0],
                        [2149.0, 5283.0],
                        [2112.0, 5250.0],
                        [2050.0, 5218.0],
                        [2019.0, 5179.0],
                        [2021.0, 5152.0],
                        [1978.0, 5169.0],
                        [1973.0, 5201.0],
                        [1884.0, 5198.0],
                        [1869.0, 5265.0],
                        [1834.0, 5264.0],
                        [1837.0, 5349.0],
                        [1816.0, 5339.0],
                        [1795.0, 5374.0],
                        [1754.0, 5407.0],
                        [1716.0, 5393.0],
                        [1630.0, 5397.0],
                        [1546.0, 5381.0],
                        [1483.0, 5439.0],
                        [1473.0, 5457.0],
                        [1402.0, 5495.0],
                        [1397.0, 5559.0],
                        [1380.0, 5558.0],
                        [1401.0, 5598.0],
                        [1429.0, 5590.0],
                        [1479.0, 5620.0],
                        [1484.0, 5640.0],
                        [1447.0, 5658.0],
                        [1393.0, 5646.0],
                        [1452.0, 5621.0],
                        [1439.0, 5604.0],
                        [1359.0, 5624.0],
                        [1375.0, 5603.0],
                        [1355.0, 5568.0],
                        [1344.0, 5596.0],
                        [1306.0, 5583.0],
                        [1296.0, 5553.0],
                        [1112.0, 5498.0],
                        [1123.0, 5182.0],
                        [1084.0, 5178.0],
                        [1045.0, 5231.0],
                        [993.0, 5262.0],
                        [907.0, 5243.0],
                        [870.0, 5209.0],
                        [867.0, 5238.0],
                        [887.0, 5294.0],
                        [831.0, 5301.0],
                        [810.0, 5331.0],
                        [783.0, 5327.0],
                        [786.0, 5351.0],
                        [750.0, 5415.0],
                        [705.0, 5431.0],
                        [710.0, 5454.0],
                        [782.0, 5452.0],
                        [757.0, 5473.0],
                        [785.0, 5516.0],
                        [865.0, 5526.0],
                        [918.0, 5523.0],
                        [880.0, 5537.0],
                        [903.0, 5581.0],
                        [908.0, 5643.0],
                        [889.0, 5664.0],
                        [855.0, 5667.0],
                        [841.0, 5649.0],
                        [767.0, 5675.0],
                        [711.0, 5651.0],
                        [669.0, 5619.0],
                        [634.0, 5620.0],
                        [628.0, 5599.0],
                        [628.0, 5599.0],
                        [572.0, 5627.0],
                        [611.0, 5638.0],
                        [575.0, 5694.0],
                        [540.0, 5725.0],
                        [474.0, 5727.0],
                        [469.0, 5768.0],
                        [426.0, 5779.0],
                        [463.0, 5853.0],
                        [445.0, 5864.0],
                        [452.0, 5910.0],
                        [480.0, 5931.0],
                        [496.0, 5970.0],
                        [560.0, 5913.0],
                        [592.0, 5933.0],
                        [575.0, 5984.0],
                        [627.0, 6011.0],
                        [627.0, 6035.0],
                        [692.0, 6058.0],
                        [707.0, 6088.0],
                        [764.0, 6090.0],
                        [793.0, 6078.0],
                        [832.0, 6105.0],
                        [845.0, 6078.0],
                        [904.0, 6083.0],
                        [987.0, 6024.0],
                        [998.0, 6041.0],
                        [1072.0, 5997.0],
                        [1130.0, 6049.0],
                        [1177.0, 6054.0],
                        [1215.0, 6036.0],
                        [1220.0, 6058.0],
                        [1258.0, 6062.0],
                        [1303.0, 6019.0],
                        [1364.0, 6008.0],
                        [1381.0, 6038.0],
                        [1431.0, 6021.0],
                        [1477.0, 6035.0],
                        [1496.0, 6080.0],
                        [1443.0, 6112.0],
                        [1431.0, 6113.0],
                        [1402.0, 6116.0],
                        [1385.0, 6136.0],
                        [1448.0, 6181.0],
                        [1421.0, 6211.0],
                        [1447.0, 6237.0],
                        [1521.0, 6246.0],
                        [1517.0, 6259.0],
                        [1456.0, 6271.0],
                        [1464.0, 6298.0],
                        [1441.0, 6306.0],
                        [1453.0, 6343.0],
                        [1482.0, 6338.0],
                        [1587.0, 6354.0],
                        [1650.0, 6378.0],
                        [1738.0, 6385.0],
                        [1754.0, 6413.0],
                        [1791.0, 6413.0],
                        [1945.0, 6452.0],
                        [1951.0, 6476.0],
                        [1999.0, 6502.0],
                        [2051.0, 6494.0],
                        [2089.0, 6475.0],
                        [2133.0, 6492.0],
                        [2160.0, 6437.0],
                        [2163.0, 6376.0],
                        [2226.0, 6383.0],
                        [2236.0, 6401.0],
                        [2254.0, 6360.0],
                        [2265.0, 6383.0],
                        [2329.0, 6368.0],
                        [2309.0, 6338.0],
                        [2324.0, 6317.0],
                        [2360.0, 6338.0],
                        [2370.0, 6334.0],
                        [2394.0, 6324.0],
                        [2396.0, 6344.0],
                        [2437.0, 6357.0],
                        [2466.0, 6377.0],
                        [2479.0, 6387.0],
                        [2564.0, 6425.0],
                        [2543.0, 6376.0],
                        [2640.0, 6312.0],
                        [2760.0, 6146.0],
                        [2799.0, 6082.0],
                        [2831.0, 6099.0],
                        [2847.0, 6132.0],
                        [2899.0, 6101.0],
                        [2904.0, 6080.0],
                        [2976.0, 6081.0],
                        [2996.0, 6100.0],
                        [3043.0, 6109.0]
                    ]
                ],
                [
                    [
                        [1307.0, 5547.0],
                        [1331.0, 5578.0],
                        [1354.0, 5555.0],
                        [1358.0, 5519.0],
                        [1334.0, 5532.0],
                        [1307.0, 5547.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.600000,
            "hc-middl_1": 0.220000,
            "hc-key": "il",
            "hc-a2": "IL",
            "name": "Israel",
            "labelrank": "4",
            "country-ab": "Isr.",
            "subregion": "Western Asia",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "ISR",
            "iso-a2": "IL",
            "woe-id": "23424852",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [-336.600061413800574, 4182.399938586198914],
                        [-346.600061413800574, 4196.399938586198914],
                        [-395.600061413800574, 4316.399938586198914],
                        [-360.600061413800574, 4368.399938586198914],
                        [-335.600061413800574, 4458.399938586198914],
                        [-309.600061413800574, 4459.399938586198914],
                        [-285.600061413800574, 4485.399938586198914],
                        [-279.600061413800574, 4449.399938586198914],
                        [-288.600061413800574, 4433.399938586198914],
                        [-288.600061413800574, 4433.399938586198914],
                        [-302.600061413800574, 4424.399938586198914],
                        [-299.600061413800574, 4355.399938586198914],
                        [-311.600061413800574, 4335.399938586198914],
                        [-308.600061413800574, 4320.399938586198914],
                        [-310.600061413800574, 4315.399938586198914],
                        [-309.600061413800574, 4313.399938586198914],
                        [-312.600061413800574, 4309.399938586198914],
                        [-307.600061413800574, 4302.399938586198914],
                        [-326.600061413800574, 4250.399938586198914],
                        [-336.600061413800574, 4182.399938586198914]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.320000,
            "hc-middl_1": 0.350000,
            "hc-key": "sy",
            "hc-a2": "SY",
            "name": "Syria",
            "labelrank": "3",
            "country-ab": "Syria",
            "subregion": "Western Asia",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "SYR",
            "iso-a2": "SY",
            "woe-id": "23424956",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [-280.0, 4449.0],
                        [-286.0, 4485.0],
                        [-280.0, 4504.0],
                        [-233.0, 4550.0],
                        [-249.0, 4583.0],
                        [-279.0, 4584.0],
                        [-285.0, 4646.0],
                        [-298.0, 4657.0],
                        [-287.0, 4686.0],
                        [-271.0, 4679.0],
                        [-255.0, 4712.0],
                        [-234.0, 4713.0],
                        [-236.0, 4762.0],
                        [-180.0, 4748.0],
                        [-128.0, 4772.0],
                        [-94.0, 4758.0],
                        [-16.0, 4762.0],
                        [51.0, 4794.0],
                        [105.0, 4794.0],
                        [157.0, 4816.0],
                        [168.0, 4799.0],
                        [132.0, 4757.0],
                        [102.0, 4749.0],
                        [91.0, 4709.0],
                        [101.0, 4678.0],
                        [92.0, 4607.0],
                        [57.0, 4571.0],
                        [-76.0, 4490.0],
                        [-212.0, 4401.0],
                        [-244.0, 4406.0],
                        [-289.0, 4433.0],
                        [-289.0, 4433.0],
                        [-280.0, 4449.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.210000,
            "hc-middl_1": 0.690000,
            "hc-key": "jo",
            "hc-a2": "JO",
            "name": "Jordan",
            "labelrank": "4",
            "country-ab": "Jord.",
            "subregion": "Western Asia",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "JOR",
            "iso-a2": "JO",
            "woe-id": "23424860",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [-308.0, 4302.0],
                        [-301.0, 4310.0],
                        [-310.0, 4313.0],
                        [-311.0, 4315.0],
                        [-309.0, 4320.0],
                        [-300.0, 4321.0],
                        [-300.0, 4355.0],
                        [-303.0, 4424.0],
                        [-289.0, 4433.0],
                        [-289.0, 4433.0],
                        [-244.0, 4406.0],
                        [-212.0, 4401.0],
                        [-76.0, 4490.0],
                        [-54.0, 4421.0],
                        [-47.0, 4392.0],
                        [-59.0, 4381.0],
                        [-200.0, 4337.0],
                        [-125.0, 4262.0],
                        [-160.0, 4222.0],
                        [-210.0, 4210.0],
                        [-229.0, 4181.0],
                        [-261.0, 4156.0],
                        [-337.0, 4166.0],
                        [-334.0, 4180.0],
                        [-337.0, 4182.0],
                        [-327.0, 4250.0],
                        [-308.0, 4302.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.570000,
            "hc-middl_1": 0.500000,
            "hc-key": "tm",
            "hc-a2": "TM",
            "name": "Turkmenistan",
            "labelrank": "4",
            "country-ab": "Turkm.",
            "subregion": "Central Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "TKM",
            "iso-a2": "TM",
            "woe-id": "23424972",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [1199.0, 5236.0],
                        [1219.0, 5204.0],
                        [1255.0, 5217.0],
                        [1239.0, 5257.0],
                        [1263.0, 5287.0],
                        [1299.0, 5272.0],
                        [1272.0, 5299.0],
                        [1306.0, 5313.0],
                        [1369.0, 5272.0],
                        [1408.0, 5267.0],
                        [1402.0, 5245.0],
                        [1415.0, 5198.0],
                        [1438.0, 5186.0],
                        [1500.0, 5181.0],
                        [1513.0, 5194.0],
                        [1543.0, 5180.0],
                        [1587.0, 5088.0],
                        [1708.0, 5005.0],
                        [1724.0, 5006.0],
                        [1816.0, 4949.0],
                        [1835.0, 4952.0],
                        [1884.0, 4934.0],
                        [1883.0, 4879.0],
                        [1829.0, 4895.0],
                        [1811.0, 4867.0],
                        [1780.0, 4865.0],
                        [1761.0, 4840.0],
                        [1739.0, 4784.0],
                        [1662.0, 4749.0],
                        [1644.0, 4715.0],
                        [1590.0, 4690.0],
                        [1570.0, 4711.0],
                        [1515.0, 4725.0],
                        [1499.0, 4808.0],
                        [1446.0, 4805.0],
                        [1422.0, 4836.0],
                        [1375.0, 4858.0],
                        [1374.0, 4872.0],
                        [1334.0, 4887.0],
                        [1230.0, 4906.0],
                        [1220.0, 4930.0],
                        [1164.0, 4927.0],
                        [1155.0, 4913.0],
                        [1093.0, 4910.0],
                        [1054.0, 4883.0],
                        [1049.0, 4863.0],
                        [988.0, 4846.0],
                        [978.0, 4943.0],
                        [988.0, 4975.0],
                        [958.0, 5009.0],
                        [924.0, 5015.0],
                        [967.0, 5027.0],
                        [945.0, 5046.0],
                        [956.0, 5061.0],
                        [897.0, 5067.0],
                        [895.0, 5103.0],
                        [908.0, 5145.0],
                        [921.0, 5129.0],
                        [965.0, 5118.0],
                        [1008.0, 5127.0],
                        [1034.0, 5161.0],
                        [988.0, 5190.0],
                        [973.0, 5241.0],
                        [921.0, 5241.0],
                        [897.0, 5212.0],
                        [898.0, 5180.0],
                        [870.0, 5209.0],
                        [907.0, 5243.0],
                        [993.0, 5262.0],
                        [1045.0, 5231.0],
                        [1084.0, 5178.0],
                        [1123.0, 5182.0],
                        [1196.0, 5179.0],
                        [1199.0, 5236.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.240000,
            "hc-middl_1": 0.350000,
            "hc-key": "cnm",
            "hc-a2": "CN",
            "name": "Cyprus No Mans Area",
            "labelrank": "9",
            "country-ab": null,
            "subregion": "Western Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "-99",
            "iso-a2": null,
            "woe-id": "-99",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [-419.0, 4613.0],
                        [-419.0, 4612.0],
                        [-425.0, 4611.0],
                        [-428.0, 4612.0],
                        [-427.0, 4613.0],
                        [-423.0, 4613.0],
                        [-419.0, 4613.0]
                    ]
                ],
                [
                    [
                        [-521.0, 4618.0],
                        [-520.0, 4618.0],
                        [-519.0, 4617.0],
                        [-517.0, 4619.0],
                        [-517.0, 4619.0],
                        [-516.0, 4619.0],
                        [-518.0, 4616.0],
                        [-521.0, 4618.0]
                    ]
                ],
                [
                    [
                        [-514.0, 4619.0],
                        [-514.0, 4619.0],
                        [-512.0, 4619.0],
                        [-463.0, 4622.0],
                        [-443.0, 4609.0],
                        [-441.0, 4609.0],
                        [-441.0, 4606.0],
                        [-462.0, 4619.0],
                        [-504.0, 4610.0],
                        [-514.0, 4619.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.480000,
            "hc-middl_1": 0.510000,
            "hc-key": "mn",
            "hc-a2": "MN",
            "name": "Mongolia",
            "labelrank": "3",
            "country-ab": "Mong.",
            "subregion": "Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "MNG",
            "iso-a2": "MN",
            "woe-id": "23424887",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [5474.0, 5898.0],
                        [5500.0, 5904.0],
                        [5490.0, 5917.0],
                        [5547.0, 5918.0],
                        [5632.0, 5848.0],
                        [5647.0, 5808.0],
                        [5632.0, 5797.0],
                        [5570.0, 5810.0],
                        [5529.0, 5805.0],
                        [5464.0, 5770.0],
                        [5414.0, 5764.0],
                        [5385.0, 5710.0],
                        [5348.0, 5685.0],
                        [5270.0, 5678.0],
                        [5237.0, 5637.0],
                        [5208.0, 5619.0],
                        [5092.0, 5645.0],
                        [5073.0, 5634.0],
                        [5050.0, 5579.0],
                        [5091.0, 5524.0],
                        [5021.0, 5486.0],
                        [4985.0, 5440.0],
                        [4920.0, 5411.0],
                        [4827.0, 5408.0],
                        [4728.0, 5390.0],
                        [4618.0, 5340.0],
                        [4605.0, 5327.0],
                        [4568.0, 5331.0],
                        [4568.0, 5349.0],
                        [4513.0, 5337.0],
                        [4466.0, 5357.0],
                        [4392.0, 5369.0],
                        [4363.0, 5397.0],
                        [4247.0, 5406.0],
                        [4209.0, 5396.0],
                        [4046.0, 5409.0],
                        [3986.0, 5403.0],
                        [3954.0, 5442.0],
                        [3913.0, 5534.0],
                        [3889.0, 5530.0],
                        [3809.0, 5564.0],
                        [3779.0, 5587.0],
                        [3646.0, 5592.0],
                        [3590.0, 5601.0],
                        [3573.0, 5628.0],
                        [3597.0, 5675.0],
                        [3598.0, 5724.0],
                        [3555.0, 5789.0],
                        [3545.0, 5820.0],
                        [3487.0, 5852.0],
                        [3451.0, 5847.0],
                        [3416.0, 5878.0],
                        [3371.0, 5899.0],
                        [3360.0, 5951.0],
                        [3385.0, 5977.0],
                        [3434.0, 5978.0],
                        [3491.0, 6005.0],
                        [3486.0, 6023.0],
                        [3583.0, 6075.0],
                        [3612.0, 6079.0],
                        [3674.0, 6117.0],
                        [3699.0, 6102.0],
                        [3812.0, 6096.0],
                        [3841.0, 6046.0],
                        [3905.0, 6037.0],
                        [3930.0, 6049.0],
                        [4008.0, 6040.0],
                        [4032.0, 6026.0],
                        [4088.0, 6059.0],
                        [4100.0, 6102.0],
                        [4064.0, 6146.0],
                        [4080.0, 6190.0],
                        [4126.0, 6228.0],
                        [4137.0, 6255.0],
                        [4218.0, 6220.0],
                        [4254.0, 6221.0],
                        [4317.0, 6197.0],
                        [4374.0, 6187.0],
                        [4387.0, 6114.0],
                        [4483.0, 6079.0],
                        [4600.0, 6115.0],
                        [4666.0, 6100.0],
                        [4695.0, 6105.0],
                        [4736.0, 6076.0],
                        [4788.0, 6071.0],
                        [4788.0, 6046.0],
                        [4832.0, 6017.0],
                        [4876.0, 6020.0],
                        [4988.0, 6005.0],
                        [5031.0, 6027.0],
                        [5151.0, 6052.0],
                        [5162.0, 6074.0],
                        [5237.0, 6119.0],
                        [5270.0, 6116.0],
                        [5315.0, 6086.0],
                        [5375.0, 6099.0],
                        [5409.0, 6083.0],
                        [5331.0, 5924.0],
                        [5357.0, 5887.0],
                        [5384.0, 5903.0],
                        [5427.0, 5905.0],
                        [5461.0, 5886.0],
                        [5474.0, 5898.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.640000,
            "hc-middl_1": 0.480000,
            "hc-key": "kw",
            "hc-a2": "KW",
            "name": "Kuwait",
            "labelrank": "6",
            "country-ab": "Kwt.",
            "subregion": "Western Asia",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "KWT",
            "iso-a2": "KW",
            "woe-id": "23424870",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [568.0, 4135.0],
                        [551.0, 4170.0],
                        [486.0, 4175.0],
                        [525.0, 4243.0],
                        [542.0, 4254.0],
                        [584.0, 4248.0],
                        [592.0, 4234.0],
                        [595.0, 4250.0],
                        [596.0, 4250.0],
                        [596.0, 4250.0],
                        [613.0, 4233.0],
                        [605.0, 4218.0],
                        [593.0, 4232.0],
                        [602.0, 4215.0],
                        [569.0, 4199.0],
                        [597.0, 4199.0],
                        [623.0, 4137.0],
                        [568.0, 4135.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.530000,
            "hc-middl_1": 0.650000,
            "hc-key": "iq",
            "hc-a2": "IQ",
            "name": "Iraq",
            "labelrank": "3",
            "country-ab": "Iraq",
            "subregion": "Western Asia",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "IRQ",
            "iso-a2": "IQ",
            "woe-id": "23424855",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [595.0, 4250.0],
                        [584.0, 4248.0],
                        [542.0, 4254.0],
                        [525.0, 4243.0],
                        [486.0, 4175.0],
                        [355.0, 4179.0],
                        [164.0, 4318.0],
                        [41.0, 4381.0],
                        [-47.0, 4392.0],
                        [-54.0, 4421.0],
                        [-76.0, 4490.0],
                        [57.0, 4571.0],
                        [92.0, 4607.0],
                        [101.0, 4678.0],
                        [91.0, 4709.0],
                        [102.0, 4749.0],
                        [132.0, 4757.0],
                        [168.0, 4799.0],
                        [193.0, 4820.0],
                        [247.0, 4812.0],
                        [300.0, 4815.0],
                        [306.0, 4793.0],
                        [339.0, 4807.0],
                        [356.0, 4758.0],
                        [374.0, 4748.0],
                        [384.0, 4714.0],
                        [450.0, 4705.0],
                        [428.0, 4677.0],
                        [444.0, 4655.0],
                        [426.0, 4644.0],
                        [392.0, 4591.0],
                        [391.0, 4554.0],
                        [428.0, 4528.0],
                        [457.0, 4476.0],
                        [519.0, 4438.0],
                        [535.0, 4439.0],
                        [571.0, 4385.0],
                        [562.0, 4325.0],
                        [587.0, 4324.0],
                        [588.0, 4285.0],
                        [626.0, 4247.0],
                        [603.0, 4251.0],
                        [596.0, 4250.0],
                        [595.0, 4250.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.800000,
            "hc-middl_1": 0.520000,
            "hc-key": "ae",
            "hc-a2": "AE",
            "name": "United Arab Emirates",
            "labelrank": "4",
            "country-ab": "U.A.E.",
            "subregion": "Western Asia",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "ARE",
            "iso-a2": "AE",
            "woe-id": "23424738",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [1172.0, 3967.0],
                        [1179.0, 3937.0],
                        [1188.0, 3935.0],
                        [1195.0, 3928.0],
                        [1197.0, 3886.0],
                        [1173.0, 3869.0],
                        [1155.0, 3876.0],
                        [1154.0, 3829.0],
                        [1172.0, 3818.0],
                        [1134.0, 3808.0],
                        [1140.0, 3794.0],
                        [1117.0, 3735.0],
                        [1118.0, 3713.0],
                        [1112.0, 3707.0],
                        [932.0, 3724.0],
                        [859.0, 3807.0],
                        [857.0, 3820.0],
                        [875.0, 3802.0],
                        [929.0, 3815.0],
                        [1000.0, 3810.0],
                        [1039.0, 3818.0],
                        [1064.0, 3837.0],
                        [1078.0, 3869.0],
                        [1104.0, 3886.0],
                        [1172.0, 3967.0]
                    ],
                    [
                        [1189.0, 3906.0],
                        [1194.0, 3910.0],
                        [1185.0, 3911.0],
                        [1186.0, 3903.0],
                        [1189.0, 3906.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.650000,
            "hc-middl_1": 0.590000,
            "hc-key": "la",
            "hc-a2": "LA",
            "name": "Laos",
            "labelrank": "4",
            "country-ab": "Laos",
            "subregion": "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "LAO",
            "iso-a2": "LA",
            "woe-id": "23424872",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [4314.0, 3648.0],
                        [4321.0, 3676.0],
                        [4344.0, 3685.0],
                        [4356.0, 3723.0],
                        [4386.0, 3742.0],
                        [4396.0, 3714.0],
                        [4427.0, 3712.0],
                        [4428.0, 3763.0],
                        [4410.0, 3793.0],
                        [4419.0, 3809.0],
                        [4452.0, 3807.0],
                        [4515.0, 3748.0],
                        [4509.0, 3728.0],
                        [4527.0, 3696.0],
                        [4567.0, 3682.0],
                        [4594.0, 3705.0],
                        [4633.0, 3685.0],
                        [4617.0, 3668.0],
                        [4660.0, 3644.0],
                        [4629.0, 3607.0],
                        [4609.0, 3614.0],
                        [4583.0, 3583.0],
                        [4647.0, 3548.0],
                        [4675.0, 3542.0],
                        [4673.0, 3524.0],
                        [4700.0, 3506.0],
                        [4722.0, 3468.0],
                        [4780.0, 3420.0],
                        [4781.0, 3399.0],
                        [4837.0, 3356.0],
                        [4828.0, 3333.0],
                        [4864.0, 3300.0],
                        [4856.0, 3258.0],
                        [4816.0, 3229.0],
                        [4784.0, 3247.0],
                        [4747.0, 3230.0],
                        [4760.0, 3209.0],
                        [4744.0, 3197.0],
                        [4691.0, 3226.0],
                        [4707.0, 3233.0],
                        [4718.0, 3274.0],
                        [4708.0, 3281.0],
                        [4721.0, 3320.0],
                        [4702.0, 3348.0],
                        [4676.0, 3356.0],
                        [4655.0, 3383.0],
                        [4657.0, 3444.0],
                        [4618.0, 3478.0],
                        [4597.0, 3511.0],
                        [4553.0, 3519.0],
                        [4503.0, 3474.0],
                        [4460.0, 3499.0],
                        [4395.0, 3442.0],
                        [4377.0, 3451.0],
                        [4396.0, 3485.0],
                        [4385.0, 3512.0],
                        [4404.0, 3558.0],
                        [4398.0, 3596.0],
                        [4342.0, 3592.0],
                        [4347.0, 3638.0],
                        [4314.0, 3648.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.530000,
            "hc-middl_1": 0.590000,
            "hc-key": "pk",
            "hc-a2": "PK",
            "name": "Pakistan",
            "labelrank": "2",
            "country-ab": "Pak.",
            "subregion": "Southern Asia",
            "region-wb": "South Asia",
            "iso-a3": "PAK",
            "iso-a2": "PK",
            "woe-id": "23424922",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [2617.0, 4765.0],
                        [2637.0, 4723.0],
                        [2603.0, 4691.0],
                        [2549.0, 4671.0],
                        [2442.0, 4689.0],
                        [2407.0, 4656.0],
                        [2420.0, 4627.0],
                        [2443.0, 4624.0],
                        [2423.0, 4599.0],
                        [2426.0, 4562.0],
                        [2449.0, 4533.0],
                        [2476.0, 4536.0],
                        [2480.0, 4507.0],
                        [2525.0, 4493.0],
                        [2488.0, 4473.0],
                        [2465.0, 4447.0],
                        [2479.0, 4399.0],
                        [2456.0, 4384.0],
                        [2423.0, 4340.0],
                        [2431.0, 4327.0],
                        [2390.0, 4306.0],
                        [2360.0, 4235.0],
                        [2323.0, 4215.0],
                        [2289.0, 4150.0],
                        [2216.0, 4128.0],
                        [2180.0, 4151.0],
                        [2128.0, 4086.0],
                        [2121.0, 4057.0],
                        [2171.0, 4038.0],
                        [2166.0, 3996.0],
                        [2181.0, 3975.0],
                        [2207.0, 3976.0],
                        [2209.0, 3956.0],
                        [2241.0, 3901.0],
                        [2243.0, 3880.0],
                        [2220.0, 3866.0],
                        [2203.0, 3880.0],
                        [2164.0, 3859.0],
                        [2135.0, 3866.0],
                        [2076.0, 3865.0],
                        [2076.0, 3841.0],
                        [2038.0, 3830.0],
                        [1999.0, 3826.0],
                        [1979.0, 3845.0],
                        [1963.0, 3889.0],
                        [1929.0, 3901.0],
                        [1930.0, 3931.0],
                        [1909.0, 3958.0],
                        [1856.0, 3937.0],
                        [1774.0, 3929.0],
                        [1707.0, 3933.0],
                        [1702.0, 3920.0],
                        [1629.0, 3923.0],
                        [1576.0, 3904.0],
                        [1566.0, 3916.0],
                        [1582.0, 3995.0],
                        [1645.0, 4028.0],
                        [1673.0, 4027.0],
                        [1684.0, 4065.0],
                        [1647.0, 4072.0],
                        [1640.0, 4151.0],
                        [1579.0, 4171.0],
                        [1533.0, 4236.0],
                        [1501.0, 4269.0],
                        [1618.0, 4239.0],
                        [1695.0, 4248.0],
                        [1732.0, 4241.0],
                        [1760.0, 4256.0],
                        [1799.0, 4255.0],
                        [1881.0, 4281.0],
                        [1890.0, 4366.0],
                        [1930.0, 4398.0],
                        [1959.0, 4390.0],
                        [1987.0, 4401.0],
                        [1974.0, 4416.0],
                        [2015.0, 4441.0],
                        [2060.0, 4426.0],
                        [2096.0, 4452.0],
                        [2089.0, 4490.0],
                        [2110.0, 4542.0],
                        [2163.0, 4564.0],
                        [2140.0, 4620.0],
                        [2177.0, 4613.0],
                        [2215.0, 4624.0],
                        [2215.0, 4673.0],
                        [2253.0, 4717.0],
                        [2249.0, 4745.0],
                        [2217.0, 4784.0],
                        [2249.0, 4818.0],
                        [2314.0, 4850.0],
                        [2390.0, 4859.0],
                        [2423.0, 4855.0],
                        [2454.0, 4871.0],
                        [2512.0, 4865.0],
                        [2558.0, 4829.0],
                        [2553.0, 4800.0],
                        [2573.0, 4777.0],
                        [2599.0, 4786.0],
                        [2617.0, 4765.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.240000,
            "hc-middl_1": 0.390000,
            "hc-key": "jk",
            "hc-a2": "JK",
            "name": "Siachen Glacier",
            "labelrank": "5",
            "country-ab": "Siachen",
            "subregion": "Southern Asia",
            "region-wb": "South Asia",
            "iso-a3": "-99",
            "iso-a2": "JK",
            "woe-id": "23424928",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [2637.0, 4723.0],
                        [2617.0, 4765.0],
                        [2662.0, 4753.0],
                        [2690.0, 4756.0],
                        [2637.0, 4723.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.500000,
            "hc-middl_1": 0.500000,
            "hc-key": "qa",
            "hc-a2": "QA",
            "name": "Qatar",
            "labelrank": "5",
            "country-ab": "Qatar",
            "subregion": "Western Asia",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "QAT",
            "iso-a2": "QA",
            "woe-id": "23424930",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [802.0, 3855.0],
                        [796.0, 3911.0],
                        [815.0, 3954.0],
                        [829.0, 3963.0],
                        [853.0, 3942.0],
                        [847.0, 3915.0],
                        [856.0, 3873.0],
                        [831.0, 3847.0],
                        [814.0, 3842.0],
                        [802.0, 3855.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.380000,
            "hc-middl_1": 0.490000,
            "hc-key": "tr",
            "hc-a2": "TR",
            "name": "Turkey",
            "labelrank": "2",
            "country-ab": "Tur.",
            "subregion": "Western Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "TUR",
            "iso-a2": "TR",
            "woe-id": "23424969",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [332.0, 5018.0],
                        [333.0, 5014.0],
                        [334.0, 5013.0],
                        [317.0, 5023.0],
                        [306.0, 4995.0],
                        [282.0, 4991.0],
                        [299.0, 4946.0],
                        [298.0, 4874.0],
                        [325.0, 4854.0],
                        [339.0, 4807.0],
                        [306.0, 4793.0],
                        [300.0, 4815.0],
                        [247.0, 4812.0],
                        [193.0, 4820.0],
                        [168.0, 4799.0],
                        [157.0, 4816.0],
                        [105.0, 4794.0],
                        [51.0, 4794.0],
                        [-16.0, 4762.0],
                        [-94.0, 4758.0],
                        [-128.0, 4772.0],
                        [-180.0, 4748.0],
                        [-236.0, 4762.0],
                        [-234.0, 4713.0],
                        [-255.0, 4712.0],
                        [-271.0, 4679.0],
                        [-287.0, 4686.0],
                        [-297.0, 4718.0],
                        [-269.0, 4742.0],
                        [-282.0, 4768.0],
                        [-329.0, 4735.0],
                        [-370.0, 4756.0],
                        [-386.0, 4752.0],
                        [-446.0, 4699.0],
                        [-508.0, 4687.0],
                        [-540.0, 4698.0],
                        [-565.0, 4727.0],
                        [-614.0, 4747.0],
                        [-661.0, 4752.0],
                        [-679.0, 4699.0],
                        [-731.0, 4687.0],
                        [-769.0, 4704.0],
                        [-785.0, 4736.0],
                        [-832.0, 4743.0],
                        [-830.0, 4759.0],
                        [-904.0, 4749.0],
                        [-880.0, 4776.0],
                        [-909.0, 4781.0],
                        [-909.0, 4833.0],
                        [-981.0, 4854.0],
                        [-932.0, 4869.0],
                        [-948.0, 4892.0],
                        [-926.0, 4911.0],
                        [-957.0, 4938.0],
                        [-938.0, 4964.0],
                        [-996.0, 4953.0],
                        [-989.0, 4998.0],
                        [-952.0, 5032.0],
                        [-780.0, 5041.0],
                        [-792.0, 5058.0],
                        [-766.0, 5069.0],
                        [-790.0, 5086.0],
                        [-777.0, 5109.0],
                        [-703.0, 5109.0],
                        [-634.0, 5101.0],
                        [-623.0, 5121.0],
                        [-563.0, 5157.0],
                        [-488.0, 5185.0],
                        [-391.0, 5182.0],
                        [-373.0, 5196.0],
                        [-331.0, 5158.0],
                        [-301.0, 5167.0],
                        [-264.0, 5127.0],
                        [-252.0, 5138.0],
                        [-183.0, 5112.0],
                        [-129.0, 5104.0],
                        [-52.0, 5123.0],
                        [-2.0, 5109.0],
                        [87.0, 5151.0],
                        [95.0, 5162.0],
                        [161.0, 5158.0],
                        [187.0, 5171.0],
                        [233.0, 5133.0],
                        [255.0, 5097.0],
                        [252.0, 5050.0],
                        [309.0, 5040.0],
                        [332.0, 5018.0]
                    ]
                ],
                [
                    [
                        [-969.0, 5160.0],
                        [-918.0, 5176.0],
                        [-898.0, 5161.0],
                        [-865.0, 5168.0],
                        [-860.0, 5140.0],
                        [-785.0, 5108.0],
                        [-794.0, 5088.0],
                        [-847.0, 5093.0],
                        [-897.0, 5083.0],
                        [-921.0, 5052.0],
                        [-955.0, 5036.0],
                        [-992.0, 5002.0],
                        [-989.0, 5024.0],
                        [-946.0, 5049.0],
                        [-999.0, 5048.0],
                        [-980.0, 5078.0],
                        [-983.0, 5103.0],
                        [-962.0, 5114.0],
                        [-984.0, 5142.0],
                        [-969.0, 5160.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.440000,
            "hc-middl_1": 0.330000,
            "hc-key": "bn",
            "hc-a2": "BN",
            "name": "Brunei",
            "labelrank": "6",
            "country-ab": "Brunei",
            "subregion": "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "BRN",
            "iso-a2": "BN",
            "woe-id": "23424773",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [5341.0, 2554.0],
                        [5379.0, 2562.0],
                        [5410.0, 2577.0],
                        [5394.0, 2565.0],
                        [5402.0, 2543.0],
                        [5384.0, 2514.0],
                        [5341.0, 2554.0]
                    ]
                ],
                [
                    [
                        [5422.0, 2578.0],
                        [5439.0, 2538.0],
                        [5421.0, 2541.0],
                        [5414.0, 2572.0],
                        [5421.0, 2574.0],
                        [5422.0, 2578.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.350000,
            "hc-middl_1": 0.550000,
            "hc-key": "af",
            "hc-a2": "AF",
            "name": "Afghanistan",
            "labelrank": "3",
            "country-ab": "Afg.",
            "subregion": "Southern Asia",
            "region-wb": "South Asia",
            "iso-a3": "AFG",
            "iso-a2": "AF",
            "woe-id": "23424739",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [2478.0, 4889.0],
                        [2442.0, 4880.0],
                        [2454.0, 4871.0],
                        [2423.0, 4855.0],
                        [2390.0, 4859.0],
                        [2314.0, 4850.0],
                        [2249.0, 4818.0],
                        [2217.0, 4784.0],
                        [2249.0, 4745.0],
                        [2253.0, 4717.0],
                        [2215.0, 4673.0],
                        [2215.0, 4624.0],
                        [2177.0, 4613.0],
                        [2140.0, 4620.0],
                        [2163.0, 4564.0],
                        [2110.0, 4542.0],
                        [2089.0, 4490.0],
                        [2096.0, 4452.0],
                        [2060.0, 4426.0],
                        [2015.0, 4441.0],
                        [1974.0, 4416.0],
                        [1987.0, 4401.0],
                        [1959.0, 4390.0],
                        [1930.0, 4398.0],
                        [1890.0, 4366.0],
                        [1881.0, 4281.0],
                        [1799.0, 4255.0],
                        [1760.0, 4256.0],
                        [1732.0, 4241.0],
                        [1695.0, 4248.0],
                        [1618.0, 4239.0],
                        [1501.0, 4269.0],
                        [1565.0, 4347.0],
                        [1555.0, 4390.0],
                        [1495.0, 4397.0],
                        [1493.0, 4456.0],
                        [1472.0, 4526.0],
                        [1493.0, 4558.0],
                        [1467.0, 4565.0],
                        [1464.0, 4601.0],
                        [1492.0, 4620.0],
                        [1478.0, 4635.0],
                        [1503.0, 4660.0],
                        [1515.0, 4725.0],
                        [1570.0, 4711.0],
                        [1590.0, 4690.0],
                        [1644.0, 4715.0],
                        [1662.0, 4749.0],
                        [1739.0, 4784.0],
                        [1761.0, 4840.0],
                        [1780.0, 4865.0],
                        [1811.0, 4867.0],
                        [1829.0, 4895.0],
                        [1883.0, 4879.0],
                        [1918.0, 4882.0],
                        [1935.0, 4867.0],
                        [1973.0, 4868.0],
                        [1990.0, 4848.0],
                        [2057.0, 4883.0],
                        [2078.0, 4865.0],
                        [2096.0, 4905.0],
                        [2141.0, 4903.0],
                        [2141.0, 4936.0],
                        [2181.0, 4978.0],
                        [2223.0, 4966.0],
                        [2218.0, 4937.0],
                        [2242.0, 4936.0],
                        [2233.0, 4867.0],
                        [2247.0, 4838.0],
                        [2320.0, 4867.0],
                        [2363.0, 4904.0],
                        [2397.0, 4903.0],
                        [2388.0, 4886.0],
                        [2461.0, 4902.0],
                        [2478.0, 4889.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.400000,
            "hc-middl_1": 0.640000,
            "hc-key": "kp",
            "hc-a2": "KP",
            "name": "North Korea",
            "labelrank": "3",
            "country-ab": "N.K.",
            "subregion": "Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "PRK",
            "iso-a2": "KP",
            "woe-id": "23424865",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [6251.0, 5109.0],
                        [6188.0, 5107.0],
                        [6154.0, 5067.0],
                        [6118.0, 5065.0],
                        [6078.0, 5081.0],
                        [6080.0, 5059.0],
                        [6012.0, 5085.0],
                        [6063.0, 5186.0],
                        [6051.0, 5203.0],
                        [5982.0, 5233.0],
                        [5985.0, 5249.0],
                        [6021.0, 5282.0],
                        [6099.0, 5321.0],
                        [6140.0, 5386.0],
                        [6161.0, 5399.0],
                        [6186.0, 5374.0],
                        [6249.0, 5366.0],
                        [6260.0, 5384.0],
                        [6239.0, 5418.0],
                        [6301.0, 5423.0],
                        [6331.0, 5459.0],
                        [6357.0, 5460.0],
                        [6366.0, 5505.0],
                        [6385.0, 5507.0],
                        [6415.0, 5470.0],
                        [6424.0, 5457.0],
                        [6428.0, 5450.0],
                        [6407.0, 5452.0],
                        [6355.0, 5384.0],
                        [6367.0, 5370.0],
                        [6362.0, 5324.0],
                        [6327.0, 5311.0],
                        [6289.0, 5268.0],
                        [6209.0, 5227.0],
                        [6206.0, 5179.0],
                        [6229.0, 5175.0],
                        [6273.0, 5136.0],
                        [6251.0, 5109.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.540000,
            "hc-middl_1": 0.550000,
            "hc-key": "lb",
            "hc-a2": "LB",
            "name": "Lebanon",
            "labelrank": "5",
            "country-ab": "Leb.",
            "subregion": "Western Asia",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "LBN",
            "iso-a2": "LB",
            "woe-id": "23424873",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [-336.0, 4458.0],
                        [-305.0, 4525.0],
                        [-279.0, 4584.0],
                        [-249.0, 4583.0],
                        [-233.0, 4550.0],
                        [-280.0, 4504.0],
                        [-286.0, 4485.0],
                        [-310.0, 4459.0],
                        [-336.0, 4458.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.540000,
            "hc-middl_1": 0.640000,
            "hc-key": "nc",
            "hc-a2": "NC",
            "name": "Northern Cyprus",
            "labelrank": "6",
            "country-ab": "N. Cy.",
            "subregion": "Western Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "-99",
            "iso-a2": "NC",
            "woe-id": "-90",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [-520.0, 4618.0],
                        [-519.0, 4619.0],
                        [-517.0, 4619.0],
                        [-519.0, 4617.0],
                        [-520.0, 4618.0]
                    ]
                ],
                [
                    [
                        [-427.0, 4613.0],
                        [-437.0, 4609.0],
                        [-443.0, 4609.0],
                        [-463.0, 4622.0],
                        [-512.0, 4619.0],
                        [-498.0, 4637.0],
                        [-462.0, 4632.0],
                        [-381.0, 4661.0],
                        [-426.0, 4630.0],
                        [-419.0, 4613.0],
                        [-423.0, 4613.0],
                        [-427.0, 4613.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.410000,
            "hc-middl_1": 0.490000,
            "hc-key": "cy",
            "hc-a2": "CY",
            "name": "Cyprus",
            "labelrank": "5",
            "country-ab": "Cyp.",
            "subregion": "Western Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "CYP",
            "iso-a2": "CY",
            "woe-id": "-90",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [-419.0, 4612.0],
                        [-428.0, 4604.0],
                        [-428.0, 4612.0],
                        [-425.0, 4611.0],
                        [-419.0, 4612.0]
                    ]
                ],
                [
                    [
                        [-521.0, 4618.0],
                        [-518.0, 4616.0],
                        [-516.0, 4619.0],
                        [-514.0, 4619.0],
                        [-504.0, 4610.0],
                        [-462.0, 4619.0],
                        [-441.0, 4606.0],
                        [-473.0, 4581.0],
                        [-532.0, 4584.0],
                        [-542.0, 4611.0],
                        [-521.0, 4618.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.240000,
            "hc-middl_1": 0.760000,
            "hc-key": "tw",
            "hc-a2": "TW",
            "name": "Taiwan",
            "labelrank": "3",
            "country-ab": "Taiwan",
            "subregion": "Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "TWN",
            "iso-a2": "TW",
            "woe-id": "23424971",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [5829.0, 4070.0],
                        [5858.0, 4051.0],
                        [5845.0, 4036.0],
                        [5820.0, 3910.0],
                        [5790.0, 3863.0],
                        [5784.0, 3817.0],
                        [5746.0, 3861.0],
                        [5725.0, 3907.0],
                        [5726.0, 3934.0],
                        [5767.0, 4018.0],
                        [5791.0, 4052.0],
                        [5829.0, 4070.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.400000,
            "hc-middl_1": 0.460000,
            "hc-key": "np",
            "hc-a2": "NP",
            "name": "Nepal",
            "labelrank": "3",
            "country-ab": "Nepal",
            "subregion": "Southern Asia",
            "region-wb": "South Asia",
            "iso-a3": "NPL",
            "iso-a2": "NP",
            "woe-id": "23424911",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [3444.0, 4184.0],
                        [3435.0, 4125.0],
                        [3450.0, 4099.0],
                        [3444.0, 4076.0],
                        [3391.0, 4067.0],
                        [3370.0, 4083.0],
                        [3348.0, 4070.0],
                        [3317.0, 4084.0],
                        [3284.0, 4080.0],
                        [3267.0, 4101.0],
                        [3245.0, 4091.0],
                        [3199.0, 4111.0],
                        [3193.0, 4134.0],
                        [3063.0, 4142.0],
                        [3013.0, 4172.0],
                        [2959.0, 4187.0],
                        [2947.0, 4205.0],
                        [2867.0, 4238.0],
                        [2896.0, 4314.0],
                        [2931.0, 4346.0],
                        [2939.0, 4332.0],
                        [2959.0, 4360.0],
                        [3009.0, 4359.0],
                        [3013.0, 4339.0],
                        [3064.0, 4309.0],
                        [3087.0, 4307.0],
                        [3113.0, 4274.0],
                        [3154.0, 4280.0],
                        [3165.0, 4254.0],
                        [3197.0, 4232.0],
                        [3232.0, 4232.0],
                        [3227.0, 4211.0],
                        [3270.0, 4214.0],
                        [3292.0, 4180.0],
                        [3331.0, 4197.0],
                        [3375.0, 4178.0],
                        [3444.0, 4184.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.460000,
            "hc-middl_1": 0.480000,
            "hc-key": "lk",
            "hc-a2": "LK",
            "name": "Sri Lanka",
            "labelrank": "3",
            "country-ab": "Sri L.",
            "subregion": "Southern Asia",
            "region-wb": "South Asia",
            "iso-a3": "LKA",
            "iso-a2": "LK",
            "woe-id": "23424778",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [2922.0, 2840.0],
                        [2967.0, 2809.0],
                        [3013.0, 2748.0],
                        [3020.0, 2723.0],
                        [3047.0, 2686.0],
                        [3054.0, 2645.0],
                        [3041.0, 2605.0],
                        [3019.0, 2588.0],
                        [2965.0, 2565.0],
                        [2936.0, 2572.0],
                        [2911.0, 2625.0],
                        [2899.0, 2711.0],
                        [2927.0, 2823.0],
                        [2906.0, 2834.0],
                        [2922.0, 2840.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": 0.580000,
            "hc-middl_1": 0.380000,
            "hc-key": "kg",
            "hc-a2": "KG",
            "name": "Kyrgyzstan",
            "labelrank": "4",
            "country-ab": "Kgz.",
            "subregion": "Central Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "KGZ",
            "iso-a2": "KG",
            "woe-id": "23424864",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [2184.0, 5298.0],
                        [2187.0, 5325.0],
                        [2214.0, 5346.0],
                        [2246.0, 5350.0],
                        [2365.0, 5319.0],
                        [2357.0, 5333.0],
                        [2372.0, 5374.0],
                        [2410.0, 5393.0],
                        [2482.0, 5360.0],
                        [2524.0, 5368.0],
                        [2718.0, 5370.0],
                        [2764.0, 5364.0],
                        [2785.0, 5338.0],
                        [2820.0, 5335.0],
                        [2842.0, 5316.0],
                        [2840.0, 5301.0],
                        [2778.0, 5279.0],
                        [2713.0, 5242.0],
                        [2693.0, 5213.0],
                        [2601.0, 5202.0],
                        [2592.0, 5175.0],
                        [2526.0, 5144.0],
                        [2518.0, 5171.0],
                        [2490.0, 5156.0],
                        [2465.0, 5161.0],
                        [2433.0, 5125.0],
                        [2407.0, 5121.0],
                        [2403.0, 5081.0],
                        [2382.0, 5069.0],
                        [2347.0, 5060.0],
                        [2270.0, 5058.0],
                        [2248.0, 5050.0],
                        [2228.0, 5077.0],
                        [2174.0, 5059.0],
                        [2139.0, 5067.0],
                        [2075.0, 5064.0],
                        [2074.0, 5103.0],
                        [2120.0, 5123.0],
                        [2160.0, 5110.0],
                        [2190.0, 5128.0],
                        [2210.0, 5136.0],
                        [2241.0, 5122.0],
                        [2288.0, 5162.0],
                        [2305.0, 5155.0],
                        [2342.0, 5179.0],
                        [2274.0, 5195.0],
                        [2243.0, 5232.0],
                        [2203.0, 5202.0],
                        [2130.0, 5239.0],
                        [2205.0, 5294.0],
                        [2184.0, 5298.0]
                    ],
                    [
                        [2167.0, 5095.0],
                        [2157.0, 5096.0],
                        [2165.0, 5088.0],
                        [2173.0, 5093.0],
                        [2167.0, 5095.0]
                    ],
                    [
                        [2248.0, 5102.0],
                        [2250.0, 5108.0],
                        [2248.0, 5109.0],
                        [2241.0, 5105.0],
                        [2248.0, 5102.0]
                    ],
                    [
                        [2206.0, 5112.0],
                        [2192.0, 5120.0],
                        [2198.0, 5105.0],
                        [2209.0, 5099.0],
                        [2206.0, 5112.0]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": null,
            "hc-middl_1": null,
            "hc-key": "hk",
            "hc-a2": "HK",
            "name": "Hong Kong SAR China",
            "labelrank": "2ULL",
            "country-ab": "Hong Kong SAR China",
            "subregion": "China",
            "region-wb": "South east Asia",
            "iso-a3": "HKG",
            "iso-a2": "HK",
            "woe-id": "24865698",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [5288.936993696356694, 3837.150296740882823],
                        [5280.485498256442952, 3855.625658865346395],
                        [5298.469494366957406, 3875.08375301770684],
                        [5314.684572827257398, 3854.151560823500859],
                        [5316.846583288631336, 3840.196766027363537],
                        [5288.936993696356694, 3837.150296740882823]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": null,
            "hc-middl_1": null,
            "hc-key": "mo",
            "hc-a2": "MO",
            "name": "Macao SAR China",
            "labelrank": "2",
            "country-ab": "Macao SAR China",
            "subregion": "South-Eastern Asia",
            "region-wb": "South Asia",
            "iso-a3": "MAC",
            "iso-a2": "MO",
            "woe-id": "20070017",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [5266.134790743926715, 3824.225079396278943],
                        [5253.913946949091041, 3834.277708969450032],
                        [5253.125505413940118, 3846.892773531861167],
                        [5273.427874944070027, 3850.637870823826688],
                        [5266.134790743926715, 3824.225079396278943]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "hc-group": "admin0",
            "hc-middle-": null,
            "hc-middl_1": null,
            "hc-key": "ps",
            "hc-a2": "PS",
            "name": "Palestine",
            "labelrank": "2",
            "country-ab": "Pale.",
            "subregion": "Western Asia",
            "region-wb":  "Middle East & North Africa",
            "iso-a3": "PSE",
            "iso-a2": "PS",
            "woe-id": "20068265",
            "continent": "Asia"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [-301.639051842602385, 4408.58669520460262],
                        [-299.639358911605655, 4355.394863240089762],
                        [-310.837639325187297, 4334.598056757724407],
                        [-346.432173496929011, 4396.988476204822291],
                        [-301.639051842602385, 4408.58669520460262]
                    ],
                    [
                        [-378.427260392876576, 4341.996920602411592],
                        [-376.027628875680477, 4338.797411912817552],
                        [-393.624926668451678, 4315.600973913255075],
                        [-396.02455818564772, 4316.400851085653812],
                        [-378.427260392876576, 4341.996920602411592]
                    ]
                ]
            ]
        }
    }]
}